document.addEventListener('DOMContentLoaded', function () {
  
  // WIM Promo Facets Filter
  window.wimFilterPromoFacets = function () {
    const storeCode = (window.WIM_CART_ATTRIBUTES && window.WIM_CART_ATTRIBUTES.store_code) || '';
    let localStoreCode = '';
    if (!storeCode) {
      const cp = localStorage.getItem('wim_postal_code');
      if (cp && window.FoxTheme && window.FoxTheme.cpStoreMapping) {
        const store = window.FoxTheme.cpStoreMapping.find(s => s.pcs && s.pcs.includes(cp));
        if (store) localStoreCode = store.sc;
      }
    }
    const currentStoreCode = storeCode || localStoreCode;
    
    // Sanitize URL params if they contain invalid store promo filters
    try {
      const urlParams = new URLSearchParams(window.location.search);
      let hasInvalidPromo = false;
      const key = 'filter.p.m.dsp.promo_list';
      if (urlParams.has(key)) {
        const values = urlParams.getAll(key);
        const newValues = values.filter(val => {
          const parts = val.split(':');
          if (parts.length >= 2) {
            const code = parts[0].trim();
            if (code === currentStoreCode || code.toLowerCase() === 'all') {
              return true;
            }
            hasInvalidPromo = true;
            return false;
          }
          return true;
        });
        
        if (hasInvalidPromo) {
          urlParams.delete(key);
          newValues.forEach(val => urlParams.append(key, val));
          const newSearch = urlParams.toString();
          window.location.href = window.location.pathname + (newSearch ? '?' + newSearch : '');
          return;
        }
      }
    } catch (e) {
      console.error('Error sanitizing promo filters in URL:', e);
    }
    
    // Handle sidebar/drawer facet checkboxes
    const promoInputs = document.querySelectorAll('input[name="filter.p.m.dsp.promo_list"]');
    promoInputs.forEach(input => {
      const value = input.value;
      const parts = value.split(':');
      if (parts.length >= 2) {
        const code = parts[0].trim();
        let promoName = parts.slice(1).join(':').trim();
        if (/\d+,\d{2}$/.test(promoName) && !promoName.includes('€') && !promoName.includes('%')) {
          promoName = promoName + '€';
        }
        
        const li = input.closest('li');
        if (li) {
          if (code === currentStoreCode || code.toLowerCase() === 'all') {
            li.style.display = '';
            const textSpan = li.querySelector('.reversed-link__text');
            if (textSpan) {
              textSpan.textContent = promoName;
              textSpan.dataset.promoUpdated = "true";
            }
          } else {
            li.style.display = 'none';
          }
        }
      }
    });
    
    // Handle active pills
    const activePromoFacets = document.querySelectorAll('.facet-remove[data-filter-param="filter.p.m.dsp.promo_list"], .facet-remove[href*="filter.p.m.dsp.promo_list"]');
    activePromoFacets.forEach(pill => {
      const titleDiv = pill.querySelector('.facet-title');
      if (titleDiv) {
        const text = titleDiv.textContent.trim();
        const parts = text.split(':');
        if (parts.length >= 2) {
          let promoName = parts.slice(1).join(':').trim();
          if (/\d+,\d{2}$/.test(promoName) && !promoName.includes('€') && !promoName.includes('%')) {
            promoName = promoName + '€';
          }
          titleDiv.textContent = promoName;
          titleDiv.dataset.promoUpdated = "true";
        }
      }
    });
  };
  
  window.wimFilterPromoFacets();
  document.addEventListener('collection:rerendered', window.wimFilterPromoFacets);
  
  // MutationObserver to ensure promo facets are always formatted and filtered on DOM changes
  if (window.MutationObserver) {
    let promoTimeout = null;
    const observer = new MutationObserver((mutations) => {
      let shouldRun = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          shouldRun = true;
          break;
        }
      }
      if (shouldRun) {
        if (promoTimeout) clearTimeout(promoTimeout);
        promoTimeout = setTimeout(() => {
          window.wimFilterPromoFacets();
        }, 50);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  window.wimInitProductScripts(document);
  
  
  document.addEventListener('click', async function (e) {
    // 1. Validación de clic en checkout
    if (e.target.id === 'wim-validate-checkout' || e.target.closest('#wim-validate-checkout')) {
      e.preventDefault();
      const cartDrawer = document.querySelector('.wim-cart-drawer');
      const mainCart = document.querySelector('.wim-main-cart');
      const isFishFresh = (cartDrawer?.getAttribute('data-fish-fresh') === 'true') || (mainCart?.getAttribute('data-fish-fresh') === 'true') || !!document.querySelector('.cart-item[data-fish-fresh="true"]');
      const cartItems = Array.from(document.querySelectorAll('.cart-item[data-shipping-days]')) || null;
      let dataShippingdays = {
        allDays: [],
        byTitle: []
      };
      if (cartItems) {
        dataShippingdays = cartItems.reduce( (prev_item, current_item) => {
          
          const title = current_item.getAttribute('data-title');
          let shippingDaysStr = current_item.getAttribute('data-shipping-days') ?? '';
          if( shippingDaysStr !== '' ) {
            shippingDaysStr = shippingDaysStr.split(',');
            for (const dayStr of shippingDaysStr) {
              const day = parseInt(dayStr);
              if (!isNaN(day) && prev_item.allDays.includes(day) === false) {
                prev_item.allDays.push(day);
              }
            }
            prev_item.byTitle.push({
              title: title,
              shippingDays: shippingDaysStr.map(dayStr => parseInt(dayStr)).filter(day => !isNaN(day))
            })
          }
          return prev_item;
        }, dataShippingdays); 
      }
      
      // Fetch the latest cart from Shopify to avoid database propagation/cache delays
      let shipping_option = null;
      let acum_quantity_water = 0;
      try {
        const res = await fetch(`${FoxTheme.routes.cart_url}.js?t=${Date.now()}`, { cache: 'no-store' });
        const cartData = await res.json();
        shipping_option = cartData?.attributes?.ShippingOptionSelect || null;
        acum_quantity_water = cartData?.items?.reduce((sum, item) => {
          const isWater = item?.properties?._quantity_water || 0;
          return sum + ((isWater ? parseFloat(isWater) : 0) * item.quantity);
        }, 0);
      } catch (err) {
        console.error("Error fetching latest cart:", err);
      }
      
      let parsedOption = null;
      try {
        if (shipping_option && shipping_option !== "") {
          parsedOption = JSON.parse(shipping_option);
          if (typeof parsedOption === 'string') {
            parsedOption = JSON.parse(parsedOption);
          }
        }
      } catch (err) {
        console.error("Error parsing shipping_option:", err);
      }
      
      if (parsedOption == null) {
        document.querySelector('.location-popup').setAttribute('data-wim-checkout', 'true');
        document.querySelector('.header__location-button').click();
      }
      else {
        let isMonday = false;
        let shippingDay = null;
        if (parsedOption && parsedOption.start) {
          const startDate = parsedOption.start.split('T')[0];
          const dateObj = new Date(startDate + 'T00:00:01');
          shippingDay = dateObj.getDay();
          isMonday = shippingDay === 1;
        }
        console.log( dataShippingdays, shippingDay );
        
        if (isFishFresh && isMonday && dataShippingdays.allDays.length == 0) {
          const modal = document.getElementById('wim-fish-fresh-modal');
          if (modal) {
            if (typeof modal.show === 'function') {
              modal.show();
            } else {
              modal.removeAttribute('hidden');
              modal.classList.remove('hidden');
            }
            const cartDrawerEl = document.getElementById('CartDrawer');
            if (cartDrawerEl) {
              if (typeof cartDrawerEl.hide === 'function') {
                cartDrawerEl.hide();
              } else if (typeof cartDrawerEl.close === 'function') {
                cartDrawerEl.close();
              } else {
                const closeBtn = cartDrawerEl.querySelector('.drawer__close-btn[aria-controls="CartDrawer"]') || cartDrawerEl.querySelector('.drawer__close-btn');
                if (closeBtn) closeBtn.click();
              }
            }
          }
        }
        else if (acum_quantity_water > FoxTheme.maxQuantityWater) {
          const modal = document.getElementById('wim-water-modal');
          if (modal) {
            if (typeof modal.show === 'function') {
              modal.show();
            } else {
              modal.removeAttribute('hidden');
              modal.classList.remove('hidden');
            }
            const cartDrawerEl = document.getElementById('CartDrawer');
            if (cartDrawerEl) {
              if (typeof cartDrawerEl.hide === 'function') {
                cartDrawerEl.hide();
              } else if (typeof cartDrawerEl.close === 'function') {
                cartDrawerEl.close();
              } else {
                const closeBtn = cartDrawerEl.querySelector('.drawer__close-btn[aria-controls="CartDrawer"]') || cartDrawerEl.querySelector('.drawer__close-btn');
                if (closeBtn) closeBtn.click();
              }
            }
          }
        }
        else if (dataShippingdays.allDays.length > 0 && shippingDay != null && !dataShippingdays.allDays.includes(shippingDay)) {
          const modal = document.getElementById('wim-shipping-days-modal');
          if (modal) {
            modal.querySelector(".wim-modal__title").textContent = modal.querySelector(".wim-modal__title").textContent.replace("[days]", dataShippingdays.allDays.map(item => {
              return item == 0 ? 7 : item;
            }).reverse().reduce( (prev_item, current_item, current_index) => {
              if( current_item == 1 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Lunes` : "Lunes";
              if( current_item == 2 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Martes` : "Martes";
              if( current_item == 3 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Miércoles` : "Miércoles";
              if( current_item == 4 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Jueves` : "Jueves";
              if( current_item == 5 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Viernes` : "Viernes";
              if( current_item == 6 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Sábado` : "Sábado";
              if( current_item == 7 ) return prev_item ? prev_item + `${ current_index === dataShippingdays.allDays.length - 1 ? ' y ' : ', ' } Domingo` : "Domingo";
              return prev_item;
            }, ""));
            modal.querySelector(".wim-modal__description").textContent = modal.querySelector(".wim-modal__description").textContent.replace("[products]", dataShippingdays.byTitle.filter((item) => {
              return item.shippingDays.includes(shippingDay) === false;
            }).map(item => item.title).join(", "));
            
            if (typeof modal.show === 'function') {
              modal.show();
            } else {
              modal.removeAttribute('hidden');
              modal.classList.remove('hidden');
            }
            const cartDrawerEl = document.getElementById('CartDrawer');
            if (cartDrawerEl) {
              if (typeof cartDrawerEl.hide === 'function') {
                cartDrawerEl.hide();
              } else if (typeof cartDrawerEl.close === 'function') {
                cartDrawerEl.close();
              } else {
                const closeBtn = cartDrawerEl.querySelector('.drawer__close-btn[aria-controls="CartDrawer"]') || cartDrawerEl.querySelector('.drawer__close-btn');
                if (closeBtn) closeBtn.click();
              }
            }
          }
        }
        else {
          document.querySelector('#wim-cart-form button[type="submit"]').click();
        }
      }
    }
    
    // 2. Cerrar Modal (fallback si es necesario)
    if (e.target.closest('.wim-modal__close') || e.target.classList.contains('wim-modal__overlay')) {
      const modal = e.target.closest('.wim-modal');
      if (modal) {
        if (typeof modal.hide === 'function') modal.hide();
        else modal.classList.add('hidden');
      }
    }
    
    // 3. Acción 1: Eliminar pescado fresco
    if (e.target.closest('.wim-btn-remove-fish')) {
      const btn = e.target.closest('.wim-btn-remove-fish');
      btn.classList.add('btn--loading');
      btn.disabled = true;
      const updates = {};
      document.querySelectorAll('.cart-item[data-fish-fresh="true"]').forEach(el => {
        const key = el.getAttribute('data-key');
        if (key) {
          updates[key] = 0;
        }
      });
      
      const sections = [];
      document.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
      
      fetch(window.FoxTheme.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections,
          sections_url: window.location.pathname
        })
      }).then(r => r.json()).then(cart => {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
        const modal = document.getElementById('wim-fish-fresh-modal');
        if (modal) {
          if (typeof modal.hide === 'function') modal.hide();
          else modal.classList.add('hidden');
        }
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      }).catch(err => {
        console.error("Error removing fresh fish:", err);
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
    }
    // 3. Acción 1: Eliminar Productos por Shipping days
    if (e.target.closest('.wim-btn-remove-products')) {
      const btn = e.target.closest('.wim-btn-remove-products');
      btn.classList.add('btn--loading');
      btn.disabled = true;
      const updates = {};
      document.querySelectorAll('.cart-item[data-shipping-days]').forEach(el => {
        const key = el.getAttribute('data-key');
        if (key && el.getAttribute('data-shipping-days') !== "") {
          updates[key] = 0;
        }
      });
      
      const sections = [];
      document.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
      
      fetch(window.FoxTheme.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections,
          sections_url: window.location.pathname
        })
      }).then(r => r.json()).then(cart => {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
        const modal = document.getElementById('wim-shipping-days-modal');
        if (modal) {
          if (typeof modal.hide === 'function') modal.hide();
          else modal.classList.add('hidden');
        }
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      }).catch(err => {
        console.error("Error removing shipping days products:", err);
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
    }
    
    // 4. Acción 2: Cambiar fecha de entrega (abrir selector)
    if (e.target.closest('.wim-btn-change-date') || e.target.closest('.wim-btn-change-date-tuesday')) {
      let modal = document.getElementById('wim-fish-fresh-modal');
      if (modal) {
        if (typeof modal.hide === 'function') modal.hide();
        else modal.classList.add('hidden');
      }
      modal = document.getElementById('wim-shipping-days-modal');
      if (modal) {
        if (typeof modal.hide === 'function') modal.hide();
        else modal.classList.add('hidden');
      }
      document.querySelector('.location-popup').setAttribute('data-wim-checkout', 'true');
      const locationBtn = document.querySelector('.header__location-button');
      if (locationBtn) {
        locationBtn.click();
      }
    }
    if (e.target.closest('.wim-btn-change-water')) {
      const modal = document.getElementById('wim-water-modal');
      if (modal) {
        if (typeof modal.hide === 'function') modal.hide();
        else modal.classList.add('hidden');
      }
      const cartDrawerEl = document.getElementById('CartDrawer');
      if (cartDrawerEl) {
        cartDrawerEl.show();
      }
    }
    
    // 4.1 Cerrar CartDrawer si se hace clic en su botón de cerrar o en el overlay
    const cartCloseBtn = e.target.closest('.wim-cart-drawer .drawer__close-btn, .cart-drawer .drawer__close-btn, [aria-controls="CartDrawer"].drawer__close-btn, .wim-cart-drawer .fixed-overlay');
    if (cartCloseBtn) {
      e.preventDefault();
      const cartDrawerEl = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        if (typeof cartDrawerEl.hide === 'function') {
          cartDrawerEl.hide();
        } else if (typeof cartDrawerEl.close === 'function') {
          cartDrawerEl.close();
        } else {
          cartDrawerEl.removeAttribute('open');
          cartDrawerEl.setAttribute('hidden', '');
        }
      }
    }
    
    // 5. Acción: Abrir modal vaciar carrito
    if (e.target.closest('#wim-clear-cart') || e.target.closest('.wim-btn-clear-cart') || e.target.closest('.js-wim-clear-cart-btn')) {
      e.preventDefault();
      const modal = document.getElementById('wim-clear-cart-modal');
      if (modal) {
        if (typeof modal.show === 'function') modal.show();
        else modal.removeAttribute('hidden');
      }
    }
    
    // 6. Acción: Confirmar vaciar carrito
    if (e.target.closest('#wim-confirm-clear-cart') || e.target.closest('.wim-btn-confirm-clear')) {
      e.preventDefault();
      const btn = e.target.closest('#wim-confirm-clear-cart') || e.target.closest('.wim-btn-confirm-clear');
      if (btn) {
        btn.classList.add('btn--loading');
        btn.disabled = true;
      }
      
      // Recoger qué secciones necesitan actualizarse
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
      // Garantizar que siempre tenemos al menos el cart-drawer
      if (!sections.length) {
        const cartDrawerEl = document.getElementById('CartDrawer');
        if (cartDrawerEl && cartDrawerEl.dataset.sectionId) {
          sections.push(cartDrawerEl.dataset.sectionId);
        }
      }
      
      const sectionsParam = sections.join(',');
      const rootUrl = window.FoxTheme?.routes?.root_url || '/';
      
      // 1. Vaciar carrito
      fetch(`${rootUrl}cart/clear.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(() => {
        // 2. POST a /cart/update.js con sections para obtener el HTML actualizado
        // Shopify solo devuelve secciones en este endpoint. El carrito ya está vacío
        // así que enviamos updates vacíos pero pedimos las secciones.
        const body = { updates: {}, sections: sectionsParam, sections_url: window.location.pathname };
        return fetch(`${rootUrl}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        });
      })
      .then(r => r.json())
      .then((parsedState) => {
        // Obtenemos el estado del carrito (ya vacío) y asociamos las secciones renderizadas
        if (btn) {
          btn.classList.remove('btn--loading');
          btn.disabled = false;
        }
        const modal = document.getElementById('wim-clear-cart-modal');
        if (modal) {
          if (typeof modal.hide === 'function') modal.hide();
          else modal.setAttribute('hidden', '');
        }
        // Publicar el evento de actualización del carrito con el HTML de las secciones
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
      })
      .catch(err => {
        console.error('Error clearing cart:', err);
        if (btn) {
          btn.classList.remove('btn--loading');
          btn.disabled = false;
        }
      });
    }
    
    // 7. Acción: Cancelar vaciar carrito
    if (e.target.closest('.wim-btn-cancel-clear')) {
      e.preventDefault();
      const modal = document.getElementById('wim-clear-cart-modal');
      if (modal) {
        if (typeof modal.hide === 'function') modal.hide();
        else modal.setAttribute('hidden', '');
      }
    }
  });
  
  const recoverEmailInput = document.getElementById('RecoverEmail');
  if (recoverEmailInput) {
    const recoverForm = recoverEmailInput.closest('form');
    recoverForm.setAttribute('novalidate', '');
    const recoverEmailError = document.getElementById('recover_email_error');
    
    recoverEmailInput.addEventListener('input', function () {
      recoverEmailError.style.display = 'none';
      recoverEmailInput.classList.remove('form-control--error');
      recoverEmailInput.removeAttribute('aria-invalid');
    });
    
    recoverForm.addEventListener('submit', function (e) {
      if (!recoverEmailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recoverEmailInput.value.trim())) {
        recoverEmailError.style.display = 'block';
        recoverEmailInput.classList.add('form-control--error');
        recoverEmailInput.setAttribute('aria-invalid', 'true');
        recoverEmailInput.focus();
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      const btn = recoverForm.querySelector('button[type="submit"], button.btn');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('btn--loading');
      }
    });
  }
  
  const loginEmailInput = document.getElementById('CustomerEmail');
  const loginPasswordInput = document.getElementById('CustomerPassword');
  if (loginEmailInput) {
    const loginForm = loginEmailInput.closest('form');
    loginForm.setAttribute('novalidate', '');
    const emailError = document.getElementById('login_email_error');
    const passwordError = document.getElementById('login_password_error');
    
    loginEmailInput.addEventListener('input', function () {
      emailError.style.display = 'none';
      loginEmailInput.classList.remove('form-control--error');
      loginEmailInput.removeAttribute('aria-invalid');
    });
    if (loginPasswordInput) {
      loginPasswordInput.addEventListener('input', function () {
        passwordError.style.display = 'none';
        loginPasswordInput.classList.remove('form-control--error');
        loginPasswordInput.removeAttribute('aria-invalid');
      });
    }
    
    loginForm.addEventListener('submit', function (e) {
      let valid = true;
      if (!loginEmailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginEmailInput.value.trim())) {
        emailError.style.display = 'block';
        loginEmailInput.classList.add('form-control--error');
        loginEmailInput.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      if (loginPasswordInput && !loginPasswordInput.value) {
        passwordError.style.display = 'block';
        loginPasswordInput.classList.add('form-control--error');
        loginPasswordInput.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      if (!valid) {
        const firstError = loginForm.querySelector('.form-control--error');
        if (firstError) firstError.focus();
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      const btn = loginForm.querySelector('button[type="submit"], button.btn');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('btn--loading');
      }
    });
  }
  
  const registerFirstName = document.getElementById('RegisterForm-FirstName');
  if (registerFirstName) {
    const registerForm = registerFirstName.closest('form');
    registerForm.setAttribute('novalidate', '');
    
    const registerLastName = document.getElementById('RegisterForm-LastName');
    const registerPhone = document.getElementById('RegisterForm-phone');
    const registerEmail = document.getElementById('RegisterForm-email');
    const registerPassword = document.getElementById('RegisterForm-password');
    const registerGdpr = document.getElementById('accepts_gdpr');
    
    const firstNameError = document.getElementById('register_firstname_error');
    const lastNameError = document.getElementById('register_lastname_error');
    const phoneError = document.getElementById('register_phone_error');
    const emailError = document.getElementById('register_email_error');
    const passwordError = document.getElementById('register_password_error');
    const gdprError = document.getElementById('register_gdpr_error');
    
    function clearError(input, errorEl) {
      if (!errorEl) return;
      errorEl.style.display = 'none';
      input.classList.remove('form-control--error');
      input.removeAttribute('aria-invalid');
    }
    
    registerFirstName.addEventListener('input', function () { clearError(registerFirstName, firstNameError); });
    if (registerLastName) registerLastName.addEventListener('input', function () { clearError(registerLastName, lastNameError); });
    if (registerPhone) registerPhone.addEventListener('input', function () { clearError(registerPhone, phoneError); });
    if (registerEmail) registerEmail.addEventListener('input', function () { clearError(registerEmail, emailError); });
    if (registerPassword) registerPassword.addEventListener('input', function () { clearError(registerPassword, passwordError); });
    if (registerGdpr) registerGdpr.addEventListener('change', function () { clearError(registerGdpr, gdprError); });
    
    registerForm.addEventListener('submit', function (e) {
      let valid = true;
      
      if (!registerFirstName.value.trim()) {
        firstNameError.style.display = 'block';
        registerFirstName.classList.add('form-control--error');
        registerFirstName.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      if (registerLastName && !registerLastName.value.trim()) {
        lastNameError.style.display = 'block';
        registerLastName.classList.add('form-control--error');
        registerLastName.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      if (registerPhone && !registerPhone.value.trim()) {
        if (phoneError) phoneError.style.display = 'block';
        registerPhone.classList.add('form-control--error');
        registerPhone.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      if (!registerEmail || !registerEmail.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(registerEmail.value.trim())) {
        if (emailError) emailError.style.display = 'block';
        if (registerEmail) {
          registerEmail.classList.add('form-control--error');
          registerEmail.setAttribute('aria-invalid', 'true');
        }
        valid = false;
      }
      if (!registerPassword || !registerPassword.value) {
        if (passwordError) passwordError.style.display = 'block';
        if (registerPassword) {
          registerPassword.classList.add('form-control--error');
          registerPassword.setAttribute('aria-invalid', 'true');
        }
        valid = false;
      }
      if (registerGdpr && !registerGdpr.checked) {
        if (gdprError) gdprError.style.display = 'block';
        registerGdpr.classList.add('form-control--error');
        registerGdpr.setAttribute('aria-invalid', 'true');
        valid = false;
      }
      
      if (!valid) {
        const firstError = registerForm.querySelector('.form-control--error');
        if (firstError) firstError.focus();
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      const btn = registerForm.querySelector('button[type="submit"], button.btn');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('btn--loading');
      }
    });
  }
  
  const otherAuthForms = document.querySelectorAll('form[action*="/account/reset"], form[action*="/account/activate"]');
  otherAuthForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const btn = form.querySelector('button[type="submit"], button.btn');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('btn--loading');
      }
    });
  });
});

// ---------------------------------------------------------------------------
// Wishlist re-inicialización para elementos añadidos dinámicamente al DOM
// ---------------------------------------------------------------------------
// La app Simple Wishlist enlaza listeners a los .wishlist-element existentes
// en el momento de su init. Cualquier .wishlist-element insertado después
// (p.ej. por product-recommendations.js o facets.js) queda sin enlazar.

var COOKIE_KEY = 'shopify_wishlist';
var EXPIRATION_DAYS = 30;

function wimGetWishlist() {
  var match = document.cookie.split('; ').find(function (c) { return c.startsWith(COOKIE_KEY + '='); });
  return match ? match.split('=')[1].split(',').filter(Boolean) : [];
}

function wimSaveWishlist(list) {
  if (list.length) {
    var exp = new Date(Date.now() + EXPIRATION_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_KEY + '=' + list.join(',') + '; expires=' + exp + '; path=/';
  } else {
    document.cookie = COOKIE_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
}

/* Delegación global de clic para elementos de Wishlist (PLP y PDP) usando fase de captura (true) */
document.addEventListener('click', function (e) {
  var el = e.target.closest('.wishlist-element, .wishlist-element-product, .wim-pdp-wishlist');
  if (!el) return;
  
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
  
  var handle = el.getAttribute('handler') || el.getAttribute('data-handle');
  var variantId = el.getAttribute('data-variant-id') || 0;
  var type = el.getAttribute('data-type') || 'p';
  
  if (!handle) return;
  
  var card = el.closest('.wim-product-card, .product-card, .product-card-wrapper, .card, .card--product');
  var imgEl = null;
  if (card) {
    /* Buscar la primera imagen visible dentro de la tarjeta */
    imgEl = card.querySelector('img[src]:not([src=""])')
    || card.querySelector('.wim-product-card__image, .product-card__image, .card__media img, .media img, img');
  }
  if (!imgEl) {
    /* Fallback PDP: imagen principal del producto */
    imgEl = document.querySelector('.product__media img[src], .product-media__image[src], .media--product img[src]');
  }
  var imgUrl = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
  
  if (window.WimWishlists && window.WimWishlists.openPicker) {
    window.WimWishlists.openPicker(handle, parseInt(variantId, 10), type, imgUrl);
  } else {
    /* Fallback ultra-básico por si WimWishlists no ha cargado */
    var list = wimGetWishlist();
    var idx = list.indexOf(handle);
    var wasAdded = (idx === -1);
    if (wasAdded) list.push(handle);
    else list.splice(idx, 1);
    wimSaveWishlist(list);
    el.classList.toggle('active', wasAdded);
    document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', { detail: { wishlist: list, wasAdded: wasAdded } }));
  }
}, true);

window.wimSetupWishlistElements = function () {
  if (window.WimWishlists && window.WimWishlists.refreshHeartStates) {
    window.WimWishlists.refreshHeartStates();
  }
};
window.wimSetupPdpWishlist = window.wimSetupWishlistElements;

// MutationObserver: detecta nuevos elementos tras filtros o carga AJAX
var debounceTimer = null;
var observer = new MutationObserver(function (mutations) {
  for (var i = 0; i < mutations.length; i++) {
    for (var j = 0; j < mutations[i].addedNodes.length; j++) {
      var node = mutations[i].addedNodes[j];
      if (!(node instanceof HTMLElement)) continue;
      if (node.classList.contains('wishlist-element') || node.querySelector('.wishlist-element')) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(window.wimSetupWishlistElements, 100);
        return;
      }
    }
  }
});

// Limpieza automática: elimina de listas handles de productos que ya no existen (404)
const wimCleanWishlist = () => {
  // Primero sacamos todos los handles únicos, logueado o no
  let handlesToCheck = [];
  
  if (window.WimWishlists) {
    const lists = window.WimWishlists.getLists();
    lists.forEach(l => l.items.forEach(i => {
      // Los items que llegaron del metafield y aún no tienen handle resuelto
      // (ver resolvePendingHandles en la sección WIM WISHLISTS CORE) se
      // ignoran aquí: NO son "productos que ya no existen", simplemente
      // todavía no sabemos su handle. Validarlos como si `i.h` fuera un
      // handle real (cuando en realidad puede ser el ID numérico sin
      // resolver) es lo que provocaba que se vaciara la wishlist entera.
      if (i.h && !handlesToCheck.includes(i.h)) handlesToCheck.push(i.h);
    }));
  } else {
    handlesToCheck = wimGetWishlist();
  }
  
  if (!handlesToCheck.length) return;
  
  const invalidHandles = [];
  let pending = handlesToCheck.length;
  
  handlesToCheck.forEach(handle => {
    // Si el 'handle' es puramente numérico, probablemente sea un variant ID. No lo validamos como handle.
    if (/^\d+$/.test(handle)) {
      pending--;
      if (pending === 0 && invalidHandles.length > 0) {
        cleanInvalidHandles(invalidHandles);
      }
      return;
    }
    
    fetch(`/products/${handle}.js`, { method: 'HEAD' }).then(res => {
      if (!res.ok) {
        invalidHandles.push(handle);
      }
    }).catch(() => {
      invalidHandles.push(handle);
    }).finally(() => {
      pending--;
      if (pending === 0 && invalidHandles.length > 0) {
        cleanInvalidHandles(invalidHandles);
      }
    });
  });
  
  function cleanInvalidHandles(invalidHandles) {
    if (window.WimWishlists) {
      // Removemos de las listas estructuradas
      const lists = window.WimWishlists.getLists();
      lists.forEach((l, idx) => {
        invalidHandles.forEach(invH => {
          window.WimWishlists.removeItem(idx, invH);
        });
      });
      if (window.WimWishlists.isDirty()) {
        window.WimWishlists.save();
      }
    } else {
      // Removemos de cookie
      const currentList = wimGetWishlist();
      const newList = currentList.filter(h => !invalidHandles.includes(h));
      wimSaveWishlist(newList);
    }
    
    console.log(`WIM: Wishlist cleaned, removed ${invalidHandles.length} stale product(s)`);
    if (window.location.pathname.includes('/pages/wishlists')) {
      window.location.reload();
    }
  }
};

// Una vez que resolvePendingHandles() consigue el handle real de items que
// llegaron del metafield solo con su ID, volvemos a validar por si alguno
// de ellos sí corresponde a un producto eliminado/despublicado.
document.addEventListener('wim-wishlists:handles-resolved', wimCleanWishlist);

document.addEventListener('DOMContentLoaded', function () {
  const refreshIfDateChanged = () => {
    try {
      const currentNow = window.FoxTheme?.utils?.getDate?.();
      if (!currentNow) return;
      
      const currentDate = currentNow.slice(0, 10);
      const lastNow = localStorage.getItem('last_now');
      const lastDate = lastNow ? lastNow.slice(0, 10) : '';
      
      if (!lastDate) {
        localStorage.setItem('last_now', currentNow);
        return;
      }
      
      if (lastDate !== currentDate) {
        localStorage.setItem('last_now', currentNow);
        window.location.reload();
      }
    } catch (error) {
      console.warn('WIM: No se pudo comprobar el cambio de fecha:', error);
    }
  };
  window.setInterval(refreshIfDateChanged, 5 * 60000);
  
  console.log('WIM: Wishlist initialized');
  window.wimSetupWishlistElements();
  window.wimSetupPdpWishlist();
  observer.observe(document.body, { childList: true, subtree: true });
  wimCleanWishlist();
  
  // Redirigir al usuario a /pages/home al hacer logout
  document.addEventListener('click', function (event) {
    const logoutLink = event.target.closest('a[href*="/account/logout"]');
    if (logoutLink) {
      event.preventDefault();
      let redirected = false;
      const redirectToHome = function () {
        if (!redirected) {
          redirected = true;
          window.location.href = '/pages/home';
        }
      };
      
      // Safety timeout of 1.5s in case fetch hangs
      setTimeout(redirectToHome, 1500);
      
      fetch(logoutLink.href).then(redirectToHome).catch(redirectToHome);
    }
  });
});

class WimSubcollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.page = 1;
    this.url = this.dataset.url;
    this.loading = false;
  }
  
  connectedCallback() {
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this.loadProducts.bind(this));
    }
    
    // Si el layout es infinite (Scroll Infinito), cargamos automáticamente al entrar en el viewport
    if (this.dataset.layout === 'infinite') {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading) {
            this.loadProducts();
          }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
  }
  
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  
  async loadProducts() {
    if (this.loading) return;
    this.loading = true;
    if (this.button) {
      this.button.classList.add('loading');
      this.button.classList.add('btn--loading');
    }
    const grid = this.closest('.subcollection-block').querySelector('.products-list');
    
    // Revelar productos dosificados antes de hacer fetch
    const hiddenProducts = Array.from(grid.querySelectorAll('.product-column.wim-product-batch-hidden'));
    if (hiddenProducts.length > 0) {
      const toReveal = hiddenProducts.slice(0, 12);
      toReveal.forEach(item => item.classList.remove('wim-product-batch-hidden'));
      
      // Sin productos ocultos ni más páginas: quitar botón
      const remaining = grid.querySelectorAll('.product-column.wim-product-batch-hidden');
      if (remaining.length === 0 && !this._hasMorePages) {
        this.remove();
      }
      
      if (this.button) {
        this.button.classList.remove('loading');
        this.button.classList.remove('btn--loading');
      }
      this.loading = false;
      return;
    }
    
    this.page++;
    
    try {
      const fetchUrl = `${this.url}?page=${this.page}&section_id=${FoxTheme.utils.getSectionId(this)}`;
      const response = await fetch(fetchUrl);
      const text = await response.text();
      
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newProducts = html.querySelectorAll('.product-column');
      
      if (newProducts.length > 0) {
        // Evitar duplicados entre subcollections
        const existingHandles = new Set();
        document.querySelectorAll('.product-column[data-product-handle]').forEach(col => {
          existingHandles.add(col.dataset.productHandle);
        });
        
        let inserted = 0;
        newProducts.forEach((product) => {
          const handle = product.dataset.productHandle;
          // Producto ya presente en otro pasillo
          if (handle && existingHandles.has(handle)) return;
          if (handle) existingHandles.add(handle);
          // Dosificar: ocultar a partir del 12º
          if (inserted >= 12) product.classList.add('wim-product-batch-hidden');
          grid.appendChild(product);
          inserted++;
        });
      }
      
      // Determinar si hay más páginas disponibles
      const hasNextPage = html.querySelector('.pagination__next, [data-pagination="next"], .pagination-wrapper');
      this._hasMorePages = !!hasNextPage && newProducts.length > 0;
      
      // Sin más páginas ni dosificados: quitar botón
      if (!this._hasMorePages) {
        const remaining = grid.querySelectorAll('.product-column.wim-product-batch-hidden');
        if (remaining.length === 0) {
          this.remove();
        }
      }
    } catch (error) {
      console.error('Error loading subcollection products:', error);
    } finally {
      if (this.button) {
        this.button.classList.remove('loading');
        this.button.classList.remove('btn--loading');
      }
      this.loading = false;
    }
  }
}
customElements.define('wim-subcollection-load-more', WimSubcollectionLoadMore);

(function () {
  function updateCpGate(isValid) {
    document.querySelectorAll('[data-cp-gate]').forEach(function (btn) {
      btn.hidden = !isValid;
    });
  }
  
  function checkCartAndUpdate() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCpGate(cart.attributes && cart.attributes.postal_code_valid === 'true');
    });
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        checkCartAndUpdate
      );
    }
  });
})();


// ====== WIM: Notificaciones Toast y Accesibilidad ======
(function () {
  function getOrCreateToastContainer() {
    let container = document.getElementById('wim-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'wim-toast-container';
      document.body.appendChild(container);
    }
    return container;
  }
  
  function getOrCreateA11yAnnouncer() {
    let announcer = document.getElementById('wim-a11y-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'wim-a11y-announcer';
      announcer.style.position = 'absolute';
      announcer.style.width = '1px';
      announcer.style.height = '1px';
      announcer.style.padding = '0';
      announcer.style.margin = '-1px';
      announcer.style.overflow = 'hidden';
      announcer.style.clip = 'rect(0, 0, 0, 0)';
      announcer.style.border = '0';
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    return announcer;
  }
  
  window.wimShowToast = function (productTitle, customTitle, customMessage, showAction = true) {
    const actionText = (window.FoxTheme && window.FoxTheme.quickOrderListStrings && window.FoxTheme.quickOrderListStrings.viewCart) || 'Ver carrito';
    const title = customTitle || '¡Añadido al carrito!';
    const message = customMessage || (productTitle ? productTitle : 'Producto añadido con éxito');
    
    // Anuncio para lectores de pantalla
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title} ${message}`;
    
    // Render del Toast
    const container = getOrCreateToastContainer();
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--success wim-toast--enter';
    
    let actionHtml = '';
    if (showAction) {
      actionHtml = `<a href="/cart" class="wim-toast__action">${actionText}</a>`;
    }
    
    toast.innerHTML = `<div class="wim-toast__content">
      <div class="wim-toast__icon-wrapper">
        <span class="wim-toast__icon">✓</span>
      </div>
      <div class="wim-toast__text">
        <span class="wim-toast__title">${title}</span>
        <span class="wim-toast__message">${message}</span>
      </div>
    </div>
    ${actionHtml}`;
    
    const actionButton = toast.querySelector('.wim-toast__action');
    if (actionButton) {
      actionButton.addEventListener('click', function (e) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          e.preventDefault();
          drawer.show();
          // Quitar toast al abrir el drawer
          toast.classList.remove('wim-toast--enter');
          toast.classList.add('wim-toast--exit');
          toast.addEventListener('animationend', function () {
            toast.remove();
          });
        }
      });
    }
    
    container.appendChild(toast);
    
    setTimeout(() => {
      if (toast && toast.parentNode) {
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', () => toast.remove());
      }
    }, 4000);
  };
  
  window.wimShowUndoToast = function (title, actionText, undoCallback) {
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title}. Tienes unos segundos para deshacer.`;
    
    const container = getOrCreateToastContainer();
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--success wim-toast--enter';
    toast.innerHTML = `<div class="wim-toast__content">
      <div class="wim-toast__icon-wrapper">
        <span class="wim-toast__icon" style="display:flex;align-items:center;justify-content:center;">
          <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round" style="margin-left:-2px"><path d="M3 10h10a5 5 0 0 1 5 5v2"/><polyline points="7 14 3 10 7 6"/></svg>
        </span>
      </div>
      <div class="wim-toast__text">
        <span class="wim-toast__title">${title}</span>
      </div>
    </div>
    <button type="button" class="wim-toast__action" style="font-weight:700;text-decoration:none;padding:6px 12px;background:rgba(255,255,255,0.15);border-radius:100px;transition:all 0.2s;">${actionText}</button>`;
    
    let isUndone = false;
    const actionButton = toast.querySelector('.wim-toast__action');
    if (actionButton) {
      actionButton.addEventListener('click', function (e) {
        e.preventDefault();
        isUndone = true;
        if (typeof undoCallback === 'function') undoCallback();
        
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', () => toast.remove());
      });
    }
    
    setTimeout(function () {
      if (!isUndone && toast && toast.parentNode) {
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', () => toast.remove());
      }
    }, 5000);
    
    container.appendChild(toast);
  };
  
  
  
  window.wimShowWishlistToast = function (listName) {
    const title = '¡Guardado en favoritos!';
    const message = listName ? `Añadido a ${listName}` : 'Producto guardado en tus listas';
    
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title} ${message}`;
    
    const container = getOrCreateToastContainer();
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--wishlist wim-toast--enter';
    toast.innerHTML = `<div class="wim-toast__content">
      <div class="wim-toast__icon-wrapper">
        <span class="wim-toast__icon">❤</span>
      </div>
      <div class="wim-toast__text">
        <span class="wim-toast__title">${title}</span>
        <span class="wim-toast__message">${message}</span>
      </div>
    </div>
    <a href="/pages/mis-favoritos" class="wim-toast__action">Ver listas</a>`;
    
    container.appendChild(toast);
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('wim-toast--enter');
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', function () { toast.remove(); });
      }
    }, 3000);
  };
  
  window.wimShowWishlistErrorToast = function (errorMsg) {
    const title = 'Error al guardar';
    const message = errorMsg || 'No se pudo guardar en la lista';
    
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title} ${message}`;
    
    const container = getOrCreateToastContainer();
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--error wim-toast--enter';
    toast.innerHTML = `<div class="wim-toast__content">
      <div class="wim-toast__icon-wrapper">
        <span class="wim-toast__icon">⚠</span>
      </div>
      <div class="wim-toast__text">
        <span class="wim-toast__title">${title}</span>
        <span class="wim-toast__message">${message}</span>
      </div>
    </div>`;
    
    container.appendChild(toast);
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('wim-toast--enter');
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', function () { toast.remove(); });
      }
    }, 4000);
  };
  
  window.wimShowLimitToast = function (maxValue, unitSale) {
    const isWeight = unitSale === 'weight';
    const unitLabel = isWeight ? 'kg' : 'ud';
    const strings = window.FoxTheme?.wimQuantityToastStrings || {};
    
    let title = strings.limitTitle || 'Límite ajustado';
    let messageTemplate = strings.limitMessage || 'El límite de este producto es de [max] [unit]. La cantidad ha sido ajustada automáticamente.';
    
    if (maxValue === 0 || maxValue === '0') {
      title = strings.limitTitleEmpty || 'Sin stock disponible';
      messageTemplate = strings.limitMessageEmpty || 'Lo sentimos, no quedan unidades disponibles de este producto en esta tienda.';
    }
    
    const message = messageTemplate.replace('[max]', maxValue).replace('[unit]', unitLabel);
    // Anuncio accesible
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title}. ${message}`;
    
    // Evitar duplicar el mismo toast si ya está visible
    const container = getOrCreateToastContainer();
    if (container.querySelector('.wim-toast--limit')) return;
    
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--limit wim-toast--enter';
    toast.innerHTML = `
      <div class="wim-toast__content">
        <div class="wim-toast__icon-wrapper">
          <span class="wim-toast__icon">⚠</span>
        </div>
        <div class="wim-toast__text">
          <span class="wim-toast__title">${title}</span>
          <span class="wim-toast__message">${message}</span>
        </div>
      </div>
    `;
    
    container.appendChild(toast);
    
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('wim-toast--enter');
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', function () { toast.remove(); });
      }
    }, 3500);
  };
  
  window.wimShowMinToast = function (minValue, unitSale) {
    const isWeight = unitSale === 'weight';
    const unitLabel = isWeight ? 'kg' : 'ud';
    const strings = window.FoxTheme?.wimQuantityToastStrings || {};
    const title = strings.minTitle || 'Límite ajustado';
    const messageTemplate = strings.minMessage || 'El pedido mínimo para este producto es de [min] [unit]. La cantidad ha sido ajustada.';
    const message = messageTemplate.replace('[min]', minValue).replace('[unit]', unitLabel);
    
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title}. ${message}`;
    
    const container = getOrCreateToastContainer();
    if (container.querySelector('.wim-toast--min')) return;
    
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--limit wim-toast--min wim-toast--enter';
    toast.innerHTML = `
      <div class="wim-toast__content">
        <div class="wim-toast__icon-wrapper">
          <span class="wim-toast__icon">⚠</span>
        </div>
        <div class="wim-toast__text">
          <span class="wim-toast__title">${title}</span>
          <span class="wim-toast__message">${message}</span>
        </div>
      </div>
    `;
    container.appendChild(toast);
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('wim-toast--enter');
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', function () { toast.remove(); });
      }
    }, 3500);
  };
  
  window.wimShowStepToast = function (stepValue, unitSale) {
    const isWeight = unitSale === 'weight';
    const unitLabel = isWeight ? 'kg' : 'ud';
    const strings = window.FoxTheme?.wimQuantityToastStrings || {};
    const title = strings.stepTitle || 'Cantidad ajustada';
    const messageTemplate = strings.stepMessage || 'Este producto se añade en múltiplos de [step] [unit].';
    const message = messageTemplate.replace('[step]', stepValue).replace('[unit]', unitLabel);
    
    const announcer = getOrCreateA11yAnnouncer();
    announcer.textContent = `${title}. ${message}`;
    
    const container = getOrCreateToastContainer();
    if (container.querySelector('.wim-toast--step')) return;
    
    const toast = document.createElement('div');
    toast.className = 'wim-toast wim-toast--limit wim-toast--step wim-toast--enter';
    toast.innerHTML = `
      <div class="wim-toast__content">
        <div class="wim-toast__icon-wrapper">
          <span class="wim-toast__icon">⚠</span>
        </div>
        <div class="wim-toast__text">
          <span class="wim-toast__title">${title}</span>
          <span class="wim-toast__message">${message}</span>
        </div>
      </div>
    `;
    container.appendChild(toast);
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('wim-toast--enter');
        toast.classList.add('wim-toast--exit');
        toast.addEventListener('animationend', function () { toast.remove(); });
      }
    }, 3500);
  };
})();

// ====== WIM: Sincronización del Carrito entre Pestañas ======
(function () {
  if (typeof window.BroadcastChannel !== 'undefined') {
    const cartChannel = new BroadcastChannel('wim-cart-sync');
    
    // Escuchar actualizaciones locales del carrito y notificarlas a otras pestañas
    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        function (event) {
          // Evitar bucles: solo difundir si se originó localmente en esta pestaña
          if (event && event.cart && !event.isRemoteSync) {
            cartChannel.postMessage({
              cart: event.cart
            });
          }
        }
      );
    } else {
      // Fallback por si FoxTheme se inicializa más tarde
      document.addEventListener('DOMContentLoaded', function () {
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          window.FoxTheme.pubsub.subscribe(
            window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            function (event) {
              if (event && event.cart && !event.isRemoteSync) {
                cartChannel.postMessage({
                  cart: event.cart
                });
              }
            }
          );
        }
      });
    }
    
    // Recibir actualizaciones de otras pestañas y aplicarlas localmente
    cartChannel.onmessage = function (e) {
      if (e.data && e.data.cart && window.FoxTheme && window.FoxTheme.pubsub) {
        window.FoxTheme.pubsub.publish(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          {
            cart: e.data.cart,
            isRemoteSync: true
          }
        );
      }
    };
  }
})();

// Cambios de estilos en form Activa tu cuenta
(function injectShopifyFormEmbedStyles() {
  const TARGET_SELECTOR = 'shopify-forms-embed';
  const RECOVERY_FORM_CSS = `
    input {
      padding: 1.2rem !important;
      font-family: 'Raleway', sans-serif !important;
      font-weight: 600 !important;
      font-size: 1.3rem !important;
      line-height: 1.8rem !important;
      letter-spacing: 0 !important;
      color: #2D343C !important;
      background-color: rgba(255, 255, 255, 1) !important;
      border: 1px solid rgba(209, 212, 217, 1) !important;
      border-radius: 10.0rem !important;
    }
    input:focus,
    input:focus-visible {
      outline: none !important;
      border-color: rgba(209, 212, 217, 1) !important;
    }
    button[type="submit"] {
      all: revert !important;
      display: block !important;
      width: 100% !important;
      padding: 1.2rem !important;
      font-family: 'Raleway', sans-serif !important;
      font-size: 1.4rem !important;
      font-weight: 700 !important;
      line-height: normal !important;
      color: #004B87 !important;
      background: #FECD00 !important;
      border: none !important;
      border-radius: 10.0rem !important;
      cursor: pointer !important;
      text-align: center !important;
      text-transform: none !important;
      letter-spacing: 0 !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      transition: opacity 0.2s ease !important;
      max-width: none !important;
      margin: 0 !important;
    }
    button[type="submit"]:hover {
      background-color: #004B87 !important;
      border-color: #004B87 !important;
      color: #FECD00 !important;
    }
    form > div {
      position: relative !important;
    }
    label {
      font-family: 'Raleway', sans-serif !important;
      color: #9CA3AF !important;
      font-size: 1.5rem !important;
      font-weight: 400 !important;
    }
    input:focus + label {
      color: #9CA3AF !important;
    }
    p {
      font-family: 'Raleway', sans-serif !important;
      color: #2D343C !important;
    }
  `;
  // function tryInject(el) {
  //   try {
  //     if (!el || el.dataset.wimInjected) return;
  //     const isRecoveryEmbed = Boolean(
  //       el.closest('.shopify-section') ||
  //       el.matches('[data-forms-id="forms-root-734209"]') ||
  //       el.getAttribute('data-forms-id') === 'forms-root-734209'
  //     );
  //     if (!isRecoveryEmbed) return;
  //     const sr = el.shadowRoot;
  //     if (!sr) return;
  //     const style = document.createElement('style');
  //     style.setAttribute('data-wim-inject', 'true');
  //     style.textContent = RECOVERY_FORM_CSS;
  //     sr.appendChild(style);
  //     const submitButton = sr.querySelector('button[type="submit"]');
  //     if (submitButton) {
  //       submitButton.classList.add('btn', 'btn--primary');
  //       submitButton.innerHTML = <span class="btn__text">${submitButton.textContent}</span>;
  //     }
  //     el.dataset.wimInjected = '1';
  
  //   } catch (e) {
  //     console.error('[wim] error injecting styles into shadowRoot', e);
  //   }
  // }
  
  // Inject into any existing embeds
  
  function tryInject(el) {
    try {
      if (!el) return;
      const isRecoveryEmbed = Boolean(
        el.closest('[data-forms-id="forms-root-734209"]') ||
        el.getAttribute('data-forms-id') === 'forms-root-734209'
      );
      if (!isRecoveryEmbed) return;
      const sr = el.shadowRoot;
      if (!sr) return;
      if (sr.querySelector('style[data-wim-inject]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-wim-inject', 'true');
      style.textContent = RECOVERY_FORM_CSS;
      sr.appendChild(style);
    } catch (e) {
      console.error('[wim] error injecting styles into shadowRoot', e);
    }
  }
  
  document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
  
  // Observe DOM for new embeds
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) tryInject(node);
        const descendants = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        descendants.forEach(tryInject);
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  
  // Retry pass for late-initialized shadowRoots (safety)
  let retries = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
    retries++;
    if (retries >= maxRetries) clearInterval(retryInterval);
  }, 500);
})();

// ====== WIM: Re-inicialización de Scripts del PDP ======
window.wimInitProductScripts = function (container = document) {
  let wim_selector_pills = container.querySelector('.wim-selector-pills');
  let sticky_bar = document.querySelector('.sticky-atc-bar__inner');
  if (wim_selector_pills) {
    wim_selector_pills.querySelectorAll('.wim-pill').forEach(function (pill) {
      if (pill.dataset.wimBound) return;
      pill.dataset.wimBound = 'true';
      pill.addEventListener('click', function (event) {
        if (navigator.vibrate) navigator.vibrate(50);
        if (wim_selector_pills.getAttribute('data-unit-sale') == 'all') {
          document.querySelectorAll(`.wim-quantity[data-section-id="${wim_selector_pills.getAttribute('data-section-id')}"]`).forEach(function (element) {
            element.setAttribute('data-unit-sale', pill.getAttribute('data-value'));
          });
          wim_selector_pills.querySelectorAll('.wim-pill').forEach(function (otherPill) {
            otherPill.classList.remove('active');
          });
          this.classList.add('active');
          if (this.getAttribute('data-value') == 'unit') {
            wim_selector_pills.closest('form').querySelector('.wim-price-per-weight').classList.add('hidden');
            wim_selector_pills.closest('form').querySelector('.wim-price-per-unit').classList.remove('hidden');
            wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity_weight"]').value = wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity_weight"]').getAttribute('min');
            wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity_weight"]').dispatchEvent(new Event('change', { bubbles: true }));
            if (sticky_bar) {
              if (sticky_bar.querySelector('.wim-price-per-weight')) {
                sticky_bar.querySelector('.wim-price-per-weight').classList.add('hidden');
              }
              if (sticky_bar.querySelector('.wim-price-per-unit')) {
                sticky_bar.querySelector('.wim-price-per-unit').classList.remove('hidden');
              }
              if (sticky_bar.querySelector('.quantity__input[name="quantity_weight"]')) {
                sticky_bar.querySelector('.quantity__input[name="quantity_weight"]').value = sticky_bar.querySelector('.quantity__input[name="quantity_weight"]').getAttribute('min');
                sticky_bar.querySelector('.quantity__input[name="quantity_weight"]').dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          else {
            wim_selector_pills.closest('form').querySelector('.wim-price-per-weight').classList.remove('hidden');
            wim_selector_pills.closest('form').querySelector('.wim-price-per-unit').classList.add('hidden');
            wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity"]').value = wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity"]').getAttribute('min');
            wim_selector_pills.closest('form').querySelector('.quantity__input[name="quantity"]').dispatchEvent(new Event('change', { bubbles: true }));
            if (sticky_bar) {
              if (sticky_bar.querySelector('.wim-price-per-weight')) {
                sticky_bar.querySelector('.wim-price-per-weight').classList.remove('hidden');
              }
              if (sticky_bar.querySelector('.wim-price-per-unit')) {
                sticky_bar.querySelector('.wim-price-per-unit').classList.add('hidden');
              }
              if (sticky_bar.querySelector('.quantity__input[name="quantity"]')) {
                sticky_bar.querySelector('.quantity__input[name="quantity"]').value = sticky_bar.querySelector('.quantity__input[name="quantity"]').getAttribute('min');
                sticky_bar.querySelector('.quantity__input[name="quantity"]').dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        }
        wim_selector_pills.closest('form').querySelector('[name="unit_sale"]').value = this.getAttribute('data-value');
        if (sticky_bar && sticky_bar.querySelector('[name="unit_sale"]')) {
          sticky_bar.querySelector('[name="unit_sale"]').value = this.getAttribute('data-value');
        }
      });
    });
  }
  
  const select_criteria = container.querySelector("#substitution_criteria_select") || container.getElementById?.("substitution_criteria_select");
  if (select_criteria) {
    if (!select_criteria.dataset.wimBound) {
      select_criteria.dataset.wimBound = 'true';
      select_criteria.addEventListener('change', function () {
        const forms = document.querySelectorAll(`form[data-product-id="${this.getAttribute('data-product-id')}"]`);
        forms.forEach(form => {
          if (form) {
            form.querySelector('input[name="properties[_janisCommerce_sustitutionCriteria]"]').value = this.value;
            form.querySelector('input[name="properties[_sustitución]"]').value = this.value;
          }
        });
      });
    }
  }
  
  const select_cutting = container.querySelector("#cutting_type_select") || container.getElementById?.("cutting_type_select");
  if (select_cutting) {
    if (!select_cutting.dataset.wimBound) {
      select_cutting.dataset.wimBound = 'true';
      select_cutting.addEventListener('change', function () {
        const forms = document.querySelectorAll(`form[data-product-id="${this.getAttribute('data-product-id')}"]`);
        forms.forEach(form => {
          if (form) {
            form.querySelector('input[name="properties[_janisCommerce_customerNote]"]').value = this.value;
            form.querySelector('input[name="properties[preparación]"]').value = this.value;
          }
        });
        const message_error = select_cutting.closest('.product__block--wim_cutType').querySelector('#cutting_type_error');
        if (message_error) {
          message_error.style.display = this.value == '' ? 'block' : 'none';
        }
        select_cutting.classList.toggle('wim-cut-type__select--error', this.value == '');
      });
    }
  }
};

// ====== WIM: Clase Quick Buy Modal ======
class WimQuickBuy {
  constructor() {
    this.modal = document.getElementById('wim-quick-buy-modal');
    if (!this.modal) return;
    
    this.container = this.modal.querySelector('.wim-quick-buy-modal__container');
    this.content = this.modal.querySelector('.wim-quick-buy-modal__content');
    this.spinner = this.modal.querySelector('.wim-quick-buy-modal__spinner');
    this.closeButtons = this.modal.querySelectorAll('.js-wim-quick-buy-close');
    
    this.isWizardMode = false;
    
    this.init();
  }
  
  init() {
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal || e.target.classList.contains('wim-quick-buy-modal__overlay') || e.target.closest('.js-wim-quick-buy-close')) {
        this.requestClose();
      }
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.hasAttribute('hidden')) {
        this.requestClose();
      }
    });
    
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.js-wim-quick-buy-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const url = btn.getAttribute('data-product-url');
        if (url) {
          this.open(url);
        }
      }
    }, true);
    
    // Cerrar el modal de vista rápida cuando el cajón del carrito (cart-drawer) se abre
    document.addEventListener('drawer:handleAfterShow', (e) => {
      if (e.target && e.target.tagName === 'CART-DRAWER') {
        if (!this.modal.hasAttribute('hidden')) {
          if (!this.isWizardMode) {
            this.close();
          }
        }
      }
    });
    
    this.initGestures();
  }
  
  /* Gestos táctiles de arrastre (Bottom Sheet) en dispositivos móviles */
  initGestures() {
    let startY = 0;
    let currentY = 0;
    let deltaY = 0;
    let isDragging = false;
    let isExpanded = false;
    let dragType = 'none';
    
    const container = this.container;
    const content = this.content;
    
    const isMobile = () => window.innerWidth < 1024;
    
    container.addEventListener('touchstart', (e) => {
      if (!isMobile()) return;
      
      const touch = e.touches[0];
      const target = e.target;
      
      const onHandle = target.closest('.wim-quick-buy-modal__drag-handle');
      const onClose = target.closest('.wim-quick-buy-modal__close');
      const onContent = target.closest('.wim-quick-buy-modal__content');
      
      if (onClose) return; // Ignorar si se toca el botón de cerrar
      
      if (onHandle || (onContent && content.scrollTop <= 0)) {
        startY = touch.clientY;
        isDragging = true;
        deltaY = 0;
        container.style.transition = 'none';
        
        // El handle permite arrastrar en ambas direcciones, el contenido solo hacia abajo
        dragType = onHandle ? 'any' : 'down-only';
      }
    }, { passive: true });
    
    container.addEventListener('touchmove', (e) => {
      if (!isDragging || !isMobile()) return;
      
      const touch = e.touches[0];
      currentY = touch.clientY;
      deltaY = currentY - startY;
      
      if (dragType === 'down-only' && deltaY < 0) {
        // Permitir scroll normal del contenido si se arrastra hacia arriba
        isDragging = false;
        container.style.transition = '';
        container.style.transform = '';
        return;
      }
      
      if (deltaY > 0) {
        // Desplazamiento hacia abajo para cerrar
        container.style.transform = `translateY(${deltaY}px)`;
        if (e.cancelable) e.preventDefault();
      } else if (deltaY < 0 && dragType === 'any') {
        // Desplazamiento hacia arriba para expandir
        const pullUp = isExpanded ? deltaY * 0.2 : deltaY;
        container.style.transform = `translateY(${pullUp}px)`;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });
    
    container.addEventListener('touchend', (e) => {
      if (!isDragging || !isMobile()) return;
      isDragging = false;
      
      container.style.transition = '';
      
      // Cerrar o confirmar salida si se arrastra más de 120px hacia abajo
      if (deltaY > 120) {
        this.requestClose();
        container.style.transform = '';
      }
      // Expandir a 100% si se arrastra hacia arriba más de 70px
      else if (deltaY < -70 && !isExpanded && dragType === 'any') {
        isExpanded = true;
        container.classList.add('wim-quick-buy-modal__container--expanded');
        container.style.transform = '';
      }
      // Contraer a 85% si se arrastra hacia abajo y estaba expandido
      else if (deltaY > 60 && isExpanded) {
        isExpanded = false;
        container.classList.remove('wim-quick-buy-modal__container--expanded');
        container.style.transform = '';
      }
      // Restablecer posición
      else {
        container.style.transform = '';
      }
      
      deltaY = 0;
    });
    
    // Resetear estado al cerrar el modal
    const originalClose = this.close.bind(this);
    this.close = () => {
      isExpanded = false;
      container.classList.remove('wim-quick-buy-modal__container--expanded');
      container.style.transform = '';
      originalClose();
    };
  }
  
  async open(url) {
    this.isWizardMode = false;
    this.content.scrollTop = 0;
    this.content.innerHTML = '';
    const existingBanner = this.modal.querySelector('.wim-fish-fresh-banner');
    if (existingBanner) {
      existingBanner.remove();
    }
    const existingShippingBanner = this.modal.querySelector('.wim-shipping-days-banner');
    if (existingShippingBanner) {
      existingShippingBanner.remove();
    }
    this.modal.classList.remove('has-fish-fresh-banner');
    this.modal.classList.remove('has-shipping-days-banner');
    this.spinner.removeAttribute('hidden');
    this.modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    
    try {
      const promises = [];
      const infoScript = this.modal.dataset.productInfoScript;
      const selectScript = this.modal.dataset.variantSelectsScript;
      const galleryScript = this.modal.dataset.mediaGalleryScript;
      
      if (!customElements.get('variant-selects') && selectScript) {
        promises.push(this.loadScript(selectScript));
      }
      if (!customElements.get('product-info') && infoScript) {
        promises.push(this.loadScript(infoScript));
      }
      if (!customElements.get('media-gallery') && galleryScript) {
        promises.push(this.loadScript(galleryScript));
      }
      
      if (promises.length > 0) {
        await Promise.all(promises);
      }
      
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const htmlText = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const productInfo = doc.querySelector('product-info.wim-product') || doc.querySelector('product-info');
      
      if (productInfo) {
        productInfo.setAttribute('data-update-url', 'false');
        productInfo.setAttribute('data-enable-image-zoom', 'false');
        
        // Move disclaimer below title row
        const disclaimer = productInfo.querySelector('.product__block--wim_additional_info') || productInfo.querySelector('.wim-additional-info');
        const titleRow = productInfo.querySelector('.wim-pdp-title-row') || productInfo.querySelector('.product__block--title') || productInfo.querySelector('.product__block--wim_richtext_pdp');
        if (disclaimer && titleRow) {
          titleRow.parentNode.insertBefore(disclaimer, titleRow.nextSibling);
        }
        this.setInnerHTML(this.content, productInfo.outerHTML);
        // Añadir banner de pescadería si corresponde
        const shippingDays = productInfo.getAttribute('data-shipping-days');
        if (shippingDays != null && shippingDays != '') {
          const shippingDaysMsg = productInfo.getAttribute('data-shipping-days-msg');
          const container = this.modal.querySelector('.wim-quick-buy-modal__container');
          if (container) {
            const banner = document.createElement('div');
            banner.className = 'wim-shipping-days-banner';
            const bannerText = document.createElement('span');
            bannerText.className = 'wim-shipping-days-banner__text';
            bannerText.textContent = shippingDaysMsg || '';
            banner.appendChild(bannerText);
            container.prepend(banner);
            this.modal.classList.add('has-shipping-days-banner');
          }
        }
        // Añadir banner de pescadería si corresponde
        const ifFreshFish = productInfo.getAttribute('data-fish-fresh') === 'true';
        if (ifFreshFish && ["",null].includes(shippingDays)) {
          const fishDeliveryText = this.modal.getAttribute('data-fish-delivery-text');
          const container = this.modal.querySelector('.wim-quick-buy-modal__container');
          if (container) {
            const banner = document.createElement('div');
            banner.className = 'wim-fish-fresh-banner';
            const bannerText = document.createElement('span');
            bannerText.className = 'wim-fish-fresh-banner__text';
            bannerText.textContent = fishDeliveryText;
            banner.appendChild(bannerText);
            container.prepend(banner);
            this.modal.classList.add('has-fish-fresh-banner');
          }
        }
        
        // Buscar y renderizar enlace de oferta al lado del botón de detalles
        setTimeout(() => {
          const badge = this.content.querySelector('.wim-promotions-badge-container .wim-product-card__badge-sale');
          if (badge) {
            const offerName = badge.textContent.trim();
            const detailsLink = this.content.querySelector('.wim-product-details-link');
            if (detailsLink && offerName) {
              const wrapper = detailsLink.closest('.wim-product-details-wrapper');
              if (wrapper) {
                const existingOfferLink = wrapper.querySelector('.wim-product-offer-link');
                if (existingOfferLink) {
                  existingOfferLink.remove();
                }
                const offerLink = document.createElement('a');
                offerLink.className = 'wim-product-offer-link';
                offerLink.href = detailsLink.href;
                offerLink.textContent = `${wrapper.getAttribute('data-offer-label')} ${offerName} >`;
                wrapper.appendChild(offerLink);
              }
            }
          }
        }, 150);
        
        if (window.wimSetupWishlistElements) {
          window.wimSetupWishlistElements();
        }
        if (window.wimSetupPdpWishlist) {
          window.wimSetupPdpWishlist();
        }
        if (window.wimInitProductScripts) {
          window.wimInitProductScripts(this.content);
        }
        
        // Esperar a que la imagen principal esté cargada o lista para ocultar el spinner y evitar flash de espacio en blanco
        const mainImg = this.content.querySelector('.product__media img') || this.content.querySelector('.product__media-wrapper img') || this.content.querySelector('img');
        const hideSpinner = () => {
          this.spinner.setAttribute('hidden', 'true');
        };
        
        if (mainImg && !mainImg.complete) {
          mainImg.addEventListener('load', hideSpinner);
          mainImg.addEventListener('error', hideSpinner);
          setTimeout(hideSpinner, 2500); // Timeout de seguridad de 2.5s
        } else {
          hideSpinner();
        }
        
        if (window.FoxTheme && window.FoxTheme.a11y) {
          window.FoxTheme.a11y.trapFocus(this.modal);
        }
      } else {
        throw new Error('Product info not found');
      }
    } catch (err) {
      console.error('[WimQuickBuy] Error loading product:', err);
      this.content.innerHTML = `<div class="p-6 text-center text-red-600">Error al cargar el producto. Por favor, inténtelo de nuevo.</div>`;
      this.spinner.setAttribute('hidden', 'true');
    }
  }
  
  async openMultiple(urls) {
    this.isWizardMode = true;
    this.content.scrollTop = 0;
    this.content.innerHTML = '';
    const existingBanner = this.modal.querySelector('.wim-fish-fresh-banner');
    const existingShippingBanner = this.modal.querySelector('.wim-shipping-days-banner');
    if (existingBanner) existingBanner.remove();
    this.modal.classList.remove('has-fish-fresh-banner');
    if (existingShippingBanner) existingShippingBanner.remove();
    this.modal.classList.remove('has-shipping-days-banner');
    
    this.spinner.removeAttribute('hidden');
    this.modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    
    try {
      const promises = [];
      const infoScript = this.modal.dataset.productInfoScript;
      const selectScript = this.modal.dataset.variantSelectsScript;
      const galleryScript = this.modal.dataset.mediaGalleryScript;
      
      if (!customElements.get('variant-selects') && selectScript) promises.push(this.loadScript(selectScript));
      if (!customElements.get('product-info') && infoScript) promises.push(this.loadScript(infoScript));
      if (!customElements.get('media-gallery') && galleryScript) promises.push(this.loadScript(galleryScript));
      if (promises.length > 0) await Promise.all(promises);
      
      // Fetch all product HTMLs up front
      const fetchPromises = urls.map(url => fetch(url).then(res => res.ok ? res.text() : null));
      const htmlTexts = await Promise.all(fetchPromises);
      
      // Filter valid texts and parse productInfos
      const parser = new DOMParser();
      const validProducts = [];
      htmlTexts.forEach(htmlText => {
        if (!htmlText) return;
        const doc = parser.parseFromString(htmlText, 'text/html');
        const productInfo = doc.querySelector('product-info.wim-product') || doc.querySelector('product-info');
        if (productInfo) {
          productInfo.setAttribute('data-update-url', 'false');
          productInfo.setAttribute('data-enable-image-zoom', 'false');
          
          const disclaimer = productInfo.querySelector('.product__block--wim_additional_info') || productInfo.querySelector('.wim-additional-info');
          const titleRow = productInfo.querySelector('.wim-pdp-title-row') || productInfo.querySelector('.product__block--title');
          if (disclaimer && titleRow) titleRow.parentNode.insertBefore(disclaimer, titleRow.nextSibling);
          
          const blocks = productInfo.querySelectorAll('.product__block');
          blocks.forEach(block => {
            const blockText = block.textContent.trim().toLowerCase();
            const isSpanishWarning = blockText.includes('lunes') && blockText.includes('pescader');
            const isEnglishWarning = blockText.includes('monday') && blockText.includes('fish');
            if (isSpanishWarning || isEnglishWarning) block.style.display = 'none';
          });
          
          validProducts.push({
            html: productInfo.outerHTML,
            ifFreshFish: productInfo.getAttribute('data-fish-fresh') === 'true',
            shippingDays: productInfo.getAttribute('data-shipping-days'),
            shippingDaysMsg: productInfo.getAttribute('data-shipping-days-msg')
          });
        }
      });
      
      if (validProducts.length === 0) throw new Error('No valid products found');
      
      // Store products on the modal for later use by wim-theme.js
      this.modal._wizardProducts = validProducts;
      this.modal._wizardCurrentIndex = 0;
      this.modal._wizardTotal = validProducts.length;
      
      // Render the first step
      this._renderWizardStep(0);
      
    } catch (err) {
      console.error('[WimQuickBuy Wizard] Error:', err);
      this.content.innerHTML = `<div class="p-6 text-center text-red-600">Error al cargar productos.</div>`;
      this.spinner.setAttribute('hidden', 'true');
    }
  }
  
  _renderWizardStep(index) {
    const products = this.modal._wizardProducts;
    const total = this.modal._wizardTotal;
    const product = products[index];
    
    this.content.scrollTop = 0;
    this.content.innerHTML = '';
    
    // --- Progress dots ---
    if (total > 1) {
      const progressEl = document.createElement('div');
      progressEl.className = 'wim-wizard-progress';
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('span');
        dot.className = 'wim-wizard-dot' + (i === index ? ' wim-wizard-dot--active' : (i < index ? ' wim-wizard-dot--done' : ''));
        progressEl.appendChild(dot);
      }
      this.content.appendChild(progressEl);
    }
    
    // --- Step header ---
    const wizardHeader = document.createElement('div');
    wizardHeader.className = 'wim-quick-buy-wizard-header';
    
    const wizardTitle = document.createElement('h3');
    wizardTitle.className = 'wim-quick-buy-wizard-title';
    wizardTitle.textContent = total > 1
    ? `Configura el producto ${index + 1} de ${total}:`
    : 'Configura el producto:';
    
    const wizardSubtitle = document.createElement('p');
    wizardSubtitle.className = 'wim-quick-buy-wizard-subtitle';
    wizardSubtitle.textContent = 'Elige las opciones de preparación y añádelo a tu cesta.';
    
    wizardHeader.appendChild(wizardTitle);
    wizardHeader.appendChild(wizardSubtitle);
    this.content.appendChild(wizardHeader);
    
    // --- Product content ---
    const wrapper = document.createElement('div');
    wrapper.className = 'wim-quick-buy-wizard-item';
    wrapper.setAttribute('data-wizard-index', index);
    this.content.appendChild(wrapper);
    this.setInnerHTML(wrapper, product.html);
    
    // --- Fishmonger banner ---
    if (product.ifFreshFish) {
      const fishDeliveryText = this.modal.getAttribute('data-fish-delivery-text');
      const container = this.modal.querySelector('.wim-quick-buy-modal__container');
      if (container) {
        const existingBanner = container.querySelector('.wim-fish-fresh-banner');
        if (existingBanner) existingBanner.remove();
        const banner = document.createElement('div');
        banner.className = 'wim-fish-fresh-banner';
        banner.innerHTML = `<span class="wim-fish-fresh-banner__text">${fishDeliveryText}</span>`;
        container.prepend(banner);
        this.modal.classList.add('has-fish-fresh-banner');
      }
    } else {
      this.modal.classList.remove('has-fish-fresh-banner');
      const existingBanner = this.modal.querySelector('.wim-fish-fresh-banner');
      if (existingBanner) existingBanner.remove();
    }
    // --- Shipping days banner ---
    if (product.shippingDays) {
      const shippingDaysText = product.shippingDaysMsg;
      const container = this.modal.querySelector('.wim-quick-buy-modal__container');
      if (container) {
        const existingBanner = container.querySelector('.wim-shipping-days-banner');
        if (existingBanner) existingBanner.remove();
        const banner = document.createElement('div');
        banner.className = 'wim-shipping-days-banner';
        banner.innerHTML = `<span class="wim-shipping-days-banner__text">${shippingDaysText}</span>`;
        container.prepend(banner);
        this.modal.classList.add('has-shipping-days-banner');
      }
    } else {
      this.modal.classList.remove('has-shipping-days-banner');
      const existingBanner = this.modal.querySelector('.wim-shipping-days-banner');
      if (existingBanner) existingBanner.remove();
    }
    
    if (window.wimSetupWishlistElements) window.wimSetupWishlistElements();
    if (window.wimSetupPdpWishlist) window.wimSetupPdpWishlist();
    if (window.wimInitProductScripts) window.wimInitProductScripts(this.content);
    
    if (window.FoxTheme && window.FoxTheme.a11y) window.FoxTheme.a11y.trapFocus(this.modal);
    this.spinner.setAttribute('hidden', 'true');
  }
  
  requestClose() {
    if (this.isWizardMode && this.modal._wizardProducts && this.modal._wizardProducts.length > 0) {
      this.showExitConfirm();
    } else {
      this.close();
    }
  }
  
  showExitConfirm() {
    const exitModal = document.getElementById('wim-wizard-exit-modal');
    if (exitModal) {
      if (typeof exitModal.show === 'function') {
        exitModal.show();
      } else {
        exitModal.removeAttribute('hidden');
      }
    }
  }
  
  close() {
    this.isWizardMode = false;
    this.content.scrollTop = 0;
    this.modal.setAttribute('hidden', 'true');
    this.content.innerHTML = '';
    
    const existingFishmongerBanner = this.modal.querySelector('.wim-fish-fresh-banner');
    if (existingFishmongerBanner) {
      existingFishmongerBanner.remove();
    }
    this.modal.classList.remove('has-fish-fresh-banner');
    const existingShippingBanner = this.modal.querySelector('.wim-shipping-days-banner');
    if (existingShippingBanner) {
      existingShippingBanner.remove();
    }
    this.modal.classList.remove('has-shipping-days-banner');
    document.body.classList.remove('overflow-hidden');
    if (window.FoxTheme && window.FoxTheme.a11y) {
      window.FoxTheme.a11y.removeTrapFocus(this.modal);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }
  
  loadScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
  }
  
  setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

window.wimQuickBuyModal = new WimQuickBuy();

document.addEventListener('click', function(e) {
  if (e.target.closest('.js-wim-wizard-force-close')) {
    const exitModal = document.getElementById('wim-wizard-exit-modal');
    if (exitModal) {
      if (typeof exitModal.hide === 'function') exitModal.hide();
      else exitModal.setAttribute('hidden', '');
    }
    if (window.wimQuickBuyModal) {
      window.wimQuickBuyModal.close();
    }
  }
});

/* Card clickeable → PDP (se ejecuta una sola vez) */
if (!window.__wimCardClickBound) {
  window.__wimCardClickBound = true;
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.wim-product-card');
    if (!card) return;
    /* No navegar si se hizo clic en un elemento interactivo */
    if (e.target.closest('a, button, input, select, textarea, form, .wishlist-element, quantity-input')) return;
    var url = card.getAttribute('data-product-url');
    if (url) window.location.href = url;
  });
}

/* Sincronización del carrito con los product cards */
if (!window.__wimCardCartSyncBound) {
  window.__wimCardCartSyncBound = true;
  
  window.wimCardState = window.wimCardState || {
    latestRequestId: {},
    pendingQuantities: {},
    timers: {},
    isUpdating: {}
  };
  
  /* Helpers para obtener el input activo de un quantity-input */
  function getActiveCardInput(qtyInput) {
    var unitSale = qtyInput.getAttribute('data-unit-sale');
    if (unitSale === 'weight') {
      return qtyInput.querySelector('input.quantity__input-weight');
    }
    return qtyInput.querySelector('input.quantity__input:not(.quantity__input-weight)');
  }
  
  /* Calcular cantidad optimista del carrito */
  function getOptimisticCartCount() {
    if (!window.wimCardState || !window.wimCardState.cart || !window.wimCardState.cart.items) {
      return document.querySelector('cart-count') ? parseInt(document.querySelector('cart-count').innerText) || 0 : 0;
    }
    var total = 0;
    var pending = window.wimCardState.pendingQuantities || {};
    var handledVariants = {};
    var countedPendingVariants = {};
    
    window.wimCardState.cart.items.forEach(function (item) {
      var vid = String(item.variant_id);
      handledVariants[vid] = true;
      
      if (pending.hasOwnProperty(vid)) {
        if (countedPendingVariants[vid]) return;
        countedPendingVariants[vid] = true;
        
        // Usar la cantidad pendiente (la que el usuario acaba de elegir) en vez de la del caché
        var pQty = pending[vid];
        var card = document.querySelector('.wim-product-card[data-variant-id="' + vid + '"]');
        if (card) {
          var qtyInputEl = card.querySelector('quantity-input');
          if (qtyInputEl && qtyInputEl.getAttribute('data-unit-sale') === 'weight') {
            var inputW = qtyInputEl.querySelector('input.quantity__input-weight');
            var stepValue = parseFloat(inputW ? inputW.getAttribute('step') : 1) || 1;
            total += Math.round(pQty / stepValue);
          } else {
            total += parseInt(pQty);
          }
        } else {
          total += parseInt(pQty);
        }
      } else {
        total += parseInt(item.quantity || 0);
      }
    });
    
    // Items pendientes que aún no están en el caché del carrito (recién añadidos)
    for (var vid in pending) {
      if (!handledVariants[vid]) {
        var pQty = pending[vid];
        var card = document.querySelector('.wim-product-card[data-variant-id="' + vid + '"]');
        if (card) {
          var qtyInputEl = card.querySelector('quantity-input');
          if (qtyInputEl && qtyInputEl.getAttribute('data-unit-sale') === 'weight') {
            var inputW = qtyInputEl.querySelector('input.quantity__input-weight');
            var stepValue = parseFloat(inputW ? inputW.getAttribute('step') : 1) || 1;
            total += Math.round(pQty / stepValue);
          } else {
            total += parseInt(pQty);
          }
        } else {
          total += parseInt(pQty);
        }
      }
    }
    
    return total;
  }
  
  /* Actualizar contadores de carrito de forma optimista */
  function updateCartCounterOptimistically() {
    var optCount = getOptimisticCartCount();
    var countStr = optCount > 99 ? '99+' : optCount;
    document.querySelectorAll('cart-count').forEach(function (c) {
      var type = c.getAttribute('data-type');
      var countVal = countStr;
      if (type === 'blank') {
        countVal = '(' + countStr + ')';
      }
      if (c.classList.contains('cart-count--absolute')) {
        if (optCount > 99) {
          c.innerHTML = '<span class="text-sm-extra">' + countVal + '</span>';
          c.classList.add('cart-count--small-medium');
        } else {
          c.innerText = countVal;
          c.classList.remove('cart-count--small-medium');
        }
      } else {
        c.innerText = countVal;
      }
      c.hidden = optCount === 0;
      var method = optCount === 0 ? 'remove' : 'add';
      document.documentElement.classList[method]('cart-has-items');
      c.classList.remove('cart-count--bump');
      void c.offsetWidth;
      c.classList.add('cart-count--bump');
    });
  }
  
  /* Actualizar overlay de un quantity-input */
  function updateCardOverlay(qtyInput, value) {
    var unitSale = qtyInput.getAttribute('data-unit-sale');
    if (unitSale === 'weight') {
      var overlay = qtyInput.querySelector('.wim-weight-overlay');
      if (!overlay) return;
      var formatVal = overlay.querySelector('.wim-format-value');
      var formatUnit = overlay.querySelector('.wim-format-unit');
      var units = qtyInput.getAttribute('data-units') ? qtyInput.getAttribute('data-units').split(',').map(function (u) { return u.trim(); }) : ['g', 'kg'];
      var fVal = parseFloat(value);
      if (formatVal) {
        formatVal.innerHTML = fVal < 1 ? (fVal * 1000) : fVal.toFixed(2);
      }
      if (formatUnit) {
        formatUnit.innerHTML = fVal < 1 ? units[0] : units[1];
      }
    } else {
      var overlayUnit = qtyInput.querySelector('.wim-unit-overlay .wim-format-value');
      if (overlayUnit) {
        overlayUnit.innerHTML = parseInt(value);
      }
    }
  }
  
  function buildVariantQuantityUpdates(items, variantId, targetQuantity) {
    var matchingItems = items.filter(function (item) {
      return item.variant_id == variantId;
    });
    var updates = {};
    if (!matchingItems.length) return updates;
    
    var currentQuantity = matchingItems.reduce(function (total, item) {
      return total + (parseInt(item.quantity, 10) || 0);
    }, 0);
    var remainingQuantity = Math.max(0, targetQuantity);
    
    if (remainingQuantity >= currentQuantity) {
      var firstItem = matchingItems[0];
      updates[firstItem.key] = (parseInt(firstItem.quantity, 10) || 0) + remainingQuantity - currentQuantity;
      return updates;
    }
    
    matchingItems.forEach(function (item) {
      var currentItemQuantity = parseInt(item.quantity, 10) || 0;
      var nextItemQuantity = Math.min(currentItemQuantity, remainingQuantity);
      if (nextItemQuantity !== currentItemQuantity) {
        updates[item.key] = nextItemQuantity;
      }
      remainingQuantity -= nextItemQuantity;
    });
    
    return updates;
  }
  
  function getCartUpdateUrl() {
    var url = window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_update_url
    ? window.FoxTheme.routes.cart_update_url
    : '/cart/update';
    return url.endsWith('.js') ? url : url + '.js';
  }
  
  /* Función para actualizar el estado de los product cards basado en el estado del carrito */
  function syncProductCards(cart) {
    if (!cart || !cart.items) return;
    window.syncProductCards = syncProductCards; // Exponer globalmente para bfcache refresh
    window.wimCardState.cart = cart;
    var cards = document.querySelectorAll('.wim-product-card');
    cards.forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId) return;
      
      if (window.wimCardState && window.wimCardState.isUpdating[variantId]) {
        return;
      }
      if (window.wimCardState && window.wimCardState.pendingQuantities) {
        delete window.wimCardState.pendingQuantities[variantId];
      }
      
      var matchingItems = cart.items.filter(function (item) {
        return item.variant_id == variantId;
      });
      
      var qtyInput = card.querySelector('quantity-input');
      
      if (matchingItems.length > 0) {
        if (qtyInput) {
          card.classList.add('in-cart');
          var unitSale = qtyInput.getAttribute('data-unit-sale');
          if (unitSale === 'weight') {
            var weightVal = matchingItems.reduce(function (sum, item) {
              return sum + parseFloat(item.properties._weight_value || 0);
            }, 0);
            var inputWeight = qtyInput.querySelector('input.quantity__input-weight');
            if (inputWeight) {
              inputWeight.value = weightVal;
              inputWeight.setAttribute('data-value', weightVal);
            }
            updateCardOverlay(qtyInput, weightVal);
          } else {
            var qtyVal = matchingItems.reduce(function (sum, item) {
              return sum + parseInt(item.quantity);
            }, 0);
            var inputUnit = qtyInput.querySelector('input.quantity__input:not(.quantity__input-weight)');
            if (inputUnit) {
              inputUnit.value = qtyVal;
              inputUnit.setAttribute('data-value', qtyVal);
            }
            updateCardOverlay(qtyInput, qtyVal);
          }
          if (typeof qtyInput._wimOverlayReady === 'function') {
            qtyInput._wimOverlayReady();
          }
          if (typeof qtyInput.validateQtyRules === 'function') {
            qtyInput.validateQtyRules();
          }
        } else {
          card.classList.remove('in-cart');
        }
      } else {
        card.classList.remove('in-cart');
        if (qtyInput) {
          /* Resetear a los valores mínimos */
          var inputWeight = qtyInput.querySelector('input.quantity__input-weight');
          if (inputWeight) {
            var minWeight = inputWeight.getAttribute('data-min') || inputWeight.min || 0;
            inputWeight.value = minWeight;
            inputWeight.setAttribute('data-value', minWeight);
          }
          var inputUnit = qtyInput.querySelector('input.quantity__input:not(.quantity__input-weight)');
          if (inputUnit) {
            var minUnit = inputUnit.getAttribute('data-min') || inputUnit.min || 1;
            inputUnit.value = minUnit;
            inputUnit.setAttribute('data-value', minUnit);
          }
          updateCardOverlay(qtyInput, qtyInput.getAttribute('data-unit-sale') === 'weight' ? (inputWeight ? inputWeight.value : 0) : (inputUnit ? inputUnit.value : 1));
          if (typeof qtyInput.validateQtyRules === 'function') {
            qtyInput.validateQtyRules();
          }
        }
      }
    });
  }
  
  /* Esperar a que FoxTheme esté listo para suscribirse e inicializar la sincronización */
  function initCartSync() {
    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        function (event) {
          if (event && event.cart) {
            syncProductCards(event.cart);
          }
        }
      );
      
      fetch(`${FoxTheme.routes.cart_url}.js`, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        syncProductCards(cart);
      });
    } else {
      setTimeout(initCartSync, 100);
    }
  }
  initCartSync();
  
  document.addEventListener('wim:nodes-added', function (e) {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      syncProductCards(cart);
    });
  });
  
  /* Actualizar cantidad en el carrito cuando cambia el input en el product card */
  document.addEventListener('change', function (e) {
    var card = e.target.closest('.wim-product-card');
    if (!card || !card.classList.contains('in-cart')) return;
    var qtyInputEl = e.target.closest('quantity-input');
    if (!qtyInputEl || !qtyInputEl.classList.contains('wim-product-card__quantity')) return;
    
    var variantId = card.getAttribute('data-variant-id');
    var input = getActiveCardInput(qtyInputEl);
    if (!input) return;
    var quantity = parseFloat(input.value);
    
    // Guardar el estado de actualización activo para este variantId
    window.wimCardState.isUpdating[variantId] = true;
    window.wimCardState.pendingQuantities[variantId] = quantity;
    
    // Actualizar contadores optimísticamente e instantáneamente
    updateCartCounterOptimistically();
    updateCardOverlay(qtyInputEl, quantity);
    
    if (window.wimCardState.timers[variantId]) {
      clearTimeout(window.wimCardState.timers[variantId]);
    }
    
    var requestId = (window.wimCardState.latestRequestId[variantId] || 0) + 1;
    window.wimCardState.latestRequestId[variantId] = requestId;
    
    window.wimCardState.timers[variantId] = setTimeout(function () {
      var executionId = requestId;
      
      // Siempre obtener el carrito fresco para tener la key correcta
      fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (executionId !== window.wimCardState.latestRequestId[variantId]) return;
        window.wimCardState.cart = cart; // Actualizar caché
        
        var matchingItems = cart.items.filter(function (item) {
          return item.variant_id == variantId;
        });
        var cartItem = matchingItems[0];
        
        if (!cartItem) {
          // El ítem ya no está en el carrito
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
          syncProductCards(cart);
          return;
        }
        
        var targetQty = window.wimCardState.pendingQuantities[variantId];
        var isWeight = input.classList.contains('quantity__input-weight');
        
        var rawQty = isWeight ? Math.round(targetQty / parseFloat(input.getAttribute('step') || 1)) : parseInt(targetQty, 10);
        if (isNaN(rawQty)) {
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
          return;
        }
        
        var body = {
          id: cartItem.key,
          quantity: rawQty
        };
        var cartChangeUrl = '/cart/change.js';
        if (!isWeight && matchingItems.length > 1) {
          body = {
            updates: buildVariantQuantityUpdates(cart.items, variantId, rawQty)
          };
          cartChangeUrl = getCartUpdateUrl();
        }
        
        if (isWeight) {
          var units = qtyInputEl.getAttribute('data-units') ? qtyInputEl.getAttribute('data-units').split(',').map(function (u) { return u.trim(); }) : ['g', 'kg'];
          var pesoVal = targetQty >= 1 ? targetQty.toFixed(2) + ' ' + units[1] : (targetQty * 1000) + ' ' + units[0];
          var properties = {};
          if (cartItem.properties) {
            for (var prop in cartItem.properties) {
              if (prop !== 'peso' && prop !== '_weight_value') {
                properties[prop] = cartItem.properties[prop];
              }
            }
          }
          properties['peso'] = pesoVal;
          properties['_weight_value'] = targetQty;
          body.properties = properties;
        }
        
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        if (sectionsToBundle.length) {
          body.sections = sectionsToBundle;
          body.sections_url = window.location.pathname;
        }
        
        return fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (newCart) {
          if (executionId !== window.wimCardState.latestRequestId[variantId]) return;
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
          if (newCart.status && newCart.status !== 200) {
            console.error('[WimCard] cart/change.js error:', newCart);
            // Recuperar con el estado real del carrito
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          } else {
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: newCart });
          }
        });
      })
      .catch(function (err) {
        console.error('[WimCard] Error al actualizar el carrito:', err);
        if (executionId === window.wimCardState.latestRequestId[variantId]) {
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
        }
      });
    }, 400); // Debounce de 400ms
  });
  
  /* Permitir eliminar del carrito con el botón de menos cuando está en la cantidad mínima */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.wim-product-card__quantity button[name="minus"]');
    if (!button) return;
    var card = button.closest('.wim-product-card');
    if (!card || !card.classList.contains('in-cart')) return;
    
    var qtyInputEl = button.closest('quantity-input');
    var input = getActiveCardInput(qtyInputEl);
    if (!input) return;
    var val = parseFloat(input.value);
    var min = parseFloat(input.getAttribute('data-min') || input.min || 1);
    
    if (val <= min) {
      e.preventDefault();
      e.stopPropagation();
      
      var variantId = card.getAttribute('data-variant-id');
      // Cancelar cualquier temporizador pendiente para este variantId
      if (window.wimCardState.timers[variantId]) {
        clearTimeout(window.wimCardState.timers[variantId]);
      }
      var requestId = (window.wimCardState.latestRequestId[variantId] || 0) + 1;
      window.wimCardState.latestRequestId[variantId] = requestId;
      window.wimCardState.isUpdating[variantId] = true;
      window.wimCardState.pendingQuantities[variantId] = 0;
      
      // Actualizar contadores optimísticamente e instantáneamente
      updateCartCounterOptimistically();
      card.classList.remove('in-cart');
      
      var executionId = requestId;
      
      // Siempre obtener el carrito fresco para tener la key correcta
      fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (executionId !== window.wimCardState.latestRequestId[variantId]) return;
        window.wimCardState.cart = cart; // Actualizar caché
        
        var matchingItems = cart.items.filter(function (item) {
          return item.variant_id == variantId;
        });
        var cartItem = matchingItems[0];
        
        if (!cartItem) {
          // El ítem ya no está en el carrito
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
          syncProductCards(cart);
          return;
        }
        
        var body = {
          id: cartItem.key,
          quantity: 0
        };
        var cartChangeUrl = '/cart/change.js';
        if (matchingItems.length > 1) {
          body = {
            updates: buildVariantQuantityUpdates(cart.items, variantId, 0)
          };
          cartChangeUrl = getCartUpdateUrl();
        }
        
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        if (sectionsToBundle.length) {
          body.sections = sectionsToBundle;
          body.sections_url = window.location.pathname;
        }
        
        return fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (newCart) {
          if (executionId !== window.wimCardState.latestRequestId[variantId]) return;
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
          if (newCart.status && newCart.status !== 200) {
            console.error('[WimCard] Error al eliminar:', newCart);
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          } else {
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: newCart });
          }
        });
      })
      .catch(function (err) {
        console.error('[WimCard] Error al remover el producto:', err);
        if (executionId === window.wimCardState.latestRequestId[variantId]) {
          window.wimCardState.isUpdating[variantId] = false;
          delete window.wimCardState.pendingQuantities[variantId];
        }
      });
    }
  }, true);
  
  /* FLUSH DE CANTIDADES PENDIENTES AL SALIR DE LA PÁGINA O ABRIR CARRITO (Race Condition Fix) */
  function flushPendingCartUpdates() {
    if (!window.wimCardState || !window.wimCardState.pendingQuantities || !window.wimCardState.cart) return Promise.resolve();
    
    var pendingKeys = Object.keys(window.wimCardState.pendingQuantities);
    if (pendingKeys.length === 0) return Promise.resolve();
    
    var promises = [];
    
    pendingKeys.forEach(function (variantId) {
      var targetQty = window.wimCardState.pendingQuantities[variantId];
      if (targetQty === undefined) return;
      
      // Limpiar timer si existía
      if (window.wimCardState.timers && window.wimCardState.timers[variantId]) {
        clearTimeout(window.wimCardState.timers[variantId]);
        delete window.wimCardState.timers[variantId];
      }
      
      var matchingItems = window.wimCardState.cart.items.filter(function (item) {
        return item.variant_id == variantId;
      });
      var cartItem = matchingItems[0];
      
      if (!cartItem) return;
      
      var isWeight = false;
      var stepVal = 1;
      var input = null;
      var card = document.querySelector('.wim-product-card[data-variant-id="' + variantId + '"]');
      if (card) {
        var qtyInputEl = card.querySelector('quantity-input');
        if (qtyInputEl) {
          input = getActiveCardInput(qtyInputEl);
          if (input) {
            isWeight = input.classList.contains('quantity__input-weight');
            stepVal = parseFloat(input.getAttribute('step') || 1);
          }
        }
      }
      
      var rawQty = isWeight ? Math.round(targetQty / stepVal) : parseInt(targetQty, 10);
      if (isNaN(rawQty)) return; // No enviar si no es un número válido
      
      var body = {
        id: cartItem.key,
        quantity: rawQty
      };
      var cartChangeUrl = '/cart/change.js';
      if (!isWeight && matchingItems.length > 1) {
        body = {
          updates: buildVariantQuantityUpdates(window.wimCardState.cart.items, variantId, rawQty)
        };
        cartChangeUrl = getCartUpdateUrl();
      }
      
      if (isWeight && qtyInputEl) {
        var units = qtyInputEl.getAttribute('data-units') ? qtyInputEl.getAttribute('data-units').split(',').map(function (u) { return u.trim(); }) : ['g', 'kg'];
        var pesoVal = targetQty >= 1 ? targetQty.toFixed(2) + ' ' + units[1] : (targetQty * 1000) + ' ' + units[0];
        var properties = {};
        if (cartItem.properties) {
          for (var prop in cartItem.properties) {
            if (prop !== 'peso' && prop !== '_weight_value') {
              properties[prop] = cartItem.properties[prop];
            }
          }
        }
        properties['peso'] = pesoVal;
        properties['_weight_value'] = targetQty;
        if (cartItem.properties && cartItem.properties['preparación'] && cartItem.properties['preparación'] !== '') {
          properties['_janisCommerce_customerNote'] = cartItem.properties['preparación'];
        }
        // Eliminado el else para peso puro
        body.properties = properties;
      } else if (!isWeight && cartItem.properties && ((cartItem.properties['preparación'] && cartItem.properties['preparación'] !== '') || cartItem.properties['_janisCommerce_measurementUnit'] === 'kg')) {
        var properties = {};
        for (var prop in cartItem.properties) {
          properties[prop] = cartItem.properties[prop];
        }
        if (cartItem.properties['preparación'] && cartItem.properties['preparación'] !== '') {
          properties['_janisCommerce_customerNote'] = rawQty + 'u de ' + cartItem.properties['preparación'];
        } else {
          properties['_janisCommerce_customerNote'] = rawQty + ' un aprox.';
        }
        body.properties = properties;
      }
      
      var p = fetch(cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function (e) { console.error('[WimCard] Error en flush:', e); });
      
      promises.push(p);
      delete window.wimCardState.pendingQuantities[variantId];
    });
    
    return Promise.all(promises);
  }
  
  window.addEventListener('pagehide', flushPendingCartUpdates);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flushPendingCartUpdates();
    }
  });
  
  /* Interceptar clics a enlaces locales o al carrito para esperar el flush */
  document.addEventListener('click', function (e) {
    if (!window.wimCardState || !window.wimCardState.pendingQuantities || Object.keys(window.wimCardState.pendingQuantities).length === 0) return;
    
    var link = e.target.closest('a');
    var isLocalLink = false;
    var href = null;
    
    if (link && link.href) {
      try {
        var url = new URL(link.href, window.location.origin);
        var currentUrl = new URL(window.location.href);
        var isSamePageAndQuery = url.pathname === currentUrl.pathname && url.search === currentUrl.search;
        
        if (url.origin === window.location.origin && !isSamePageAndQuery && !link.hasAttribute('download') && link.target !== '_blank' && !link.href.startsWith('javascript:')) {
          isLocalLink = true;
          href = link.href;
        }
      } catch (err) { }
    }
    
    var isCartDrawerToggle = e.target.closest('#cart-icon-bubble, .header__icon--cart');
    
    if (isLocalLink || isCartDrawerToggle) {
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      document.body.style.cursor = 'wait';
      var originalTarget = e.target;
      
      flushPendingCartUpdates().then(function () {
        document.body.style.cursor = '';
        if (isLocalLink && !isCartDrawerToggle && href) {
          window.location.href = href;
        } else {
          // Remover temporalmente cantidades para evitar bucle al re-clicar
          window.wimCardState.pendingQuantities = {};
          originalTarget.click();
        }
      });
    }
  }, true);
}

/* ==========================================
WIM WISHLISTS CORE
========================================== */
/* Wishlists múltiples — Core */
(function () {
  'use strict';
  
  var COOKIE_KEY = 'shopify_wishlist';
  var MAX_LISTS = 5;
  var MAX_NAME_LEN = 20;
  var MAX_ITEMS_PER_LIST = 80;
  
  /* Estado en memoria */
  var lists = [];
  var dirty = false;
  var saving = false;
  var customerId = null;
  
  /* ---- Resolución de handle a partir del ID numérico ----
  El middleware persiste `products` como IDs numéricos (no handles). Al
  recargar la lista desde el metafield solo tenemos el ID, así que hay
  que resolver el handle real vía Storefront API antes de poder
  renderizar la tarjeta del producto o validar que sigue existiendo. */
  var PID_CACHE_KEY = 'wim_pid_handle_cache';
  
  function getPidCache() {
    try {
      return JSON.parse(localStorage.getItem(PID_CACHE_KEY) || '{}');
    } catch (e) { return {}; }
  }
  
  function getCachedHandle(pid) {
    var cache = getPidCache();
    return cache[pid] || null;
  }
  
  function setCachedHandles(map) {
    try {
      var cache = getPidCache();
      for (var pid in map) {
        if (map[pid]) cache[pid] = map[pid];
      }
      localStorage.setItem(PID_CACHE_KEY, JSON.stringify(cache));
    } catch (e) { /* localStorage llena o no disponible: ignorar */ }
  }
  
  function resolveHandlesByIds(pids) {
    if (!pids.length || !window.WimStorefrontToken || !window.WimShopDomain) {
      return Promise.resolve({});
    }
    
    var gids = [];
    pids.forEach(function (pid) {
      gids.push('gid://shopify/Product/' + pid);
      gids.push('gid://shopify/ProductVariant/' + pid);
    });
    
    var query = 'query resolveHandles($ids: [ID!]!) { nodes(ids: $ids) { ' +
    '... on Product { id handle } ' +
    '... on ProductVariant { id product { handle } } ' +
    '} }';
    
    return fetch('https://' + window.WimShopDomain + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.WimStorefrontToken
      },
      body: JSON.stringify({ query: query, variables: { ids: gids } })
    })
    .then(function (res) { return res.json(); })
    .then(function (json) {
      var result = {};
      var nodes = (json && json.data && json.data.nodes) || [];
      nodes.forEach(function (node) {
        if (!node) return;
        var idParts = node.id.split('/');
        var numericId = idParts[idParts.length - 1];
        var handle = node.handle || (node.product && node.product.handle);
        if (handle) result[numericId] = handle;
      });
      return result;
    })
    .catch(function (err) {
      console.error('[WimWishlists] Error resolviendo handles vía Storefront API:', err);
      return {};
    });
  }
  
  /* Resuelve en segundo plano los items que llegaron del metafield sin
  handle conocido (h === null) y actualiza la UI cuando termina.
  Nunca elimina items: si no se puede resolver, simplemente se queda
  sin renderizar hasta la próxima vez (ver wimCleanWishlist, que ignora
  los items sin handle en vez de tratarlos como productos eliminados). */
  function resolvePendingHandles() {
    var pending = [];
    lists.forEach(function (l) {
      l.items.forEach(function (item) {
        if (!item.h && item.v && pending.indexOf(item.v) === -1) {
          pending.push(item.v);
        }
      });
    });
    
    if (!pending.length) return;
    
    resolveHandlesByIds(pending).then(function (resolved) {
      if (!Object.keys(resolved).length) return;
      
      var changed = false;
      lists.forEach(function (l) {
        l.items.forEach(function (item) {
          if (!item.h && resolved[item.v]) {
            item.h = resolved[item.v];
            changed = true;
          }
        });
      });
      
      if (changed) {
        setCachedHandles(resolved);
        dispatch('handles-resolved');
        refreshHeartStates();
        document.dispatchEvent(new CustomEvent('wim-wishlists:handles-resolved'));
      }
    });
  }
  
  /* ---- Inicialización ---- */
  
  function init() {
    customerId = window.WIM_CUSTOMER_ID || null;
    var raw = window.WIM_WISHLISTS;
    
    if (customerId) {
      /* Usuario logueado: cargar desde metafield (puede estar vacío) */
      if (raw && typeof raw === 'string') {
        try { lists = JSON.parse(raw); } catch (e) { lists = []; }
      } else if (Array.isArray(raw)) {
        lists = raw;
      } else {
        /* Metafield aún no creado o vacío: arrancamos vacíos
        y la migración de localStorage (más abajo) lo rellenará */
        lists = [];
      }
    } else {
      /* Invitado: leer desde localStorage */
      try {
        var localRaw = localStorage.getItem('wim_wishlists_multi');
        lists = localRaw ? JSON.parse(localRaw) : [];
      } catch (e) { lists = []; }
    }
    
    /* Normalizar las listas si vienen en el formato del middleware (name, products)
    al formato interno esperado por la UI (n, items).
    IMPORTANTE: `products` son IDs numéricos de Shopify (no handles), así que
    aquí solo guardamos el ID (`v`). El handle (`h`) se resuelve aparte, de
    forma asíncrona, vía resolvePendingHandles() -- usando primero el caché
    local y si hace falta la Storefront API. Nunca se asume que el ID es un
    handle: eso era lo que causaba que wimCleanWishlist() los marcara como
    "producto no encontrado" y vaciara la lista automáticamente. */
    if (lists && lists.length > 0 && typeof lists[0].name !== 'undefined') {
      lists = lists.map(function (l) {
        return {
          id: l.id,
          n: l.name,
          items: (l.products || []).map(function (pId) {
            return { h: getCachedHandle(pId), v: pId, t: 'p', i: '' };
          })
        };
      });
    }
    
    var needsSave = false;
    
    if (customerId) {
      /* Migración para logueados que traen datos de invitado (localStorage) */
      try {
        var localRaw = localStorage.getItem('wim_wishlists_multi');
        if (localRaw) {
          var localLists = JSON.parse(localRaw);
          if (localLists && localLists.length > 0) {
            if (lists.length === 0) {
              lists = localLists;
            } else {
              /* Fusión deduplicada: si la lista existe por nombre, fusiona sus items;
              si no existe, la añade como lista nueva */
              localLists.forEach(function (ll) {
                var serverList = null;
                for (var k = 0; k < lists.length; k++) {
                  if (lists[k].n.toLowerCase() === ll.n.toLowerCase()) {
                    serverList = lists[k];
                    break;
                  }
                }
                if (!serverList) {
                  /* Lista nueva: añadir completa si hay espacio */
                  if (lists.length < MAX_LISTS) lists.push(ll);
                } else {
                  /* Lista duplicada: fusionar solo items que no existan ya */
                  ll.items.forEach(function (localItem) {
                    var alreadyIn = serverList.items.some(function (si) {
                      return si.h === localItem.h;
                    });
                    if (!alreadyIn && serverList.items.length < MAX_ITEMS_PER_LIST) {
                      serverList.items.push(localItem);
                    }
                  });
                }
              });
            }
            needsSave = true;
          }
        }
        /* Siempre limpiar localStorage tras procesar (evita re-fusión en próxima sesión) */
        localStorage.removeItem('wim_wishlists_multi');
      } catch (e) {
        /* Si falla el parse, limpiar igualmente */
        try { localStorage.removeItem('wim_wishlists_multi'); } catch (e2) { }
      }
    }
    
    /* Migración cookie antigua (para todos) */
    if (lists.length === 0) {
      var cookieList = readCookie();
      if (cookieList.length > 0) {
        lists.push({
          n: 'Mis listas',
          items: cookieList.map(function (handle) { return { h: handle, v: 0, t: 'p' }; })
        });
        needsSave = true;
        clearCookie();
      }
    }
    
    if (needsSave) {
      dirty = true;
      setTimeout(function () { save(); }, 500); // Auto-save after init
    }
    
    dispatch('init');
    resolvePendingHandles();
  }
  
  /* ---- Lectura de cookie (fallback para no logueados) ---- */
  
  function readCookie() {
    var match = document.cookie.split('; ').find(function (c) {
      return c.startsWith(COOKIE_KEY + '=');
    });
    return match ? match.split('=')[1].split(',').filter(Boolean) : [];
  }
  
  function writeCookie(handles) {
    if (handles.length) {
      var exp = new Date(Date.now() + 30 * 864e5).toUTCString();
      document.cookie = COOKIE_KEY + '=' + handles.join(',') + '; expires=' + exp + '; path=/';
    } else {
      clearCookie();
    }
  }
  
  function clearCookie() {
    document.cookie = COOKIE_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
  
  /* ---- CRUD de listas ---- */
  
  function getLists() {
    return lists;
  }
  
  function getList(index) {
    return lists[index] || null;
  }
  
  function createList(name) {
    name = (name || '').trim().substring(0, MAX_NAME_LEN);
    if (!name) return { ok: false, error: 'Nombre vacío' };
    if (lists.length >= MAX_LISTS) return { ok: false, error: 'Máximo ' + MAX_LISTS + ' listas' };
    
    /* Evitar nombres duplicados */
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].n.toLowerCase() === name.toLowerCase()) {
        return { ok: false, error: 'Ya existe una lista con ese nombre' };
      }
    }
    
    lists.push({ n: name, items: [] });
    dirty = true;
    dispatch('list-created');
    return { ok: true, index: lists.length - 1 };
  }
  
  function renameList(index, newName) {
    newName = (newName || '').trim().substring(0, MAX_NAME_LEN);
    if (!newName) return { ok: false, error: 'Nombre vacío' };
    if (!lists[index]) return { ok: false, error: 'Lista no encontrada' };
    
    for (var i = 0; i < lists.length; i++) {
      if (i !== index && lists[i].n.toLowerCase() === newName.toLowerCase()) {
        return { ok: false, error: 'Ya existe una lista con ese nombre' };
      }
    }
    
    lists[index].n = newName;
    dirty = true;
    dispatch('list-renamed');
    return { ok: true };
  }
  
  function deleteList(index) {
    if (!lists[index]) return { ok: false, error: 'Lista no encontrada' };
    lists.splice(index, 1);
    dirty = true;
    dispatch('list-deleted');
    return { ok: true };
  }
  
  /* ---- Items dentro de listas ---- */
  
  function addItem(listIndex, handle, variantId, type, imgUrl) {
    var list = lists[listIndex];
    if (!list) return { ok: false, error: 'Lista no encontrada' };
    if (list.items.length >= MAX_ITEMS_PER_LIST) {
      return { ok: false, error: 'Máximo ' + MAX_ITEMS_PER_LIST + ' productos por lista' };
    }
    
    /* Evitar duplicados: comparar por handle */
    for (var i = 0; i < list.items.length; i++) {
      if (list.items[i].h === handle) {
        return { ok: false, error: 'Ya está en la lista' };
      }
    }
    
    list.items.push({ h: handle, v: variantId || 0, t: type || 'p', i: imgUrl || '' });
    dirty = true;
    dispatch('item-added');
    return { ok: true };
  }
  
  function removeItem(listIndex, handle) {
    var list = lists[listIndex];
    if (!list) return { ok: false, error: 'Lista no encontrada' };
    
    var idx = -1;
    for (var i = 0; i < list.items.length; i++) {
      if (list.items[i].h === handle) { idx = i; break; }
    }
    if (idx === -1) return { ok: false, error: 'Producto no encontrado' };
    
    var removed = list.items.splice(idx, 1)[0];
    dirty = true;
    dispatch('item-removed', handle);
    return { ok: true, removed: removed, index: idx };
  }
  
  /**
  * Actualiza las listas de un producto según los checkboxes del picker.
  * @param {string} handle - Handle del producto
  * @param {number} variantId - ID de la variante
  * @param {string} type - 'v' o 'p'
  * @param {number[]} selectedIndexes - Índices de las listas donde debe estar
  */
  function setItemLists(handle, variantId, type, selectedIndexes) {
    for (var i = 0; i < lists.length; i++) {
      var isSelected = selectedIndexes.indexOf(i) !== -1;
      var existingIdx = -1;
      
      for (var j = 0; j < lists[i].items.length; j++) {
        if (lists[i].items[j].h === handle) { existingIdx = j; break; }
      }
      
      if (isSelected && existingIdx === -1) {
        if (lists[i].items.length < MAX_ITEMS_PER_LIST) {
          lists[i].items.push({ h: handle, v: variantId || 0, t: type || 'p', i: pickerState.imgUrl || '' });
        }
      } else if (!isSelected && existingIdx !== -1) {
        lists[i].items.splice(existingIdx, 1);
      }
    }
    dirty = true;
    dispatch('item-lists-updated');
  }
  
  /* ---- Consultas ---- */
  
  function isInAnyList(handle) {
    for (var i = 0; i < lists.length; i++) {
      for (var j = 0; j < lists[i].items.length; j++) {
        if (lists[i].items[j].h === handle) return true;
      }
    }
    return false;
  }
  
  function getListsForItem(handle) {
    var result = [];
    for (var i = 0; i < lists.length; i++) {
      for (var j = 0; j < lists[i].items.length; j++) {
        if (lists[i].items[j].h === handle) {
          result.push(i);
          break;
        }
      }
    }
    return result;
  }
  
  function isDirty() {
    return dirty;
  }
  
  /* ---- Persistencia ---- */
  
  function save(callback) {
    if (!customerId) {
      /* Usuarios no logueados: guardar estructura completa en localStorage */
      localStorage.setItem('wim_wishlists_multi', JSON.stringify(lists));
      dirty = false;
      dispatch('saved');
      if (callback) callback({ ok: true });
      return;
    }
    
    if (saving) {
      if (callback) callback({ ok: false, error: 'Guardado en progreso' });
      return;
    }
    
    /* Si no está logueado, guardar en local y simular éxito (sin POST) */
    if (!customerId) {
      try {
        localStorage.setItem('wim_wishlists_multi', JSON.stringify(lists));
      } catch (e) { }
      dirty = false;
      dispatch('saved');
      if (callback) callback({ ok: true });
      return;
    }
    
    /* Verificar que la App está instalada y activa (inyecta window.WimWishlistApp) */
    if (!window.WimWishlistApp || !window.WimWishlistApp.save) {
      if (callback) callback({ ok: false, error: 'App de Wishlist no disponible. Asegúrate de que la App está instalada y el bloque está activo en el Theme.' });
      return;
    }
    
    saving = true;
    dispatch('saving');
    
    /* Delegar toda la comunicación HTTP a la App.
    El Theme le pasa los datos en formato interno y la App se encarga
    de transformarlos, validarlos y enviarlos al middleware. */
    console.log('[WIM] Ejecutando save()', {
      customerId: customerId,
      lists: lists,
      appDisponible: !!window.WimWishlistApp,
      hasSaveFunction: !!(window.WimWishlistApp && window.WimWishlistApp.save)
    });
    window.WimWishlistApp.save(customerId, lists, function (res) {
      saving = false;
      if (res.ok) {
        dirty = false;
        dispatch('saved');
      } else {
        dispatch('save-error');
        console.error('[WimWishlists] Error al guardar:', res.error);
      }
      if (callback) callback(res);
    });
  }
  
  /* ---- Eventos ---- */
  
  function dispatch(action, payload) {
    document.dispatchEvent(new CustomEvent('wim-wishlists:updated', {
      detail: { action: action, lists: lists, dirty: dirty, payload: payload }
    }));
  }
  
  /* ---- Picker (modal selector de lista) ---- */
  
  var pickerModal = null;
  var pickerState = { handle: '', variantId: 0, type: 'p', imgUrl: '' };
  
  function toggleDefaultList(handle, variantId, type, imgUrl) {
    /* Si no hay ninguna lista, crear "Mis listas" */
    if (lists.length === 0) {
      lists.push({ n: 'Mis listas', items: [] });
    }
    
    /* Buscar la lista "Mis listas" por nombre para añadir ahí por defecto,
    si no existe usamos el índice 0 (la primera lista que exista) */
    var defaultIdx = 0;
    for (var i = 0; i < lists.length; i++) {
      if (lists[i].n.toLowerCase() === 'mis listas') {
        defaultIdx = i;
        break;
      }
    }
    
    var inList = isInAnyList(handle);
    if (inList) {
      for (var i = 0; i < lists.length; i++) {
        removeItem(i, handle);
      }
    } else {
      addItem(defaultIdx, handle, variantId, type, imgUrl);
    }
    
    save(function () {
      refreshHeartStates();
      if (!inList) {
        window.wimShowWishlistToast && window.wimShowWishlistToast(lists[defaultIdx].n);
      }
    });
  }
  
  function openPicker(handle, variantId, type, imgUrl) {
    pickerState.handle = handle;
    pickerState.variantId = variantId || 0;
    pickerState.type = type || 'p';
    pickerState.imgUrl = imgUrl || '';
    
    if (!pickerModal) {
      pickerModal = document.getElementById('wim-wishlist-picker');
    }
    
    /* Fallback si no hay modal picker en el DOM */
    if (!pickerModal) {
      toggleDefaultList(handle, variantId, type, imgUrl);
      return;
    }
    
    /* Si no hay ninguna lista, crear "Mis listas" por defecto para que aparezca como opción */
    if (lists.length === 0) {
      lists.push({ n: 'Mis listas', items: [] });
    }
    
    renderPickerContent();
    showPickerMainView();
    
    /* Reset mobile bottom sheet state */
    var container = pickerModal.querySelector('.wim-wishlist-picker__container');
    if (container && window.innerWidth < 768) {
      container.style.transition = 'none';
      container.style.height = '60vh';
      setTimeout(function () {
        container.style.transition = 'transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), height 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)';
      }, 50);
    }
    
    pickerModal.removeAttribute('hidden');
    
    /* Prevent layout shifting by compensating for scrollbar width */
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
    document.body.classList.add('overflow-hidden');
  }
  
  function closePicker() {
    if (!pickerModal) return;
    pickerModal.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }
  
  function showPickerMainView() {
    if (!pickerModal) return;
    var mainView = pickerModal.querySelector('.wim-wishlist-picker__view-main');
    var createView = pickerModal.querySelector('.wim-wishlist-picker__view-create');
    if (mainView) mainView.style.display = 'block';
    if (createView) createView.style.display = 'none';
  }
  
  function showPickerCreateView() {
    if (!pickerModal) return;
    var mainView = pickerModal.querySelector('.wim-wishlist-picker__view-main');
    var createView = pickerModal.querySelector('.wim-wishlist-picker__view-create');
    if (mainView) mainView.style.display = 'none';
    if (createView) {
      createView.style.display = 'block';
      var input = createView.querySelector('.wim-wishlist-picker__new-input');
      var clearBtn = createView.querySelector('.wim-wishlist-picker__clear-input');
      var createBtn = createView.querySelector('.js-wim-picker-create');
      if (input) {
        input.value = '';
        setTimeout(function () { input.focus(); }, 50);
      }
      if (createBtn) {
        createBtn.disabled = true;
      }
      if (clearBtn) clearBtn.style.display = 'none';
      
      var errorEl = createView.querySelector('.wim-wishlist-picker__new-error');
      if (errorEl) errorEl.style.display = 'none';
    }
  }
  
  function renderPickerContent() {
    var body = pickerModal.querySelector('.wim-wishlist-picker__body');
    if (!body) return;
    
    var currentLists = getListsForItem(pickerState.handle);
    var html = '';
    
    /* Acceso a crear nueva lista: Barra superior separada de ancho completo */
    html += '<button type="button" class="wim-wishlist-picker__create-bar js-wim-picker-show-create">';
    html += '  <div class="wim-wishlist-picker__create-icon">';
    html += '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
    html += '  </div>';
    html += '  <span class="wim-wishlist-picker__create-label">Crear nueva lista</span>';
    html += '</button>';
    
    html += '<div class="wim-wishlist-picker__grid">';
    
    /* Tarjetas de listas existentes */
    for (var i = 0; i < lists.length; i++) {
      var isSaved = currentLists.indexOf(i) !== -1;
      var activeClass = isSaved ? ' is-active' : '';
      var listItems = lists[i].items || [];
      
      html += '<div class="wim-wishlist-picker__card js-wim-list-select' + activeClass + '" data-list-index="' + i + '">';
      
      if (listItems.length === 0) {
        /* Lista sin productos: Icono neutro de marcador */
        html += '  <div class="wim-wishlist-picker__card-icon-wrapper">';
        html += '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>';
        html += '  </div>';
      } else {
        /* Lista con productos: Mini galería 2x2 */
        html += '  <div class="wim-wishlist-picker__card-gallery">';
        for (var k = 0; k < 4; k++) {
          var item = listItems[k];
          if (item && item.i) {
            html += '<div class="wim-wishlist-picker__card-img"><img src="' + escapeHtml(item.i) + '" alt="" loading="lazy"></div>';
          } else if (item && item.h) {
            html += '<div class="wim-wishlist-picker__card-img" data-picker-handle="' + escapeHtml(item.h) + '"></div>';
          } else {
            html += '<div class="wim-wishlist-picker__card-img wim-wishlist-picker__card-img--empty"></div>';
          }
        }
        html += '  </div>';
      }
      
      /* Info */
      html += '  <div class="wim-wishlist-picker__card-info">';
      html += '    <span class="wim-wishlist-picker__card-name">' + escapeHtml(lists[i].n) + '</span>';
      html += '    <span class="wim-wishlist-picker__card-count">' + listItems.length + ' producto' + (listItems.length !== 1 ? 's' : '') + '</span>';
      html += '  </div>';
      
      /* Si ya está guardado, icono de check */
      if (isSaved) {
        html += '<div class="wim-wishlist-picker__card-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg></div>';
      }
      html += '</div>';
    }
    
    html += '</div>';
    body.innerHTML = html;
    
    /* Cargar imágenes faltantes de Shopify via /products/handle.js */
    body.querySelectorAll('[data-picker-handle]').forEach(function (slot) {
      var h = slot.getAttribute('data-picker-handle');
      fetch('/products/' + h + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (p) {
        var src = p && p.featured_image ? p.featured_image : null;
        if (src && src.indexOf('//') === 0) src = 'https:' + src;
        if (src && src.indexOf('?') !== -1) src = src.split('?')[0];
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = h;
          img.loading = 'lazy';
          slot.innerHTML = '';
          slot.appendChild(img);
          slot.classList.remove('wim-wishlist-picker__card-img--empty');
          
          for (var l = 0; l < lists.length; l++) {
            for (var m = 0; m < lists[l].items.length; m++) {
              if (lists[l].items[m].h === h) {
                lists[l].items[m].i = src;
              }
            }
          }
        } else {
          slot.classList.add('wim-wishlist-picker__card-img--empty');
        }
      })
      .catch(function () { slot.classList.add('wim-wishlist-picker__card-img--empty'); });
    });
  }
  
  function handleListSelect(index) {
    var res = addItem(index, pickerState.handle, pickerState.variantId, pickerState.type, pickerState.imgUrl);
    
    if (res.ok) {
      /* Auto-save */
      save(function (result) {
        if (result.ok) {
          window.wimShowWishlistToast && window.wimShowWishlistToast(lists[index].n);
          refreshHeartStates();
        } else {
          window.wimShowWishlistErrorToast && window.wimShowWishlistErrorToast(result.error);
        }
      });
      closePicker();
    } else if (res.error === 'Ya está en la lista') {
      /* Si hace clic y ya estaba, lo quitamos (toggle) */
      var removedRes = removeItem(index, pickerState.handle);
      var removedItem = removedRes ? removedRes.removed : null;
      var removedIndex = removedRes ? removedRes.index : 0;
      var listName = (lists[index] && lists[index].n) ? lists[index].n : 'la lista';
      var savedHandle = pickerState.handle;
      var savedVariantId = pickerState.variantId;
      var savedType = pickerState.type;
      var savedImg = pickerState.imgUrl;
      
      save(function (result) {
        if (result && result.ok) {
          refreshHeartStates();
        }
      });
      closePicker();
      
      if (window.wimShowUndoToast) {
        window.wimShowUndoToast('Eliminado de ' + listName, 'Deshacer', function () {
          if (removedItem) {
            var targetList = lists[index];
            if (targetList) {
              targetList.items.splice(removedIndex, 0, removedItem);
            }
          } else {
            addItem(index, savedHandle, savedVariantId, savedType, savedImg);
          }
          save(function () {
            refreshHeartStates();
          });
        });
      }
    } else {
      window.wimShowWishlistErrorToast && window.wimShowWishlistErrorToast(res.error);
    }
  }
  function handlePickerCreateList() {
    var input = pickerModal.querySelector('.wim-wishlist-picker__new-input');
    if (!input) return;
    
    var name = input.value.trim();
    if (!name) return;
    
    var result = createList(name);
    if (result.ok) {
      input.value = '';
      /* Auto-guardar en la nueva lista */
      handleListSelect(result.index);
    } else {
      /* Mostrar error inline */
      var errorEl = pickerModal.querySelector('.wim-wishlist-picker__new-error');
      if (errorEl) {
        errorEl.textContent = result.error;
        errorEl.style.display = 'block';
        setTimeout(function () { errorEl.style.display = 'none'; }, 3000);
      }
    }
  }
  
  /* Bind de eventos del picker (se ejecuta una vez) */
  function bindPickerEvents() {
    if (!pickerModal) {
      pickerModal = document.getElementById('wim-wishlist-picker');
    }
    if (!pickerModal) return;
    
    /* Event delegator para las listas y cerrar */
    pickerModal.addEventListener('click', function (e) {
      if (e.target === pickerModal || e.target.classList.contains('wim-wishlist-picker__overlay') || e.target.closest('.js-wim-picker-close')) {
        closePicker();
        return;
      }
      
      if (e.target.closest('.js-wim-picker-show-main')) {
        showPickerMainView();
        return;
      }
      
      var selectCard = e.target.closest('.js-wim-list-select');
      if (selectCard) {
        var idx = parseInt(selectCard.dataset.listIndex, 10);
        handleListSelect(idx);
      }
      
      var createCard = e.target.closest('.js-wim-picker-show-create');
      if (createCard) {
        showPickerCreateView();
      }
    });
    
    /* Crear lista nueva */
    var createBtn = pickerModal.querySelector('.js-wim-picker-create');
    if (createBtn) createBtn.addEventListener('click', handlePickerCreateList);
    
    /* Input events */
    var createInput = pickerModal.querySelector('.wim-wishlist-picker__new-input');
    var clearInputBtn = pickerModal.querySelector('.wim-wishlist-picker__clear-input');
    
    if (createInput) {
      createInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (this.value.trim().length > 0) {
            handlePickerCreateList();
          }
        }
      });
      createInput.addEventListener('input', function () {
        var hasText = this.value.trim().length > 0;
        if (clearInputBtn) {
          clearInputBtn.style.display = this.value.length > 0 ? 'flex' : 'none';
        }
        if (createBtn) {
          createBtn.disabled = !hasText;
        }
      });
    }
    
    if (clearInputBtn && createInput) {
      clearInputBtn.addEventListener('click', function () {
        createInput.value = '';
        createInput.focus();
        this.style.display = 'none';
        if (createBtn) {
          createBtn.disabled = true;
        }
      });
    }
    
    /* Bottom Sheet Touch Physics (Mobile Only) */
    var dragHandle = pickerModal.querySelector('.wim-wishlist-picker__drag-handle');
    var pickerContainer = pickerModal.querySelector('.wim-wishlist-picker__container');
    
    if (dragHandle && pickerContainer) {
      var touchStartY = 0;
      var initialHeight = 0;
      var isDragging = false;
      
      dragHandle.addEventListener('touchstart', function (e) {
        if (window.innerWidth >= 768) return;
        isDragging = true;
        touchStartY = e.touches[0].clientY;
        initialHeight = pickerContainer.offsetHeight;
        pickerContainer.style.transition = 'none';
        pickerContainer.style.willChange = 'height';
      }, { passive: true });
      
      dragHandle.addEventListener('touchmove', function (e) {
        if (!isDragging || window.innerWidth >= 768) return;
        e.preventDefault();
        var deltaY = e.touches[0].clientY - touchStartY;
        var newHeight = initialHeight - deltaY;
        var maxHeight = window.innerHeight * 0.95;
        if (newHeight > maxHeight) newHeight = maxHeight;
        pickerContainer.style.height = newHeight + 'px';
      }, { passive: false });
      
      dragHandle.addEventListener('touchend', function (e) {
        if (!isDragging || window.innerWidth >= 768) return;
        isDragging = false;
        pickerContainer.style.transition = 'transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), height 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)';
        pickerContainer.style.willChange = '';
        
        var currentHeight = pickerContainer.offsetHeight;
        var windowHeight = window.innerHeight;
        
        if (currentHeight > windowHeight * 0.75) {
          pickerContainer.style.height = '95vh';
        } else if (currentHeight < windowHeight * 0.45) {
          closePicker();
          setTimeout(function () { pickerContainer.style.height = '60vh'; }, 300);
        } else {
          pickerContainer.style.height = '60vh';
        }
      });
    }
  }
  
  /* ---- Sincronización de corazones ---- */
  
  function refreshHeartStates() {
    /* PLP: .wishlist-element */
    document.querySelectorAll('.wishlist-element[handler]').forEach(function (el) {
      var handle = el.getAttribute('handler');
      el.classList.toggle('active', isInAnyList(handle));
    });
    
    /* PDP: .wim-pdp-wishlist */
    document.querySelectorAll('.wim-pdp-wishlist[data-handle]').forEach(function (el) {
      var handle = el.getAttribute('data-handle');
      el.classList.toggle('active', isInAnyList(handle));
    });
  }
  
  /* ---- Utilidades ---- */
  
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
  
  /* ---- API pública ---- */
  
  window.WimWishlists = {
    init: init,
    getLists: getLists,
    getList: getList,
    createList: createList,
    renameList: renameList,
    deleteList: deleteList,
    addItem: addItem,
    removeItem: removeItem,
    setItemLists: setItemLists,
    isInAnyList: isInAnyList,
    getListsForItem: getListsForItem,
    isDirty: isDirty,
    save: save,
    openPicker: openPicker,
    toggleDefaultList: toggleDefaultList,
    closePicker: closePicker,
    refreshHeartStates: refreshHeartStates,
    bindPickerEvents: bindPickerEvents,
    getCustomerId: function () { return customerId; },
    MAX_LISTS: MAX_LISTS,
    MAX_NAME_LEN: MAX_NAME_LEN,
    MAX_ITEMS_PER_LIST: MAX_ITEMS_PER_LIST
  };
  
  /* Inicializar cuando DOM esté listo */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      bindPickerEvents();
      refreshHeartStates();
    });
  } else {
    init();
    bindPickerEvents();
    refreshHeartStates();
  }
})();


/* ==========================================
WIM WISHLISTS DASHBOARD
========================================== */
/* 
Dashboard de Wishlists Múltiples (SPA UI)
Requiere wim-wishlists.js 
*/

(function () {
  'use strict';
  
  var container, headerEl, contentEl, breadcrumbEl, currentNameEl, titleEl, backBtn, createBtn, addAllBtn, saveBar, saveBtn;
  var modal, modalTitle, modalInput, modalText, modalSubmit, modalCloses;
  var searchModal, searchInput, searchResults, searchLoading, searchCloses;
  var searchTimeout = null;
  var modalCallback = null;
  var currentView = 'dashboard'; /* 'dashboard' o index de lista (0, 1, 2...) */
  
  function init() {
    container = document.querySelector('.wim-main-wishlists');
    if (!container) return;
    
    headerEl = container.querySelector('.wim-main-wishlists__header');
    contentEl = document.getElementById('wim-wishlists-content');
    breadcrumbEl = document.getElementById('wim-wishlists-breadcrumb');
    currentNameEl = document.getElementById('wim-wishlists-current-name');
    titleEl = container.querySelector('.wim-main-wishlists__title');
    backBtn = container.querySelector('.js-wim-dashboard-back');
    createBtn = document.getElementById('wim-wishlists-create-btn');
    addAllBtn = document.getElementById('wim-wishlists-add-all-btn');
    saveBar = document.getElementById('wim-wishlists-save-bar');
    saveBtn = saveBar.querySelector('.js-wim-dashboard-save');
    
    // Elementos del Modal
    modal = document.getElementById('wim-wishlists-modal');
    modalTitle = document.getElementById('wim-wishlists-modal-title');
    modalInput = document.getElementById('wim-wishlists-modal-input');
    modalText = document.getElementById('wim-wishlists-modal-text');
    modalSubmit = document.getElementById('wim-wishlists-modal-submit');
    modalCloses = document.querySelectorAll('.js-wim-modal-close');
    
    // Elementos del Modal de Búsqueda
    searchModal = document.getElementById('wim-wishlists-search-modal');
    searchInput = document.getElementById('wim-wishlists-search-input');
    searchResults = document.getElementById('wim-wishlists-search-results');
    searchLoading = document.getElementById('wim-wishlists-search-loading');
    searchCloses = document.querySelectorAll('.js-wim-search-close');
    
    if (!window.WimWishlists) {
      console.error('[WimWishlistDashboard] wim-wishlists.js no cargado');
      return;
    }
    
    /* Bind events */
    backBtn.addEventListener('click', showDashboard);
    createBtn.addEventListener('click', handleCreateList);
    saveBtn.addEventListener('click', handleSave);
    addAllBtn.addEventListener('click', handleAddAllToCart);
    
    if (modal) {
      modalCloses.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.classList.contains('wim-wishlists-modal__overlay')) {
          closeModal();
        }
      });
      modalSubmit.addEventListener('click', handleModalSubmit);
      modalInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') handleModalSubmit();
        if (e.key === 'Escape') closeModal();
      });
    }
    
    if (searchModal) {
      searchCloses.forEach(function (btn) {
        btn.addEventListener('click', closeSearchModal);
      });
      searchModal.addEventListener('click', function (e) {
        if (e.target === searchModal || e.target.classList.contains('wim-wishlists-modal__overlay')) {
          closeSearchModal();
        }
      });
      searchInput.addEventListener('input', handleSearchInput);
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSearchModal();
      });
    }
    
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchModal && !searchModal.hasAttribute('hidden')) closeSearchModal();
        if (modal && !modal.hasAttribute('hidden')) closeModal();
        if (pickerModal && !pickerModal.hasAttribute('hidden')) closePicker();
      }
    });
    
    document.addEventListener('wim-wishlists:updated', function (e) {
      updateSaveBar(e.detail.dirty);
      if (currentView === 'dashboard') {
        renderDashboard(e.detail.lists);
      } else {
        /* Si eliminamos la lista actual, volvemos */
        if (!e.detail.lists[currentView]) {
          showDashboard();
        } else {
          /* Para evitar refetch completo si solo cambia un item, 
          en un caso ideal actualizaríamos el DOM local.
          Por simplicidad y dado que la fuente de verdad es wim-wishlists.js, re-renderizamos. */
          if (e.detail.action === 'item-removed') {
            var handleToRemove = e.detail.payload;
            if (handleToRemove) {
              var btnToRemove = contentEl.querySelector('.js-wim-remove-item[data-handle="' + handleToRemove + '"]');
              if (btnToRemove) {
                var wrapper = btnToRemove.closest('.wim-wishlist-item-wrapper');
                if (wrapper) wrapper.remove();
              }
            }
            
            var list = window.WimWishlists.getList(currentView);
            if (!list || list.items.length === 0) {
              renderListView(currentView); // Para mostrar estado vacío si ya no quedan
            }
          }
        }
      }
    });
    
    /* Render inicial */
    renderDashboard(window.WimWishlists.getLists());
  }
  
  function updateSaveBar(isDirty) {
    if (saveBar) {
      saveBar.setAttribute('hidden', '');
      saveBar.style.display = 'none';
    }
  }
  
  function openModal(title, defaultText, callback) {
    if (!modal) return;
    modalTitle.textContent = title;
    
    if (modalText) modalText.setAttribute('hidden', '');
    modalInput.removeAttribute('hidden');
    modalInput.value = defaultText || '';
    
    var submitBtn = document.getElementById('wim-wishlists-modal-submit');
    if (submitBtn) {
      submitBtn.textContent = 'Guardar';
      submitBtn.classList.remove('wim-wishlists-modal__btn-submit--danger');
    }
    
    modalCallback = callback;
    modal.removeAttribute('hidden');
    setTimeout(function () { modalInput.focus(); }, 50);
  }
  
  function openConfirmModal(title, text, confirmBtnText, callback) {
    if (!modal) return;
    modalTitle.textContent = title;
    
    if (modalText) {
      modalText.innerHTML = text;
      modalText.removeAttribute('hidden');
    }
    modalInput.setAttribute('hidden', '');
    
    var submitBtn = document.getElementById('wim-wishlists-modal-submit');
    if (submitBtn) {
      submitBtn.textContent = confirmBtnText || 'Confirmar';
      submitBtn.classList.add('wim-wishlists-modal__btn-submit--danger');
    }
    
    modalCallback = function () {
      if (callback) callback(true);
    };
    
    modal.removeAttribute('hidden');
  }
  
  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modalCallback = null;
  }
  
  function handleModalSubmit() {
    if (modalInput.hasAttribute('hidden')) {
      if (modalCallback) modalCallback();
      closeModal();
      return;
    }
    
    var val = modalInput.value.trim();
    if (!val) return;
    if (modalCallback) {
      modalCallback(val);
    }
    closeModal();
  }
  
  function handleSave() {
    saveBtn.textContent = 'Guardando...';
    saveBtn.disabled = true;
    
    window.WimWishlists.save(function (res) {
      saveBtn.textContent = 'Guardar cambios';
      saveBtn.disabled = false;
      if (res.ok) {
        if (window.wimShowToast) window.wimShowToast('Cambios guardados correctamente');
      } else {
        if (window.wimShowToast) window.wimShowToast('Error al guardar: ' + res.error);
      }
    });
  }
  
  function handleCreateList() {
    openModal('Nueva lista', '', function (name) {
      var res = window.WimWishlists.createList(name);
      if (!res.ok) {
        if (window.wimShowWishlistErrorToast) window.wimShowWishlistErrorToast(res.error);
        else alert(res.error);
      } else {
        showList(res.index);
      }
    });
  }
  
  function renderDashboard(lists) {
    currentView = 'dashboard';
    if (headerEl) headerEl.removeAttribute('hidden');
    titleEl.removeAttribute('hidden');
    breadcrumbEl.setAttribute('hidden', '');
    createBtn.removeAttribute('hidden');
    addAllBtn.setAttribute('hidden', '');
    
    if (lists.length === 0) {
      contentEl.innerHTML = `
        <div class="wim-wishlists-empty">
          <svg class="wim-wishlists-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <p class="wim-wishlists-empty__text">No tienes listas de favoritos.</p>
          <button class="wim-main-wishlists__btn-create js-wim-dashboard-create-empty">
            Crear mi primera lista
          </button>
        </div>
      `;
      var emptyCreate = contentEl.querySelector('.js-wim-dashboard-create-empty');
      if (emptyCreate) emptyCreate.addEventListener('click', handleCreateList);
      return;
    }
    
    var html = '<div class="wim-wishlists-grid">';
    lists.forEach(function (list, idx) {
      var listImages = list.items.slice(0, 4).map(function (item) { return item.i; });
      html += '<div class="wim-wishlist-card" data-index="' + idx + '">';
      
      /* Grilla 2x2 o Estado Vacío Dedicado */
      if (list.items.length === 0) {
        html += '  <div class="wim-wishlist-card__gallery wim-wishlist-card__gallery--empty">';
        html += '    <div class="wim-wishlist-card__empty-state">';
        html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" /></svg>';
        html += '      <span class="wim-wishlist-card__empty-title">Sin productos aún</span>';
        html += '      <span class="wim-wishlist-card__empty-sub">Explora y añade a esta lista</span>';
        html += '    </div>';
        html += '  </div>';
      } else {
        html += '  <div class="wim-wishlist-card__gallery">';
        for (var k = 0; k < 4; k++) {
          if (listImages[k]) {
            html += '<div class="wim-wishlist-card__img">';
            html += '  <img src="' + escapeHtml(listImages[k]) + '" alt="Producto" loading="lazy">';
            html += '</div>';
          } else {
            var item = list.items[k];
            if (item && item.h) {
              html += '<div class="wim-wishlist-card__img" data-load-handle="' + item.h + '"></div>';
            } else {
              html += '<div class="wim-wishlist-card__img wim-wishlist-card__img--placeholder">';
              html += '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
              html += '</div>';
            }
          }
        }
        html += '  </div>';
      }
      
      /* Info + Indicador de Navegación */
      html += '  <div class="wim-wishlist-card__info">';
      html += '    <div class="wim-wishlist-card__text">';
      html += '      <h3 class="wim-wishlist-card__name">' + escapeHtml(list.n) + '</h3>';
      html += '      <p class="wim-wishlist-card__count">' + list.items.length + ' producto' + (list.items.length !== 1 ? 's' : '') + '</p>';
      html += '    </div>';
      html += '    <div class="wim-wishlist-card__arrow" aria-hidden="true">';
      html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg>';
      html += '    </div>';
      html += '  </div>';
      
      /* Acciones rápidas (editar, carrito, eliminar) */
      html += '  <div class="wim-wishlist-card__actions">';
      if (list.items.length > 0) {
        html += '    <button class="wim-wishlist-card__btn js-wim-list-cart" title="Añadir lista a la cesta" aria-label="Añadir lista a la cesta">';
        html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        html += '    </button>';
      }
      html += '    <button class="wim-wishlist-card__btn js-wim-list-edit" title="Renombrar lista" aria-label="Renombrar">';
      html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>';
      html += '    </button>';
      html += '    <button class="wim-wishlist-card__btn js-wim-list-delete" title="Eliminar lista" aria-label="Eliminar">';
      html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
      html += '    </button>';
      html += '  </div>';
      html += '</div>';
    });
    html += '</div>';
    
    contentEl.innerHTML = html;
    
    /* Cargar imágenes faltantes via Shopify AJAX API usando <img> tags */
    contentEl.querySelectorAll('[data-load-handle]').forEach(function (slot) {
      var h = slot.getAttribute('data-load-handle');
      fetch('/products/' + h + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (p) {
        var src = p && p.featured_image ? p.featured_image : null;
        /* Normalizar URL protocol-relative de Shopify CDN */
        if (src && src.indexOf('//') === 0) src = 'https:' + src;
        /* Eliminar parámetros de version para URL limpia */
        if (src && src.indexOf('?') !== -1) src = src.split('?')[0];
        if (src) {
          /* Usar <img> tag directamente — más fiable que background-image */
          var img = document.createElement('img');
          img.src = src;
          img.alt = h;
          img.loading = 'lazy';
          slot.innerHTML = '';
          slot.appendChild(img);
        } else {
          slot.classList.add('wim-wishlist-card__img--empty');
        }
      })
      .catch(function () { slot.classList.add('wim-wishlist-card__img--empty'); });
    });
    
    /* Bind events de las cards */
    contentEl.querySelectorAll('.wim-wishlist-card').forEach(function (card) {
      var idx = parseInt(card.dataset.index, 10);
      
      card.addEventListener('click', function (e) {
        if (e.target.closest('.js-wim-list-edit') || e.target.closest('.js-wim-list-delete') || e.target.closest('.js-wim-list-cart')) return;
        showList(idx);
      });
      
      var cartBtn = card.querySelector('.js-wim-list-cart');
      if (cartBtn) {
        cartBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          showList(idx);
          setTimeout(function () {
            handleAddAllToCart();
          }, 300);
        });
      }
      
      card.querySelector('.js-wim-list-edit').addEventListener('click', function (e) {
        e.stopPropagation();
        var list = window.WimWishlists.getList(idx);
        openModal('Renombrar lista', list.n, function (newName) {
          if (newName && newName !== list.n) {
            var res = window.WimWishlists.renameList(idx, newName);
            if (!res.ok) {
              if (window.wimShowWishlistErrorToast) window.wimShowWishlistErrorToast(res.error);
              else alert(res.error);
            } else {
              window.WimWishlists.save(function () {
                renderDashboard(window.WimWishlists.getLists());
              });
            }
          }
        });
      });
      
      card.querySelector('.js-wim-list-delete').addEventListener('click', function (e) {
        e.stopPropagation();
        var list = window.WimWishlists.getList(idx);
        openConfirmModal('Eliminar lista', '¿Seguro que deseas eliminar la lista <strong>"' + escapeHtml(list.n) + '"</strong>?', 'Eliminar', function () {
          window.WimWishlists.deleteList(idx);
          window.WimWishlists.save(function () {
            renderDashboard(window.WimWishlists.getLists());
          });
        });
      });
    });
  }
  
  function showDashboard() {
    renderDashboard(window.WimWishlists.getLists());
  }
  
  function showList(index, backgroundLoad) {
    currentView = index;
    var list = window.WimWishlists.getList(index);
    if (!list) return showDashboard();
    
    if (!backgroundLoad) {
      if (headerEl) headerEl.setAttribute('hidden', '');
      titleEl.setAttribute('hidden', '');
      breadcrumbEl.setAttribute('hidden', '');
      createBtn.setAttribute('hidden', '');
      addAllBtn.setAttribute('hidden', '');
    }
    
    renderListView(index, backgroundLoad);
  }
  
  function buildListHeaderHtml(list, index) {
    var countText = list.items.length + ' producto' + (list.items.length !== 1 ? 's' : '');
    var html = '';
    html += '<div class="wim-list-detail-header">';
    
    /* Botón Volver superior */
    html += '  <div class="wim-list-detail-header__top">';
    html += '    <button class="wim-list-detail-header__back js-wim-dashboard-back" aria-label="Volver a mis listas">';
    html += '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    html += '    </button>';
    html += '  </div>';
    
    /* Título y Subtítulo Centrados */
    html += '  <div class="wim-list-detail-header__main">';
    html += '    <h2 class="wim-list-detail-header__title">' + escapeHtml(list.n) + '</h2>';
    html += '    <p class="wim-list-detail-header__count">' + countText + '</p>';
    html += '  </div>';
    
    /* Barra de 3 Botones de Acción */
    html += '  <div class="wim-list-detail-actions">';
    
    /* 1. Añadir todo al carro */
    var disabledAttr = list.items.length === 0 ? ' disabled' : '';
    html += '    <div class="wim-list-detail-action">';
    html += '      <button class="wim-list-detail-action__btn wim-list-detail-action__btn--cart js-wim-detail-add-all"' + disabledAttr + ' title="Añadir todo al carro">';
    html += '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
    html += '      </button>';
    html += '      <span class="wim-list-detail-action__label">Añadir todo<br>al carro</span>';
    html += '    </div>';
    
    /* 2. Buscar productos */
    html += '    <div class="wim-list-detail-action">';
    html += '      <button class="wim-list-detail-action__btn js-wim-detail-search-modal" title="Buscar productos">';
    html += '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
    html += '      </button>';
    html += '      <span class="wim-list-detail-action__label">Buscar<br>productos</span>';
    html += '    </div>';
    
    /* 3. Opciones */
    html += '    <div class="wim-list-detail-action" style="position:relative;">';
    html += '      <button class="wim-list-detail-action__btn js-wim-detail-options" title="Opciones de lista">';
    html += '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="1.5"></circle><circle cx="6" cy="12" r="1.5"></circle><circle cx="18" cy="12" r="1.5"></circle></svg>';
    html += '      </button>';
    html += '      <span class="wim-list-detail-action__label">Opciones</span>';
    
    html += '      <div class="wim-list-detail-dropdown js-wim-list-dropdown" hidden>';
    html += '        <button class="wim-list-detail-dropdown__item js-wim-dropdown-rename">';
    html += '          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>';
    html += '          Renombrar lista';
    html += '        </button>';
    html += '        <button class="wim-list-detail-dropdown__item wim-list-detail-dropdown__item--danger js-wim-dropdown-delete">';
    html += '          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
    html += '          Eliminar lista';
    html += '        </button>';
    html += '      </div>';
    
    html += '    </div>';
    
    html += '  </div>';
    
    /* Línea Divisoria y Ordenación de Productos */
    if (list.items.length > 0) {
      html += '  <div class="wim-list-detail-filter-bar" style="display: flex; justify-content: flex-end; align-items: center; margin-bottom: 24px;">';
      html += '    <label class="wim-sort-by-label text-nowrap" style="margin: 0 10px 0 0; font-size: 14px; font-weight: 700; color: #003a70;">Ordenar por:</label>';
      html += '    <select class="wim-sort-by-native js-wim-detail-sort" style="display: none;">';
      html += '      <option value="added">Más relevantes</option>';
      html += '      <option value="name">Alfabéticamente, A-Z</option>';
      html += '    </select>';
      html += '    <wim-sort-dropdown class="wim-sort-by-dropdown">';
      html += '      <button type="button" class="wim-sort-by-dropdown__trigger" aria-expanded="false" style="min-width: 180px; display: flex; justify-content: space-between; align-items: center; padding: 10px 20px;">';
      html += '        <span class="wim-sort-by-dropdown__selected">Más relevantes</span>';
      html += '        <svg class="wim-sort-by-dropdown__chevron" width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-top: 2px;"><path d="M16.25 7.5L10 13.75L3.75 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      html += '      </button>';
      html += '      <ul class="wim-sort-by-dropdown__list">';
      html += '        <li><button type="button" class="wim-sort-by-dropdown__option is-active" data-sort-value="added">Más relevantes</button></li>';
      html += '        <li><button type="button" class="wim-sort-by-dropdown__option" data-sort-value="name">Alfabéticamente, A-Z</button></li>';
      html += '      </ul>';
      html += '    </wim-sort-dropdown>';
      html += '  </div>';
    }
    
    html += '</div>';
    return html;
  }
  
  function renderListView(index, backgroundLoad) {
    var list = window.WimWishlists.getList(index);
    if (!list) return;
    
    var headerHtml = buildListHeaderHtml(list, index);
    
    if (list.items.length === 0) {
      contentEl.innerHTML = headerHtml + `
        <div class="wim-wishlists-empty">
          <p class="wim-wishlists-empty__text">Esta lista está vacía.</p>
        </div>
      `;
      bindListDetailEvents(index);
      return;
    }
    
    if (!backgroundLoad) {
      contentEl.innerHTML = headerHtml + '<div class="wim-wishlists-loading"><div class="spinner"></div></div>';
    } else {
      var countText = list.items.length + ' producto' + (list.items.length !== 1 ? 's' : '');
      var countEl = contentEl.querySelector('.wim-list-detail-header__count');
      if (countEl) countEl.textContent = countText;
    }
    
    var promises = list.items.map(function (item) {
      return fetch('/products/' + item.h + '?view=wim-card')
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
    });
    
    Promise.all(promises).then(function (htmls) {
      if (currentView !== index) return;
      
      var validHtmls = [];
      htmls.forEach(function (html, i) {
        if (html.trim()) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.wim-product-card');
          if (card) {
            card.classList.remove('wim-product-hidden');
            
            var wrapper = document.createElement('div');
            wrapper.className = 'wim-wishlist-item-wrapper wim-wishlist-item';
            wrapper.style.position = 'relative';
            wrapper.innerHTML = `
              <button type="button" class="wim-wishlists-remove-item js-wim-remove-item" data-handle="${list.items[i].h}" aria-label="Eliminar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            `;
            wrapper.appendChild(card);
            validHtmls.push(wrapper.outerHTML);
          }
        }
      });
      
      if (validHtmls.length === 0) {
        contentEl.innerHTML = headerHtml + '<p class="wim-wishlists-empty__text">Productos no disponibles.</p>';
      } else {
        contentEl.innerHTML = headerHtml + '<div id="wishlist-grid" class="wim-wishlists-products wim-wishlist-grid">' + validHtmls.join('') + '</div>';
        
        if (window.WimApp && typeof window.WimApp.initProductCards === 'function') {
          window.WimApp.initProductCards(contentEl);
        } else if (typeof initWimQuantitySelectors === 'function') {
          initWimQuantitySelectors();
        } else {
          document.dispatchEvent(new CustomEvent('wim:nodes-added', { detail: { element: contentEl } }));
        }
        
        window.WimWishlists.refreshHeartStates();
        
        // Bind eliminar item
        contentEl.querySelectorAll('.js-wim-remove-item').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var h = btn.dataset.handle;
            
            // Si el botón está desactivado para evitar doble clic, salir
            if (btn.disabled) return;
            btn.disabled = true;
            
            var res = window.WimWishlists.removeItem(index, h);
            var cardContainer = btn.closest('.wim-wishlist-item-wrapper');
            if (cardContainer) {
              cardContainer.style.display = 'none';
            }
            
            var list = window.WimWishlists.getList(index);
            if (list) {
              var c = list.items.length;
              var countEl = contentEl.querySelector('.wim-list-detail-header__count');
              if (countEl) {
                countEl.textContent = c + ' producto' + (c !== 1 ? 's' : '');
              }
              
              if (c === 0) {
                showList(index);
              }
            }
            
            if (window.wimShowUndoToast && res && res.removed) {
              window.wimShowUndoToast("Eliminado de la lista", "Deshacer", function () {
                var targetList = window.WimWishlists.getList(index);
                if (targetList) {
                  targetList.items.splice(res.index, 0, res.removed);
                  if (cardContainer && document.body.contains(cardContainer)) {
                    cardContainer.style.display = '';
                    btn.disabled = false;
                    var count = targetList.items.length;
                    var countEl = contentEl.querySelector('.wim-list-detail-header__count');
                    if (countEl) {
                      countEl.textContent = count + ' producto' + (count !== 1 ? 's' : '');
                    }
                    window.WimWishlists.save();
                  } else {
                    window.WimWishlists.save(function () {
                      showList(index, true);
                    });
                  }
                }
              });
            }
            
            window.WimWishlists.save();
          });
        });
      }
      
      bindListDetailEvents(index);
    });
  }
  
  function bindListDetailEvents(index) {
    var list = window.WimWishlists.getList(index);
    if (!list) return;
    
    // Volver
    contentEl.querySelectorAll('.js-wim-dashboard-back').forEach(function (btn) {
      btn.addEventListener('click', showDashboard);
    });
    
    // Añadir todo al carro
    var addAllBtnDetail = contentEl.querySelector('.js-wim-detail-add-all');
    if (addAllBtnDetail) {
      addAllBtnDetail.addEventListener('click', handleAddAllToCart);
    }
    
    // Abrir Modal de Búsqueda
    var searchModalBtn = contentEl.querySelector('.js-wim-detail-search-modal');
    if (searchModalBtn) {
      searchModalBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openSearchModal();
      });
    }
    
    // Opciones (Renombrar / Eliminar) Dropdown
    var optionsBtn = contentEl.querySelector('.js-wim-detail-options');
    var optionsDropdown = contentEl.querySelector('.js-wim-list-dropdown');
    
    if (optionsBtn && optionsDropdown) {
      // Toggle visibility
      optionsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isHidden = optionsDropdown.hasAttribute('hidden');
        if (isHidden) {
          optionsDropdown.removeAttribute('hidden');
        } else {
          optionsDropdown.setAttribute('hidden', '');
        }
      });
      
      // Close on click outside
      var closeDropdown = function (e) {
        if (!optionsDropdown.contains(e.target) && e.target !== optionsBtn && !optionsBtn.contains(e.target)) {
          optionsDropdown.setAttribute('hidden', '');
        }
      };
      document.addEventListener('click', closeDropdown);
      
      var renameBtn = optionsDropdown.querySelector('.js-wim-dropdown-rename');
      if (renameBtn) {
        renameBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          optionsDropdown.setAttribute('hidden', '');
          openModal('Renombrar lista', list.n, function (newName) {
            if (newName && newName !== list.n) {
              window.WimWishlists.renameList(index, newName);
              window.WimWishlists.save(function () {
                showList(index);
              });
            }
          });
        });
      }
      
      var deleteBtn = optionsDropdown.querySelector('.js-wim-dropdown-delete');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          optionsDropdown.setAttribute('hidden', '');
          openConfirmModal('Eliminar lista', '¿Seguro que deseas eliminar la lista <strong>"' + escapeHtml(list.n) + '"</strong>?', 'Eliminar', function () {
            window.WimWishlists.deleteList(index);
            window.WimWishlists.save(function () {
              showDashboard();
            });
          });
        });
      }
    }
    
    // Ordenación
    var sortSelect = contentEl.querySelector('.js-wim-detail-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var mode = this.value;
        var grid = contentEl.querySelector('.wim-wishlists-products');
        if (!grid) return;
        var itemsArr = Array.from(grid.children);
        if (mode === 'name') {
          itemsArr.sort(function (a, b) {
            var nameA = (a.querySelector('.wim-product-card__title') || {}).textContent || '';
            var nameB = (b.querySelector('.wim-product-card__title') || {}).textContent || '';
            return nameA.localeCompare(nameB);
          });
        }
        itemsArr.forEach(function (itemNode) {
          grid.appendChild(itemNode);
        });
      });
    }
  }
  
  function handleAddAllToCart() {
    var list = window.WimWishlists.getList(currentView);
    if (!list || list.items.length === 0) return;
    
    addAllBtn.textContent = 'Añadiendo...';
    addAllBtn.disabled = true;
    
    var simpleItems = [];
    var complexItems = [];
    
    // Inspeccionamos el DOM de las tarjetas renderizadas para saber la verdad.
    var wrappers = contentEl.querySelectorAll('.wim-wishlist-item-wrapper');
    wrappers.forEach(function (wrapper) {
      var removeBtn = wrapper.querySelector('.js-wim-remove-item');
      var handle = removeBtn ? removeBtn.dataset.handle : null;
      if (!handle) return;
      
      var quickBuyBtn = wrapper.querySelector('.js-wim-quick-buy-btn');
      if (quickBuyBtn) {
        complexItems.push({ h: handle, url: quickBuyBtn.getAttribute('data-product-url') });
      } else {
        // Es un producto simple, buscamos el form de añadir al carrito
        var idInput = wrapper.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (idInput && idInput.value) {
          simpleItems.push({ id: idInput.value, quantity: 1 });
        }
      }
    });
    
    if (simpleItems.length > 0) {
      var body = { items: simpleItems };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('Error adding to cart:', data.description);
          return;
        }
        
        // Replicar el flujo de ProductForm: pedir /cart.js + secciones por separado
        fetch((window.FoxTheme.routes.cart_url || '/cart') + '.js?t=' + Date.now(), { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function(cart) {
          if (window.FoxTheme && window.FoxTheme.pubsub) {
            var sectionsToBundle = [];
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
            );
            
            if (sectionsToBundle.length) {
              var fetchConfig = window.FoxTheme.utils && window.FoxTheme.utils.fetchConfig ? window.FoxTheme.utils.fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
              fetchConfig.body = JSON.stringify({
                sections: sectionsToBundle,
                sections_url: window.location.pathname
              });
              
              var cartUpdateUrl = window.FoxTheme.routes.cart_update_url || '/cart/update.js';
              fetch(cartUpdateUrl, fetchConfig)
              .then(function(r) { return r.json(); })
              .then(function(updatedCart) {
                updatedCart.items = cart.items;
                updatedCart.item_count = cart.item_count;
                updatedCart.total_price = cart.total_price;
                window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: updatedCart });
              })
              .catch(function(e) { console.error('Error fetching sections:', e); });
            } else {
              window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            }
          }
        })
        .catch(function (e) { console.error('Error fetching cart:', e); });
        
        if (complexItems.length > 0) {
          /* Mixto: simples añadidos + complejos pendientes de configurar con el wizard */
          if (window.wimShowToast) {
            window.wimShowToast(simpleItems.length + ' producto' + (simpleItems.length !== 1 ? 's' : '') + ' añadido' + (simpleItems.length !== 1 ? 's' : '') + ' al carrito. Configurando ' + complexItems.length + ' más...');
          }
          var complexUrls = complexItems.map(function (item) { return item.url; }).filter(Boolean);
          if (complexUrls.length > 0 && window.wimQuickBuyModal && typeof window.wimQuickBuyModal.openMultiple === 'function') {
            setTimeout(function () {
              window.wimQuickBuyModal.openMultiple(complexUrls);
            }, 300);
          }
        } else {
          if (window.wimShowToast) window.wimShowToast('Todos los productos añadidos al carrito');
          
          // Abrir sidecart si está disponible y NO abrimos un modal
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }
      })
      .catch(function (err) {
        console.error('Error in handleAddAllToCart fetch:', err);
        if (window.wimShowWishlistErrorToast) window.wimShowWishlistErrorToast('Error de conexión');
      })
      .finally(function () {
        addAllBtn.textContent = 'Añadir todo al carrito';
        addAllBtn.disabled = false;
      });
    } else if (complexItems.length > 0) {
      /* Solo hay productos complejos: abrir el wizard directamente sin toast
      (el wizard ya proporciona contexto suficiente al usuario) */
      var complexUrls = complexItems.map(function (item) { return item.url; }).filter(Boolean);
      if (complexUrls.length > 0 && window.wimQuickBuyModal && typeof window.wimQuickBuyModal.openMultiple === 'function') {
        window.wimQuickBuyModal.openMultiple(complexUrls);
      }
      
      addAllBtn.textContent = 'Añadir todo al carrito';
      addAllBtn.disabled = false;
    } else {
      addAllBtn.textContent = 'Añadir todo al carrito';
      addAllBtn.disabled = false;
    }
  }
  
  /* --- SEARCH MODAL --- */
  function loadDefaultProducts() {
    var defaultTerms = ['leche', 'aceite', 'agua', 'pan', 'queso', 'jamón', 'cerveza', 'café', 'arroz', 'pasta', 'yogur', 'galletas', 'vino'];
    var randomTerm = defaultTerms[Math.floor(Math.random() * defaultTerms.length)];
    
    var subtitleEl = document.querySelector('.wim-wishlists-search-subtitle');
    if (subtitleEl) subtitleEl.setAttribute('hidden', '');
    searchLoading.removeAttribute('hidden');
    
    fetch('/search/suggest.json?q=' + encodeURIComponent(randomTerm) + '&resources[type]=product&resources[limit]=4')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      searchLoading.setAttribute('hidden', '');
      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        if (subtitleEl) {
          subtitleEl.textContent = 'Productos populares';
          subtitleEl.removeAttribute('hidden');
        }
        renderSearchResults(data.resources.results.products);
      } else {
        loadStaticDefaultProducts();
      }
    })
    .catch(function (err) {
      searchLoading.setAttribute('hidden', '');
      loadStaticDefaultProducts();
    });
  }
  
  function loadStaticDefaultProducts() {
    var defaultJsonEl = document.getElementById('wim-wishlists-default-products');
    if (defaultJsonEl) {
      try {
        var products = JSON.parse(defaultJsonEl.textContent);
        if (products && products.length > 0) {
          var subtitleEl = document.querySelector('.wim-wishlists-search-subtitle');
          if (subtitleEl) {
            subtitleEl.textContent = 'Productos populares';
            subtitleEl.removeAttribute('hidden');
          }
          renderSearchResults(products);
        }
      } catch (e) {
        console.error('Error parsing default products', e);
      }
    }
  }
  
  function openSearchModal() {
    if (!searchModal) return;
    searchInput.value = '';
    searchResults.innerHTML = '';
    searchModal.removeAttribute('hidden');
    setTimeout(function () { searchInput.focus(); }, 50);
    
    var subtitleEl = document.querySelector('.wim-wishlists-search-subtitle');
    if (subtitleEl) subtitleEl.setAttribute('hidden', '');
    
    var list = window.WimWishlists.getList(currentView);
    if (list && list.items && list.items.length > 0) {
      searchLoading.removeAttribute('hidden');
      var lastItem = list.items[list.items.length - 1]; // Recommendation based on latest added product
      
      function fetchRecs(productId) {
        fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          searchLoading.setAttribute('hidden', '');
          if (data.products && data.products.length > 0) {
            if (subtitleEl) {
              subtitleEl.textContent = 'Recomendados para tu lista';
              subtitleEl.removeAttribute('hidden');
            }
            renderSearchResults(data.products);
          } else {
            loadDefaultProducts();
          }
        })
        .catch(function (err) {
          searchLoading.setAttribute('hidden', '');
          loadDefaultProducts();
        });
      }
      
      if (lastItem.p) {
        fetchRecs(lastItem.p);
      } else {
        fetch('/products/' + lastItem.h + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          if (product && product.id) {
            fetchRecs(product.id);
          } else {
            searchLoading.setAttribute('hidden', '');
            loadDefaultProducts();
          }
        })
        .catch(function (err) {
          searchLoading.setAttribute('hidden', '');
          loadDefaultProducts();
        });
      }
    } else {
      loadDefaultProducts();
    }
  }
  
  function closeSearchModal() {
    if (!searchModal) return;
    searchModal.setAttribute('hidden', '');
  }
  
  function handleSearchInput(e) {
    var q = e.target.value.trim();
    if (searchTimeout) clearTimeout(searchTimeout);
    
    var subtitleEl = document.querySelector('.wim-wishlists-search-subtitle');
    
    if (q.length < 2) {
      searchResults.innerHTML = '';
      searchLoading.setAttribute('hidden', '');
      if (subtitleEl) subtitleEl.setAttribute('hidden', '');
      loadDefaultProducts();
      return;
    }
    
    searchTimeout = setTimeout(function () {
      searchLoading.removeAttribute('hidden');
      if (subtitleEl) subtitleEl.setAttribute('hidden', '');
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        searchLoading.setAttribute('hidden', '');
        if (subtitleEl) {
          subtitleEl.textContent = 'Resultados de búsqueda';
          subtitleEl.removeAttribute('hidden');
        }
        renderSearchResults(data.resources.results.products || []);
      })
      .catch(function (err) {
        searchLoading.setAttribute('hidden', '');
        console.error('Error fetching suggestions', err);
      });
    }, 300);
  }
  
  function renderSearchResults(products) {
    if (products.length === 0) {
      searchResults.innerHTML = '<p class="wim-wishlists-empty__text" style="padding:2rem;">No se encontraron productos.</p>';
      return;
    }
    
    var listObj = window.WimWishlists.getList(currentView);
    var existingHandles = {};
    if (listObj) {
      listObj.items.forEach(function (item) {
        existingHandles[item.h] = true;
      });
    }
    
    var html = '';
    products.forEach(function (p) {
      var img = p.image || p.featured_image || '//cdn.shopify.com/s/images/admin/no-image-large.gif';
      var isAdded = !!existingHandles[p.handle];
      var btnHtml = isAdded
      ? '<span class="wim-search-result-item__btn-add wim-search-result-item__btn-add--added"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Añadido</span>'
      : '<button class="wim-search-result-item__btn-add js-wim-search-add" data-id="' + p.id + '" data-handle="' + p.handle + '" data-img="' + escapeHtml(img) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg> Guardar</button>';
      
      var priceFormatted = p.price || '';
      if (typeof p.price === 'number') {
        priceFormatted = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
      
      html += '<div class="wim-search-result-item">';
      html += '  <img src="' + img + '" alt="' + escapeHtml(p.title) + '" class="wim-search-result-item__img">';
      html += '  <div class="wim-search-result-item__info">';
      html += '    <h4 class="wim-search-result-item__title">' + escapeHtml(p.title) + '</h4>';
      html += '    <p class="wim-search-result-item__price">' + escapeHtml(priceFormatted) + ' <span style="font-size:1.1rem; color:#9CA3AF; font-weight:normal;">/ ud. (aprox)</span></p>';
      html += '  </div>';
      html += '  ' + btnHtml;
      html += '</div>';
    });
    
    searchResults.innerHTML = html;
    
    searchResults.querySelectorAll('.js-wim-search-add').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var id = this.dataset.id;
        var handle = this.dataset.handle;
        var imgUrl = this.dataset.img;
        
        this.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Añadido';
        this.classList.add('wim-search-result-item__btn-add--added');
        this.classList.remove('js-wim-search-add');
        this.disabled = true;
        
        window.WimWishlists.addItem(currentView, handle, parseInt(id, 10) || 0, 'p', imgUrl);
        window.WimWishlists.save(function () {
          showList(currentView, true);
        });
      });
    });
  }
  
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Initialize Lottie Player for Albacete Popup
document.addEventListener('DOMContentLoaded', function() {
  const lottiePlayer = document.getElementById('wim-lottie-player-default');
  if (lottiePlayer) {
    // Wait for the custom element to be registered
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('lottie-player').then(function() {
        if (window.wimLottieAlbaceteData) {
          lottiePlayer.load(window.wimLottieAlbaceteData);
        } else {
          // If data script was deferred, retry after a short delay
          setTimeout(function() {
            if (window.wimLottieAlbaceteData) {
              lottiePlayer.load(window.wimLottieAlbaceteData);
            }
          }, 500);
        }
      });
    } else {
      // Fallback for older browsers
      setTimeout(function() {
        if (window.wimLottieAlbaceteData && typeof lottiePlayer.load === 'function') {
          lottiePlayer.load(window.wimLottieAlbaceteData);
        }
      }, 1000);
    }
  }
});

/* WIM Popup Albacete Coupon Feedback */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wim-popup-albacete__coupon-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const originalText = this.innerText;
      const originalBg = this.style.backgroundColor;
      const originalColor = this.style.color;
      this.innerText = '¡Copiado! ✅';
      this.style.backgroundColor = 'var(--wim-color-green, #10B981)';
      this.style.color = '#ffffff';
      setTimeout(() => {
        this.innerText = originalText;
        this.style.backgroundColor = originalBg;
        this.style.color = originalColor;
      }, 2000);
    });
  });
});


/**
* Lógica para repetir pedidos (Movida desde wim-reorder.js)
*/
(function () {
  'use strict';
  
  function init() {
    const btns = document.querySelectorAll('.wim-reorder-btn');
    btns.forEach(function (btn) {
      if (!btn.hasAttribute('data-wim-reorder-bound')) {
        btn.setAttribute('data-wim-reorder-bound', 'true');
        btn.addEventListener('click', onReorderClick);
      }
    });
  }
  
  async function onReorderClick(e) {
    e.preventDefault();
    const btn = this;
    const orderId = btn.getAttribute('data-order-id');
    const dataScript = document.getElementById('ReorderData-' + orderId);
    
    if (!dataScript) return;
    
    let items = [];
    try {
      items = JSON.parse(dataScript.textContent);
    } catch (err) {
      console.error('[wim-reorder] Error parseando datos del pedido', err);
      return;
    }
    
    if (items.length === 0) return;
    
    // Filtramos completamente los items de ajuste de peso creados por Janis / ERP durante la preparación
    items = items.filter(function (item) {
      if (!item.title) return true;
      const lower = item.title.toLowerCase();
      return !lower.includes('weight adjustment') && !lower.includes('ajuste de peso');
    });
    
    if (items.length === 0) return;
    
    const directItems = [];
    const configurableItems = [];
    const configurableUrls = [];
    const seenUrls = new Set(); // Evitar duplicados si hay varios items configurables del mismo producto
    
    items.forEach(function (item) {
      const getProp = (k) => {
        if (!item.properties) return null;
        if (Array.isArray(item.properties)) {
          const p = item.properties.find(x => x.name === k);
          return p ? p.value : null;
        }
        return item.properties[k] || null;
      };
      
      const isWeight = (item.unit_sale && item.unit_sale.indexOf('weight') !== -1) || (getProp('peso') || getProp('_weight_value')) ? true : false;
      const hasCutting = item.cutting_types && Array.isArray(item.cutting_types) && item.cutting_types.length > 0;
      
      
      // Si es un producto pesable, recalculamos la cantidad original en base al peso guardado
      // Esto soluciona que si el pedido original se ajustó (ej. de 1.0 a 1.2 kg), se añadan 1.2 kg
      if (isWeight && item.properties) {
        let targetKg = null;
        if (getProp('_weight_value')) {
          targetKg = parseFloat(getProp('_weight_value'));
        } else if (getProp('peso')) {
          let pesoStr = String(getProp('peso')).toLowerCase();
          targetKg = parseFloat(pesoStr);
          if (pesoStr.indexOf('g') > -1 && pesoStr.indexOf('kg') === -1) {
            targetKg = targetKg / 1000;
          }
        }
        
        if (targetKg && targetKg > 0) {
          let rawMult = getProp('_janisCommerce_unitMultiplier') || item.unit_multiplier || getProp('_weight_step') || 1;
          let mult = parseFloat(rawMult) || 1;
          
          let rawUnit = getProp('_janisCommerce_measurementUnit') || item.measurement_format || getProp('_weight_format') || 'gr';
          let unit = String(rawUnit).toLowerCase().trim();
          if (unit === 'g') unit = 'gr';
          
          let stepKg = (unit === 'kg') ? mult : (mult < 1 ? mult : mult / 1000);
          
          if (stepKg > 0) {
            const calculatedQty = Math.round(targetKg / stepKg);
            if (calculatedQty > 0) {
              item.quantity = calculatedQty;
            }
          }
        }
      }
      
      // Es configurable si es pesable o requiere corte/preparación
      if (isWeight || hasCutting) {
        configurableItems.push(item);
        let url = item.url;
        // Limpiamos la variante para que cargue el producto base y el usuario elija
        if (url.indexOf('?') > -1) {
          url = url.split('?')[0];
        }
        
        if (!seenUrls.has(url)) {
          seenUrls.add(url);
          configurableUrls.push(url);
        }
      } else {
        directItems.push(item);
      }
    });
    
    let itemsToAddDirectly = [...directItems];
    let shouldOpenWizard = false;
    
    // Helper para mostrar el modal de confirmación
    function promptConfigurableItems() {
      return new Promise((resolve) => {
        const modal = document.getElementById('wim-reorder-prompt');
        if (!modal) {
          resolve(window.confirm("Este pedido contiene productos al peso.\n\n¿Deseas revisarlos y modificarlos antes de añadirlos?\n\nAceptar: Revisar\nCancelar: Añadir tal cual") ? 'modify' : 'direct');
          return;
        }
        
        if (typeof modal.show === 'function') {
          modal.show();
        } else {
          modal.removeAttribute('hidden');
          modal.setAttribute('open', '');
        }
        
        const detachListeners = () => {
          if (btnConfirm) {
            btnConfirm.removeEventListener('click', onConfirm);
          }
          if (btnDirect) {
            btnDirect.removeEventListener('click', onDirect);
          }
          closeBtns.forEach(btn => btn.removeEventListener('click', onClose));
        };
        
        const cleanup = () => {
          detachListeners();
          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            modal.removeAttribute('open');
            modal.setAttribute('hidden', '');
          }
          if (btnConfirm) {
            btnConfirm.classList.remove('btn--loading');
            btnConfirm.disabled = false;
          }
          if (btnDirect) {
            btnDirect.classList.remove('btn--loading');
            btnDirect.disabled = false;
          }
        };
        
        const onConfirm = () => {
          detachListeners();
          if (btnConfirm) {
            btnConfirm.classList.add('btn--loading');
            btnConfirm.disabled = true;
          }
          if (btnDirect) btnDirect.disabled = true;
          // Dejamos el modal abierto con el loader activo en el botón hasta que se abra el modal de configuración
          resolve('modify');
        };
        
        const onDirect = () => {
          detachListeners();
          if (btnDirect) {
            btnDirect.classList.add('btn--loading');
            btnDirect.disabled = true;
          }
          if (btnConfirm) btnConfirm.disabled = true;
          resolve('direct');
        };
        
        const onClose = () => { cleanup(); resolve('abort'); };
        
        const btnConfirm = modal.querySelector('.js-wim-reorder-prompt-confirm');
        const btnDirect = modal.querySelector('.js-wim-reorder-prompt-direct');
        const closeBtns = modal.querySelectorAll('.js-wim-reorder-prompt-close');
        
        if (btnConfirm) btnConfirm.addEventListener('click', onConfirm);
        if (btnDirect) btnDirect.addEventListener('click', onDirect);
        closeBtns.forEach(btn => btn.addEventListener('click', onClose));
      });
    }
    
    // Preguntamos al usuario si desea modificar los pesables
    if (configurableItems.length > 0) {
      const decision = await promptConfigurableItems();
      
      if (decision === 'abort') {
        return; // El usuario cerró el modal, abortamos todo
      } else if (decision === 'modify') {
        shouldOpenWizard = true;
      } else if (decision === 'direct') {
        itemsToAddDirectly = itemsToAddDirectly.concat(configurableItems);
      }
    }
    
    btn.classList.add('btn--loading');
    btn.disabled = true;
    
    // Filtra el stock real usando GraphQL apuntando directamente a las Variantes
    async function validateStockForOrderItems(items) {
      if (items.length === 0) return { inStock: items, outOfStock: [] };
      
      let storeCode = '';
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cartJson = await cartRes.json();
          storeCode = (cartJson.attributes && cartJson.attributes.store_code) || '';
        }
      } catch (e) {
        console.warn('[wim-reorder] Error fetching cart attributes', e);
      }
      
      if (!storeCode) storeCode = (window.WIM_CART_ATTRIBUTES && window.WIM_CART_ATTRIBUTES.store_code) || '';
      if (!storeCode) return { inStock: items, outOfStock: [] };
      
      try {
        const inStock = [];
        const outOfStock = [];
        items.forEach(item => {
          const info = { stock: item.stock, forceVis: item.force_visibility, hasEntry: item.has_entry };
          let isAvailable = false;
          
          if (info.forceVis === 'true') {
            isAvailable = true;
          } else if (info.forceVis === 'false') {
            isAvailable = false;
          } else if (info.hasEntry) {
            let neededQty = parseFloat(item.quantity) || 1;
            
            const getProp = (k) => {
              if (!item.properties) return null;
              if (Array.isArray(item.properties)) {
                const p = item.properties.find(x => x.name === k);
                return p ? p.value : null;
              }
              return item.properties[k] || null;
            };
            
            const isWeight = (item.unit_sale && item.unit_sale.indexOf('weight') !== -1) || (getProp('peso') || getProp('_weight_value')) ? true : false;
            if (isWeight && item.properties) {
              let targetKg = null;
              if (getProp('_weight_value')) {
                targetKg = parseFloat(getProp('_weight_value'));
              } else if (getProp('peso')) {
                let pesoStr = String(getProp('peso')).toLowerCase();
                targetKg = parseFloat(pesoStr);
                if (pesoStr.indexOf('g') > -1 && pesoStr.indexOf('kg') === -1) {
                  targetKg = targetKg / 1000;
                }
              }
              if (targetKg && targetKg > 0) {
                neededQty = targetKg;
              }
            }
            
            isAvailable = info.stock > 0 && info.stock >= neededQty;
          }
          
          if (isAvailable) {
            inStock.push(item);
          } else {
            outOfStock.push(item);
          }
        });
        
        return { inStock, outOfStock };
      } catch (e) {
        console.warn('[wim-reorder] Error checking stock by variant:', e);
        return { inStock: items, outOfStock: [] };
      }
    }
    
    // Helper para enviar un lote y reintentar individualmente si falla
    async function processDirectItems(itemsArray) {
      if (itemsArray.length === 0) return { success: true, rejected: [], sections: null };
      
      let cartAddUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_add_url)
      ? window.FoxTheme.routes.cart_add_url
      : '/cart/add';
      if (!cartAddUrl.endsWith('.js')) cartAddUrl += '.js';
      
      let cartUpdateUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_update_url)
      ? window.FoxTheme.routes.cart_update_url
      : '/cart/update';
      if (!cartUpdateUrl.endsWith('.js')) cartUpdateUrl += '.js';
      
      // Filtramos los items de sistema (ajustes de peso, etc.)
      const validItemsArray = itemsArray.filter(i => {
        if (!i.title) return true;
        return !i.title.toLowerCase().includes('weight adjustment');
      });
      
      if (validItemsArray.length === 0) return { success: true, rejected: [], sections: null };
      
      // Ventana de entrega VIGENTE
      const janisFrom = localStorage.getItem('_janisCommerce_deliveryWindowFrom');
      const janisTo = localStorage.getItem('_janisCommerce_deliveryWindowTo');
      if (janisFrom && janisTo) {
        validItemsArray.forEach(i => {
          i.properties = Object.assign({}, i.properties || {}, {
            '_janisCommerce_deliveryWindowFrom': janisFrom,
            '_janisCommerce_deliveryWindowTo': janisTo
          });
        });
      }
      
      // Leemos el carrito actual para separar items nuevos de los ya existentes
      let currentCartItems = [];
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) currentCartItems = (await cartRes.json()).items || [];
      } catch (_) { /* continuamos sin datos previos */ }
      
      // Propiedades transientes que NO usamos para identificar un line item
      // (varían por sesión, las añade Cart Transform, o representan la cantidad/peso acumulado)
      const TRANSIENT_PROPS = new Set([
        '_janisCommerce_deliveryWindowFrom',
        '_janisCommerce_deliveryWindowTo',
        '_store_price',
        '_store_compare_at_price',
        '_use_cp',
        'peso',
        '_weight_value',
        '_weight_step',
        '_weight_format',
        '_janisCommerce_customerNote'
      ]);
      
      // Devuelve las propiedades "estables" de un item (las que identifican su configuración)
      function stableProps(props) {
        const result = {};
        const isWeight = !!(props && (props['peso'] || props['_weight_value']));
        result['_mode'] = isWeight ? 'weight' : 'unit';
        Object.keys(props || {}).forEach(k => {
          if (!TRANSIENT_PROPS.has(k)) result[k] = String(props[k]);
        });
        return result;
      }
      
      function getWeightParams(item) {
        let rawMult = (item.properties && item.properties['_janisCommerce_unitMultiplier']) 
        || item.unit_multiplier 
        || (item.properties && item.properties['_weight_step']) 
        || 1;
        let mult = parseFloat(rawMult) || 1;
        
        let rawUnit = (item.properties && item.properties['_janisCommerce_measurementUnit']) 
        || item.measurement_format 
        || (item.properties && item.properties['_weight_format']) 
        || 'gr';
        let unit = String(rawUnit).toLowerCase().trim();
        if (unit === 'g') unit = 'gr';
        
        let stepKg;
        if (unit === 'kg') {
          stepKg = mult;
        } else {
          stepKg = mult < 1 ? mult : mult / 1000;
        }
        
        return { multiplier: mult, measureUnit: unit, stepKg: stepKg };
      }
      
      function applyWeightProps(props, qty, params) {
        if (!props) props = {};
        const totalKg = parseFloat((qty * params.stepKg).toFixed(2));
        const pesoStr = totalKg >= 1 ? `${totalKg} kg` : `${Math.round(totalKg * 1000)} g`;
        
        props['_weight_value'] = String(totalKg);
        props['peso'] = pesoStr;
        props['_weight_format'] = String(params.measureUnit);
        props['_weight_step'] = String(params.multiplier);
        props['_janisCommerce_unitMultiplier'] = String(params.multiplier);
        props['_janisCommerce_measurementUnit'] = String(params.measureUnit);
        
        if (props['preparación'] && props['preparación'] !== '') {
          props['_janisCommerce_customerNote'] = `${qty}u de ${props['preparación']}`;
        } else {
          props['_janisCommerce_customerNote'] = `${qty} un aprox.`;
        }
        return props;
      }
      
      // Busca la línea del carrito que mejor coincide con un item del pedido.
      // Matching leniente: todos los props estables del pedido deben estar en el carrito,
      // pero el carrito puede tener props extras (añadidas por Cart Transform).
      function findCartLine(orderItem) {
        const orderStable = stableProps(orderItem.properties);
        const orderKeys = Object.keys(orderStable);
        const candidates = currentCartItems.filter(ci => String(ci.variant_id) === String(orderItem.id));
        
        if (!candidates.length) return null;
        
        // Si no hay props estables en el pedido, devolvemos el primer candidato
        if (!orderKeys.length) return candidates[0];
        
        const match = candidates.find(ci => {
          const ciStable = stableProps(ci.properties);
          // Todos los props estables del pedido deben coincidir en el carrito
          return orderKeys.every(k => ciStable[k] === orderStable[k]);
        });
        
        return match || null;
      }
      
      function isWeightOrderItem(item) {
        if (item.properties && (item.properties['peso'] || item.properties['_weight_value'])) {
          return true;
        }
        if (item.unit_sale === 'weight') {
          return true;
        }
        return false;
      }
      
      // Separamos los items según su tipo y presencia en el carrito
      const updatesMap = {};  // line_key -> qty absoluta (productos normales)
      const lineChanges = []; // [{ key, qty, properties }] para pesables ya en carrito (via /cart/change.js)
      const newItems = [];    // items nuevos (via /cart/add.js)
      
      validItemsArray.forEach(i => {
        const isWeight = isWeightOrderItem(i);
        
        if (isWeight) {
          const wParams = getWeightParams(i);
          i.properties = applyWeightProps(i.properties || {}, i.quantity, wParams);
        } else if (i.properties && i.properties['preparación']) {
          i.properties['_janisCommerce_customerNote'] = `${i.quantity}u de ${i.properties['preparación']}`;
        }
        
        // Buscamos la línea exacta en el carrito usando propiedades estables
        const matchingLine = findCartLine(i);
        
        if (matchingLine) {
          if (isWeight) {
            // Si ya hay un cambio en memoria, acumulamos sobre él
            const existingChange = lineChanges.find(c => c.key === matchingLine.key);
            const baseQty = existingChange ? existingChange.quantity : matchingLine.quantity;
            const newQty = baseQty + i.quantity;
            const newProps = { ...matchingLine.properties, ...(i.properties || {}) };
            
            const wParams = getWeightParams(i);
            applyWeightProps(newProps, newQty, wParams);
            
            if (existingChange) {
              existingChange.quantity = newQty;
              existingChange.properties = newProps;
            } else {
              lineChanges.push({ key: matchingLine.key, quantity: newQty, properties: newProps });
            }
          } else {
            // Producto normal ya en carrito: cantidad absoluta via /cart/update.js (por KEY de línea)
            const baseQty = updatesMap[matchingLine.key] || matchingLine.quantity;
            updatesMap[matchingLine.key] = baseQty + i.quantity;
          }
        } else {
          // Agrupamos si en el mismo pedido hay repetidos
          const existingNew = newItems.find(ni => String(ni.id) === String(i.id) && JSON.stringify(stableProps(ni.properties)) === JSON.stringify(stableProps(i.properties)));
          if (existingNew) {
            existingNew.quantity += i.quantity;
            if (isWeight) {
              const wParams = getWeightParams(existingNew);
              applyWeightProps(existingNew.properties, existingNew.quantity, wParams);
            }
          } else {
            newItems.push(i);
          }
        }
      });
      
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      const sections = sectionsToBundle.length ? sectionsToBundle.join(',') : 'cart-drawer,cart-icon-bubble';
      
      try {
        let lastSections = null;
        
        // 1. Actualizamos productos normales con cantidad absoluta via /cart/update.js
        if (Object.keys(updatesMap).length > 0) {
          const updateRes = await fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updatesMap, sections, sections_url: window.location.pathname })
          });
          if (updateRes.ok) {
            const updateJson = await updateRes.json();
            lastSections = updateJson.sections || null;
          } else {
            throw new Error('updateRes batch failed with status ' + updateRes.status);
          }
        }
        
        // 2. Actualizamos pesables ya en carrito via /cart/change.js (por key de línea)
        for (const change of lineChanges) {
          const changeRes = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: change.key, quantity: change.quantity, properties: change.properties })
          });
          if (changeRes.ok) {
            lastSections = null; // forzamos fetch de sections al final
          } else {
            throw new Error('changeRes batch failed with status ' + changeRes.status);
          }
        }
        
        // 3. Añadimos items nuevos (pesables sin match en carrito y productos normales nuevos)
        if (newItems.length > 0) {
          const payloadNewItems = newItems.map(i => ({ id: i.id, quantity: i.quantity, properties: i.properties || {} }));
          const addRes = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: payloadNewItems, sections, sections_url: window.location.pathname })
          });
          if (addRes.ok) {
            const addJson = await addRes.json();
            lastSections = addJson.sections || lastSections;
          } else {
            throw new Error('addRes batch failed with status ' + addRes.status);
          }
        }
        
        const anyChanges = Object.keys(updatesMap).length > 0 || lineChanges.length > 0 || newItems.length > 0;
        if (anyChanges) {
          return { success: true, rejected: [], sections: lastSections };
        }
        
        throw new Error('No se completaron las peticiones al carrito');
        
      } catch (err) {
        console.warn('[wim-reorder] Fallo en batch, reintentando item a item...', err);
        const rejected = [];
        const chunkSize = 3;
        let procesados = 0;
        
        const btnTextSpan = document.querySelector('.wim-reorder-btn__spinner:not(.hidden)')?.previousElementSibling;
        let originalText = '';
        if (btnTextSpan) {
          originalText = btnTextSpan.innerText;
          btnTextSpan.innerText = `0 / ${validItemsArray.length}`;
        }
        
        for (let i = 0; i < validItemsArray.length; i += chunkSize) {
          const chunk = validItemsArray.slice(i, i + chunkSize);
          const chunkPromises = chunk.map(async (item) => {
            if (!item.id) { rejected.push({ item }); return; }
            
            const isWeight = isWeightOrderItem(item);
            const matching = findCartLine(item);
            if (matching) {
              if (isWeight) {
                const newQty = matching.quantity + item.quantity;
                const newProps = { ...matching.properties, ...(item.properties || {}) };
                const wParams = getWeightParams(item);
                applyWeightProps(newProps, newQty, wParams);
                
                const changeRes = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: matching.key, quantity: newQty, properties: newProps })
                });
                if (!changeRes.ok) rejected.push({ item });
              } else {
                const singleUpdateRes = await fetch(cartUpdateUrl, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ updates: { [matching.key]: matching.quantity + item.quantity } })
                });
                if (!singleUpdateRes.ok) rejected.push({ item });
              }
            } else {
              if (isWeight) {
                const wParams = getWeightParams(item);
                item.properties = applyWeightProps(item.properties || {}, item.quantity, wParams);
              } else if (item.properties && item.properties['preparación']) {
                item.properties['_janisCommerce_customerNote'] = `${item.quantity}u de ${item.properties['preparación']}`;
              }
              const singleAddRes = await fetch(cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity, properties: item.properties || {} }] })
              });
              if (!singleAddRes.ok) rejected.push({ item });
            }
          });
          
          await Promise.all(chunkPromises);
          procesados += chunk.length;
          if (btnTextSpan) btnTextSpan.innerText = `${procesados} / ${validItemsArray.length}`;
        }
        
        if (btnTextSpan) btnTextSpan.innerText = originalText || 'Repetir';
        
        return { success: rejected.length < validItemsArray.length, rejected, sections: null, requiresFetch: true };
      }
    }
    
    const { inStock, outOfStock } = await validateStockForOrderItems(itemsToAddDirectly);
    
    processDirectItems(inStock).then(async (result) => {
      btn.classList.remove('btn--loading');
      btn.disabled = false;
      
      // Agregamos a los rechazados los items que no tienen stock según nuestra validación GraphQL
      if (outOfStock.length > 0) {
        const outOfStockRejects = outOfStock.map(item => ({ item: item }));
        result.rejected = (result.rejected || []).concat(outOfStockRejects);
      }
      
      // Mostrar modal si hay items rechazados (ej. sin stock)
      if (result.rejected && result.rejected.length > 0) {
        console.warn('[wim-reorder] Items rechazados:', result.rejected);
        const rejectedModal = document.getElementById('wim-reorder-rejected');
        const rejectedList = document.getElementById('wim-reorder-rejected-list');
        
        if (rejectedModal && rejectedList) {
          const formatCurrency = (cents) => {
            if (typeof cents !== 'number') return '';
            if (window.FoxTheme && window.FoxTheme.Currency && window.FoxTheme.Currency.formatMoney) {
              return window.FoxTheme.Currency.formatMoney(cents, window.FoxTheme.settings?.money_format || '{{amount}}€');
            }
            return (cents / 100).toFixed(2).replace('.', ',') + '€';
          };
          
          // Resolver datos faltantes de productos borrados/reimportados por el ERP
          // antes de renderizar, para tener imagen y product_id disponibles
          for (const r of result.rejected) {
            if (!r.item.product_id || !r.item.image) {
              try {
                let resolved = null;
                // Buscar directamente por título mediante suggest.json
                try {
                  const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(r.item.title)}&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=show`);
                  if (searchRes.ok) {
                    const data = await searchRes.json();
                    const prods = data.resources?.results?.products || [];
                    resolved = prods.find(p =>
                      p.title.toLowerCase().trim() === (r.item.title || '').toLowerCase().trim()
                    );
                  }
                } catch (e) {}
                
                if (resolved) {
                  if (!r.item.product_id && resolved.id) r.item.product_id = resolved.id;
                  if (!r.item.image) {
                    // featured_image puede ser string (/products/handle.js) u objeto con url (suggest.json)
                    let img = '';
                    if (typeof resolved.featured_image === 'string' && resolved.featured_image) {
                      img = resolved.featured_image;
                    } else if (resolved.featured_image && resolved.featured_image.url) {
                      img = resolved.featured_image.url;
                    } else if (typeof resolved.image === 'string' && resolved.image) {
                      img = resolved.image;
                    } else if (resolved.images && resolved.images.length > 0) {
                      img = typeof resolved.images[0] === 'string' ? resolved.images[0] : (resolved.images[0]?.src || '');
                    }
                    if (img) {
                      r.item.image = img.includes('width=') ? img : (img + (img.includes('?') ? '&' : '?') + 'width=200');
                    }
                  }
                }
              } catch (e) {
                console.warn('[wim-reorder] Error resolviendo producto borrado:', r.item.title, e);
              }
            }
          }
          
          rejectedList.innerHTML = result.rejected.map(r => {
            const cleanTitle = (r.item.title || 'Producto').replace(/"/g, '&quot;');
            const imgHtml = r.item.image 
            ? `<img src="${r.item.image}" alt="${cleanTitle}" class="wim-reorder-rejected__card-img" loading="lazy">`
            : `<div class="wim-reorder-rejected__card-placeholder flex items-center justify-center text-gray-400">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                 </div>`;
            const getStr = val => Array.isArray(val) ? val.join(' ') : (val ? String(val) : '');
            const grupoStr = getStr(r.item.metafield_grupo);
            const subcatStr = getStr(r.item.metafield_subcategoria);
            return `
              <div class="wim-reorder-rejected__item" data-title="${cleanTitle}" data-product-id="${r.item.product_id || ''}" data-product-type="${(r.item.product_type || '').replace(/"/g, '&quot;')}" data-metafield-grupo="${grupoStr.replace(/"/g, '&quot;')}" data-metafield-subcategoria="${subcatStr.replace(/"/g, '&quot;')}">
                <div class="wim-reorder-rejected__card">
                  <div class="wim-reorder-rejected__card-media">
                    ${imgHtml}
                  </div>
                  <div class="wim-reorder-rejected__card-info">
                    <span class="wim-reorder-rejected__card-name">${r.item.title || 'Producto'}</span>
                    <span class="wim-reorder-rejected__card-badge">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                      Agotado
                    </span>
                  </div>
                  <button type="button" class="wim-reorder-rejected__card-btn js-toggle-replace" aria-expanded="false">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 17h16M16 13l4 4-4 4M20 7H4M8 3L4 7l4 4"/>
                    </svg>
                    <span>Sustituir</span>
                  </button>
                </div>
              
                <div class="wim-reorder-rejected__dropdown hidden">
                  <div class="wim-reorder-rejected__dropdown-header">
                    <span class="wim-reorder-rejected__dropdown-title">Alternativas recomendadas:</span>
                  </div>
              
                  <div class="wim-reorder-rejected__results js-replace-results">
                    <div class="wim-reorder-rejected__loading">
                      <svg class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px;">
                        <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                      </svg>
                      <span>Buscando las mejores alternativas...</span>
                    </div>
                  </div>
              
                  <div class="wim-reorder-rejected__search-section">
                    <div class="wim-reorder-rejected__search-wrap">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="wim-reorder-rejected__search-icon">
                        <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                      <input type="text" class="wim-reorder-rejected__search-input js-replace-search-input" placeholder="O busca manualmente otro producto...">
                    </div>
                  </div>
                </div>
              </div>
            `;
          }).join('');
          
          if (typeof rejectedModal.show === 'function') {
            rejectedModal.show();
          } else {
            rejectedModal.removeAttribute('hidden');
            rejectedModal.setAttribute('open', '');
          }
          
          // Cerrar modal
          const closeBtns = rejectedModal.querySelectorAll('.js-wim-reorder-rejected-close');
          closeBtns.forEach(b => b.addEventListener('click', () => {
            if (typeof rejectedModal.hide === 'function') {
              rejectedModal.hide();
            } else {
              rejectedModal.removeAttribute('open');
              rejectedModal.setAttribute('hidden', '');
            }
          }, { once: true }));
          
          // Filtrar productos asegurando stock en la tienda del usuario mediante GraphQL
          const filterProductsByStoreCode = async (products) => {
            const storeCode = (window.WIM_CART_ATTRIBUTES && window.WIM_CART_ATTRIBUTES.store_code) || '';
            if (!storeCode || products.length === 0) return products;
            
            try {
              const gids = products.map(p => `gid://shopify/Product/${p.id}`);
              const query = `
                query resolveStockStore($ids: [ID!]!) {
                  nodes(ids: $ids) {
                    ... on Product {
                      id
                      variants(first: 10) {
                        edges {
                          node {
                            id
                            metafield(namespace: "dsp", key: "stock_store") {
                              value
                            }
                          }
                        }
                      }
                    }
                  }
                }
              `;
              const res = await fetch('https://' + window.WimShopDomain + '/api/2024-10/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': window.WimStorefrontToken
                },
                body: JSON.stringify({ query, variables: { ids: gids } })
              });
              
              if (!res.ok) {
                console.error('[wim-reorder] GraphQL fetch failed with status:', res.status);
                return products;
              }
              
              const json = await res.json();
              if (json.errors) {
                console.error('[wim-reorder] GraphQL errors:', json.errors);
                return products; // si falla algo en GraphQL, devolvemos todo por fallback
              }
              
              const nodes = (json && json.data && json.data.nodes) || [];
              
              const validIds = [];
              nodes.forEach(node => {
                if (!node || !node.variants || !node.variants.edges) return;
                
                let hasStock = false;
                let validVariantId = null;
                node.variants.edges.forEach(edge => {
                  const variantNode = edge.node;
                  if (!variantNode || !variantNode.metafield || !variantNode.metafield.value) return;
                  
                  try {
                    const stockData = JSON.parse(variantNode.metafield.value);
                    const storeEntry = stockData.find(entry => entry.store_code === storeCode);
                    // Validamos que haya entry para esta tienda y que la cantidad sea mayor que 0
                    if (storeEntry && parseFloat(storeEntry.quantity) > 0) {
                      hasStock = true;
                      if (!validVariantId) {
                        const vIdParts = variantNode.id.split('/');
                        validVariantId = parseInt(vIdParts[vIdParts.length - 1], 10);
                      }
                    }
                  } catch (e) {}
                });
                
                if (hasStock) {
                  const idParts = node.id.split('/');
                  const numericId = parseInt(idParts[idParts.length - 1], 10);
                  validIds.push({ productId: numericId, variantId: validVariantId });
                }
              });
              
              // Filtramos la lista original de productos dejando solo los que tienen al menos 1 variante con stock
              return products.reduce((acc, p) => {
                const match = validIds.find(v => v.productId === parseInt(p.id, 10));
                if (match) {
                  acc.push({ ...p, _validVariantId: match.variantId });
                }
                return acc;
              }, []);
            } catch (e) {
              console.warn('[wim-reorder] Error filtering by store code:', e);
              return products;
            }
          };
          
          // Algoritmo para obtener hasta 3 productos sustitutos o similares
          const fetchSimilarProducts = async (itemTitle, productId, productType = '', metafieldGrupo = '', metafieldSubcategoria = '') => {
            // Helper para limpiar el título y extraer palabras clave significativas
            let clean = itemTitle
            .replace(/\s*\(.*?\)/g, '')
            .replace(/\s*-\s*.*/g, '')
            .replace(/\b\d+(\.\d+)?\s*(g|gr|kg|l|ml|cl|u|unidades|piezas|g\.|kg\.|l\.)\b/gi, '')
            .replace(/\b\d+([.,]\d+)?°?\b/g, '')
            .trim();
            
            const words = clean.split(/\s+/).filter(w => w.length > 2);
            const lowerWords = words.map(w => w.toLowerCase());
            
            // Helper para verificar coherencia temática contra el producto original
            // Descarta recomendaciones no relacionadas de la IA (ej. limpiador para un tomate)
            const isRelevantProduct = (prod) => {
              if (!prod || !prod.title) return false;
              const pTitle = prod.title.toLowerCase();
              
              // Coincidencia con alguna palabra clave del título original
              if (lowerWords.some(w => pTitle.includes(w))) return true;
              
              // Coincidencia con la misma categoría o tipo de producto si existe
              if (productType && prod.type && prod.type.toLowerCase().trim() === productType.toLowerCase().trim()) {
                return true;
              }
              
              return false;
            };
            
            // 0. Si no tenemos productId (producto borrado/reimportado), intentamos resolverlo
            // buscando el producto actual por título para conectar con las reglas de S&D
            let resolvedProductId = productId;
            if (!resolvedProductId) {
              try {
                const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(itemTitle)}&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=show`);
                if (searchRes.ok) {
                  const searchData = await searchRes.json();
                  const prods = searchData.resources?.results?.products || [];
                  const exactMatch = prods.find(p =>
                    p.title.toLowerCase().trim() === itemTitle.toLowerCase().trim()
                  );
                  if (exactMatch && exactMatch.id) {
                    resolvedProductId = String(exactMatch.id);
                  }
                }
              } catch (e) {}
              
              if (resolvedProductId) {
                console.log('[wim-reorder] Producto resuelto por título:', itemTitle, '→ ID:', resolvedProductId);
              }
            }
            // 1. Intentar con Search & Discovery mediante la API de recomendaciones oficiales de Shopify
            if (resolvedProductId) {
              // Primero sin intent (devuelve mezcla manual+auto), luego intents específicos
              const intentsToTry = [null, 'related', 'complementary'];
              console.log('[wim-reorder] Consultando S&D para product_id:', resolvedProductId, '| Título:', itemTitle);
              
              for (const intent of intentsToTry) {
                try {
                  const intentParam = intent ? `&intent=${intent}` : '';
                  const recRes = await fetch(`/recommendations/products.json?product_id=${resolvedProductId}&limit=10${intentParam}`);
                  if (recRes.ok) {
                    const recData = await recRes.json();
                    if (recData.products && recData.products.length > 0) {
                      console.log(`[wim-reorder] S&D (${intent || 'sin-intent'}) devolvió ${recData.products.length} productos:`, recData.products.map(p => p.title));
                      const availableProds = recData.products.filter(p =>
                        p.available !== false &&
                        p.title.toLowerCase().trim() !== itemTitle.toLowerCase().trim()
                      );
                      console.log(`[wim-reorder] Tras filtro disponibilidad: ${availableProds.length} productos:`, availableProds.map(p => p.title));
                      
                      if (availableProds.length > 0) {
                        const filteredByStore = await filterProductsByStoreCode(availableProds);
                        console.log(`[wim-reorder] Tras filtro tienda: ${filteredByStore.length} productos:`, filteredByStore.map(p => p.title));
                        if (filteredByStore.length > 0) {
                          return filteredByStore.slice(0, 3);
                        }
                      }
                    }
                  }
                } catch (e) {
                  console.warn(`[wim-reorder] Recommendations fetch failed (intent=${intent}):`, e);
                }
              }
            }
            
            // Helper function for exact metafield search via GraphQL
            const fetchGraphQLByMetafield = async (namespace, key, value) => {
              if (!window.WimStorefrontToken || !window.WimShopDomain) return [];
              const query = `
                query getByMetafield($val: String!) {
                  search(
                    query: ""
                    productFilters: [{productMetafield: {namespace: "${namespace}", key: "${key}", value: $val}}]
                    first: 6
                  ) {
                    edges {
                      node {
                        ... on Product {
                          id
                          title
                          handle
                          availableForSale
                          featuredImage { url }
                          productType
                          variants(first: 1) {
                            edges {
                              node {
                                id
                                price { amount }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              `;
              try {
                const res = await fetch('https://' + window.WimShopDomain + '/api/2024-10/graphql.json', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': window.WimStorefrontToken
                  },
                  body: JSON.stringify({ query, variables: { val: value } })
                });
                const json = await res.json();
                if (json.data?.search?.edges) {
                  return json.data.search.edges.map(e => {
                    const node = e.node;
                    return {
                      id: parseInt(node.id.split('/').pop(), 10),
                      title: node.title,
                      type: node.productType,
                      handle: node.handle,
                      available: node.availableForSale,
                      image: node.featuredImage ? node.featuredImage.url : null,
                      url: '/products/' + node.handle,
                      price: node.variants.edges.length > 0 ? parseFloat(node.variants.edges[0].node.price.amount) : 0,
                      variants: node.variants.edges.map(ve => ({
                        id: parseInt(ve.node.id.split('/').pop(), 10)
                      }))
                    };
                  });
                }
              } catch (e) {
                console.error('[wim-reorder] GraphQL filter error', e);
              }
              return [];
            };
            
            // 2. Fallback 1: Búsqueda por product_type (máxima prioridad solicitada ahora)
            if (productType) {
              try {
                const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(productType)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
                if (searchRes.ok) {
                  const data = await searchRes.json();
                  const prods = data.resources?.results?.products || [];
                  const filtered = prods.filter(p => p.available !== false && p.title.toLowerCase().trim() !== itemTitle.toLowerCase().trim());
                  if (filtered.length > 0) {
                    const filteredByStore = await filterProductsByStoreCode(filtered);
                    if (filteredByStore.length > 0) return filteredByStore.slice(0, 3);
                  }
                }
              } catch (e) {}
            }
            
            // 3. Fallback 2: Búsqueda por Subcategoría
            if (metafieldSubcategoria) {
              try {
                const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(metafieldSubcategoria)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
                if (searchRes.ok) {
                  const data = await searchRes.json();
                  const prods = data.resources?.results?.products || [];
                  const filtered = prods.filter(p => p.available !== false && p.title.toLowerCase().trim() !== itemTitle.toLowerCase().trim());
                  if (filtered.length > 0) {
                    const filteredByStore = await filterProductsByStoreCode(filtered);
                    if (filteredByStore.length > 0) return filteredByStore.slice(0, 3);
                  }
                }
              } catch (e) {}
            }
            
            // 4. Fallback 3: Búsqueda por Grupo (dejado como último recurso)
            if (metafieldGrupo) {
              try {
                let prods = [];
                if (!metafieldGrupo.includes(' ')) {
                  prods = await fetchGraphQLByMetafield('dsp', 'group_code', metafieldGrupo);
                }
                
                if (prods.length === 0) {
                  const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(metafieldGrupo)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
                  if (searchRes.ok) {
                    const data = await searchRes.json();
                    prods = data.resources?.results?.products || [];
                  }
                }
                
                if (prods.length > 0) {
                  const filtered = prods.filter(p => p.available !== false && p.title.toLowerCase().trim() !== itemTitle.toLowerCase().trim());
                  if (filtered.length > 0) {
                    const filteredByStore = await filterProductsByStoreCode(filtered);
                    if (filteredByStore.length > 0) return filteredByStore.slice(0, 3);
                  }
                }
              } catch (e) {}
            }
            
            
            
            return [];
          };
          
          // Renderizar lista de productos
          const renderProductsList = (resultsContainer, products, isManualSearch = false, query = '') => {
            if (!resultsContainer) return;
            
            if (products.length === 0) {
              resultsContainer.innerHTML = `
                <div class="wim-reorder-rejected__empty">
                  <span>${isManualSearch ? `No se encontraron productos disponibles para "${query}".` : 'No se encontraron alternativas automáticas disponibles.'}</span>
                </div>
              `;
              return;
            }
            
            resultsContainer.innerHTML = products.slice(0, isManualSearch ? 6 : 3).map(prod => {
              const variantId = prod._validVariantId || prod.variants?.[0]?.id || prod.id;
              
              // Resolve image: Product Recommendations uses string in featured_image, Predictive Search uses string in image
              const pImg = prod.image || (typeof prod.featured_image === 'string' ? prod.featured_image : prod.featured_image?.url) || '';
              
              // Resolve price: Recommendations returns integer cents (1529), Predictive Search returns string ("15.29")
              let centsPrice = 0;
              if (typeof prod.price === 'number') {
                centsPrice = prod.price % 1 !== 0 ? Math.round(prod.price * 100) : prod.price; // if it's decimal like 15.29, convert to cents. If already 1529, keep it.
              } else if (typeof prod.price === 'string') {
                centsPrice = prod.price.includes('.') || prod.price.includes(',') 
                ? Math.round(parseFloat(prod.price.replace(',', '.')) * 100) 
                : parseInt(prod.price, 10);
              }
              const pPrice = centsPrice > 0 ? formatCurrency(centsPrice) : '';
              
              return `
                <div class="wim-reorder-rejected__suggest-card">
                  <div class="wim-reorder-rejected__suggest-media">
                    ${pImg ? `<img src="${pImg}" alt="${(prod.title || '').replace(/"/g, '&quot;')}" class="wim-reorder-rejected__suggest-img" loading="lazy">` : ''}
                  </div>
                  <div class="wim-reorder-rejected__suggest-info">
                    <a href="${prod.url}" target="_blank" class="wim-reorder-rejected__suggest-title" title="${(prod.title || '').replace(/"/g, '&quot;')}">${prod.title}</a>
                    ${pPrice ? `<span class="wim-reorder-rejected__suggest-price">${pPrice}</span>` : ''}
                  </div>
                  <button type="button" class="btn btn--primary wim-reorder-rejected__suggest-add js-add-substitute" data-variant-id="${variantId}">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    <span>Añadir</span>
                    <div class="loading__spinner hidden">
                      <svg class="spinner icon icon--small" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </button>
                </div>
              `;
            }).join('');
            
            // Evento añadir sustituto
            resultsContainer.querySelectorAll('.js-add-substitute').forEach(addBtn => {
              addBtn.addEventListener('click', async (e) => {
                const targetBtn = e.currentTarget;
                const vId = targetBtn.getAttribute('data-variant-id');
                if (!vId || targetBtn.disabled) return;
                
                targetBtn.disabled = true;
                targetBtn.classList.add('btn--loading');
                
                try {
                  const cartAddUrl = (window.FoxTheme?.routes?.cart_add_url || '/cart/add') + (window.FoxTheme?.routes?.cart_add_url?.endsWith('.js') ? '' : '.js');
                  const addRes = await fetch(cartAddUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ items: [{ id: parseInt(vId, 10), quantity: 1 }] })
                  });
                  
                  targetBtn.classList.remove('btn--loading');
                  
                  if (addRes.ok) {
                    targetBtn.classList.remove('btn--primary');
                    targetBtn.classList.add('wim-reorder-rejected__suggest-added');
                    targetBtn.innerHTML = `
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <span>Añadido</span>
                    `;
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    if (window.wimShowToast) {
                      window.wimShowToast('', 'Añadido', 'Producto sustituto añadido al carrito', false);
                    }
                  } else {
                    targetBtn.disabled = false;
                    targetBtn.innerHTML = '<span>Reintentar</span>';
                  }
                } catch (err) {
                  console.error('[wim-reorder] Error añadiendo sustituto:', err);
                  targetBtn.classList.remove('btn--loading');
                  targetBtn.disabled = false;
                  targetBtn.innerHTML = '<span>Reintentar</span>';
                }
              });
            });
          };
          
          // Toggle dropdown de sustitutos y carga inicial de 3 similares
          rejectedList.querySelectorAll('.wim-reorder-rejected__item').forEach(itemElem => {
            const toggleBtn = itemElem.querySelector('.js-toggle-replace');
            const dropdown = itemElem.querySelector('.wim-reorder-rejected__dropdown');
            const searchInput = itemElem.querySelector('.js-replace-search-input');
            const resultsContainer = itemElem.querySelector('.js-replace-results');
            const itemTitle = itemElem.getAttribute('data-title') || '';
            const productId = itemElem.getAttribute('data-product-id') || '';
            const productType = itemElem.getAttribute('data-product-type') || '';
            const metafieldGrupo = itemElem.getAttribute('data-metafield-grupo') || '';
            const metafieldSubcategoria = itemElem.getAttribute('data-metafield-subcategoria') || '';
            let isLoaded = false;
            
            if (toggleBtn && dropdown) {
              toggleBtn.addEventListener('click', async () => {
                const isOpen = !dropdown.classList.contains('hidden');
                dropdown.classList.toggle('hidden');
                toggleBtn.setAttribute('aria-expanded', (!isOpen).toString());
                toggleBtn.classList.toggle('is-active', !isOpen);
                
                if (!isOpen && !isLoaded) {
                  isLoaded = true;
                  const suggestions = await fetchSimilarProducts(itemTitle, productId, productType, metafieldGrupo, metafieldSubcategoria);
                  renderProductsList(resultsContainer, suggestions, false);
                }
              });
            }
            
            // Búsqueda manual por si el usuario decide buscar otro producto
            if (searchInput) {
              let debounceTimer;
              searchInput.addEventListener('input', (e) => {
                clearTimeout(debounceTimer);
                const val = e.target.value.trim();
                debounceTimer = setTimeout(async () => {
                  if (val.length > 1) {
                    resultsContainer.innerHTML = `
                      <div class="wim-reorder-rejected__loading">
                        <svg class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px;">
                          <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
                        </svg>
                        <span>Buscando "${val}"...</span>
                      </div>
                    `;
                    try {
                      const searchRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(val)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
                      if (searchRes.ok) {
                        const data = await searchRes.json();
                        const prods = data.resources?.results?.products || [];
                        const filteredByStore = await filterProductsByStoreCode(prods);
                        renderProductsList(resultsContainer, filteredByStore, true, val);
                      }
                    } catch (e) {
                      renderProductsList(resultsContainer, [], true, val);
                    }
                  } else if (val.length === 0) {
                    // Si limpia el buscador, volver a mostrar las 3 sugerencias iniciales
                    const suggestions = await fetchSimilarProducts(itemTitle, productId, productType, metafieldGrupo, metafieldSubcategoria);
                    renderProductsList(resultsContainer, suggestions, false);
                  }
                }, 300);
              });
            }
          });
        } else if (window.wimShowToast) {
          window.wimShowToast('', 'Atención', `${result.rejected.length} artículo(s) agotados o no disponibles.`, false);
        }
      }
      
      let cartJson = {};
      try {
        let cartUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_url) ? window.FoxTheme.routes.cart_url : '/cart';
        if (!cartUrl.endsWith('.js')) cartUrl += '.js';
        const cartRes = await fetch(cartUrl + '?t=' + Date.now(), { cache: 'no-store', headers: { 'Accept': 'application/json' } });
        cartJson = await cartRes.json();
        
        // Fetch HTML sections server-side to execute wim-price.liquid
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        const sectionsStr = sectionsToBundle.length ? sectionsToBundle.join(',') : 'cart-drawer,cart-icon-bubble';
        
        // Use /cart/update.js to safely fetch sections regardless of current page URL
        const rootUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) ? window.FoxTheme.routes.root_url : '/';
        let cartUpdateUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_update_url) ? window.FoxTheme.routes.cart_update_url : '/cart/update';
        if (!cartUpdateUrl.endsWith('.js')) cartUpdateUrl += '.js';
        const sectionsRes = await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: {}, sections: sectionsStr, sections_url: rootUrl })
        });
        
        if (sectionsRes.ok) {
          const updatedCart = await sectionsRes.json();
          cartJson.sections = updatedCart.sections;
        } else if (result.sections) {
          cartJson.sections = result.sections;
        }
      } catch (e) {
        console.error('[wim-reorder] Error sincronizando carrito', e);
      }
      
      // Cerramos el modal previo de confirmación justo antes de terminar o abrir el wizard
      const promptModal = document.getElementById('wim-reorder-prompt');
      if (promptModal) {
        if (typeof promptModal.hide === 'function') promptModal.hide();
        else {
          promptModal.removeAttribute('open');
          promptModal.setAttribute('hidden', '');
        }
        const promptConfirmBtn = promptModal.querySelector('.js-wim-reorder-prompt-confirm');
        if (promptConfirmBtn) {
          promptConfirmBtn.classList.remove('btn--loading');
          promptConfirmBtn.disabled = false;
        }
        const promptDirectBtn = promptModal.querySelector('.js-wim-reorder-prompt-direct');
        if (promptDirectBtn) {
          promptDirectBtn.classList.remove('btn--loading');
          promptDirectBtn.disabled = false;
        }
      }
      
      if (shouldOpenWizard) {
        // Abrimos el modal con wizard
        if (window.wimQuickBuyModal && typeof window.wimQuickBuyModal.openMultiple === 'function') {
          // Si añadimos direct items, emitimos un cartUpdate para que se refresque por detrás
          if (itemsToAddDirectly.length > 0) {
            if (window.FoxTheme && window.FoxTheme.pubsub) {
              window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson, source: 'reorder-direct' });
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
            if (window.wimShowToast) {
              window.wimShowToast(itemsToAddDirectly.length + ' producto(s) añadidos. Configurando el resto...');
            }
          }
          window.wimQuickBuyModal.openMultiple(configurableUrls);
        } else {
          console.error('[wim-reorder] wimQuickBuyModal.openMultiple no está disponible.');
        }
      } else {
        // Todo fue directo o el usuario no quiso wizard
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson, source: 'reorder-direct' });
        }
        
        // Evento oficial del tema para forzar refresco completo del cajón (sin abrirlo)
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        
        if (window.wimShowToast) {
          const successCount = itemsToAddDirectly.length - (result.rejected ? result.rejected.length : 0);
          if (successCount > 0 && successCount === itemsToAddDirectly.length) {
            window.wimShowToast(window.WIM_REORDER_STRINGS && window.WIM_REORDER_STRINGS.toast_all_added ? window.WIM_REORDER_STRINGS.toast_all_added : 'Todos los productos añadidos al carrito');
          } else if (successCount > 0) {
            const partialTxt = window.WIM_REORDER_STRINGS && window.WIM_REORDER_STRINGS.toast_some_added ? window.WIM_REORDER_STRINGS.toast_some_added.replace('[count]', successCount) : `${successCount} producto(s) añadidos al carrito`;
            window.wimShowToast(partialTxt);
          }
        }
      }
    });
  }
  
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:loaded', init);
  
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }
  
})();

// Toggle de contraseña (ver / ocultar)
document.addEventListener('click', function(e) {
  const toggleBtn = e.target.closest('.js-wim-password-toggle');
  if (toggleBtn) {
    const wrapper = toggleBtn.closest('.wim-password-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('input');
    const iconShow = toggleBtn.querySelector('.wim-password-toggle__icon-show');
    const iconHide = toggleBtn.querySelector('.wim-password-toggle__icon-hide');
    if (input && iconShow && iconHide) {
      if (input.type === 'password') {
        input.type = 'text';
        iconShow.setAttribute('hidden', '');
        iconHide.removeAttribute('hidden');
        toggleBtn.setAttribute('aria-label', 'Ocultar contraseña');
      } else {
        input.type = 'password';
        iconHide.setAttribute('hidden', '');
        iconShow.removeAttribute('hidden');
        toggleBtn.setAttribute('aria-label', 'Mostrar contraseña');
      }
    }
  }
});

// WIM Desistimiento Popup Logic
window.openDesistimientoPopup = function() {
  const popup = document.getElementById('WimDesistimientoPopup');
  if (popup) {
    // Lazy load the iframe
    const iframe = popup.querySelector('iframe[data-src]');
    if (iframe && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
    }

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
};

window.closeDesistimientoPopup = function() {
  const popup = document.getElementById('WimDesistimientoPopup');
  if (popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
};

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const popup = document.getElementById('WimDesistimientoPopup');
    if (popup && popup.classList.contains('is-open')) {
      window.closeDesistimientoPopup();
    }
  }
});